(function () {
  var legacyTeamsAliasTarget = 'https://www.nordbelt.nl/pages/nordbelt-voor-sportverenigingen-teams-gyms';

  function redirectLegacyTeamsAliases() {
    try {
      var location = window.location;
      if (!location) return;
      var hostname = (location.hostname || '').toLowerCase();
      if (hostname !== 'www.nordbelt.nl' && hostname !== 'nordbelt.nl') return;

      var path = (location.pathname || '').replace(/\/+$/, '');
      if (path !== '/pages/teams-clubs' && path !== '/pages/sportverenigingen-teams-gyms') return;

      var target = legacyTeamsAliasTarget + (location.search || '') + (location.hash || '');
      if (location.href !== target) location.replace(target);
    } catch (error) {
      // Keep business-page scripts non-blocking when a browser extension mutates location.
    }
  }

  redirectLegacyTeamsAliases();

  var quotePrefillConfig = {
    teams: {
      start: { label: 'Start', volume: '4 Nordbelts' },
      team: { label: 'Team', volume: '8 Nordbelts' },
      performance: { label: 'Performance', volume: '12 Nordbelts' },
      club: { label: 'Club', volume: '20 Nordbelts' },
      academy: { label: 'Academy', volume: '32+ Nordbelts' },
      '20plus': { label: 'Club 20+', volume: '20+ Nordbelts' }
    },
    practice: {
      start: { label: '1 kamer start', volume: '4 Nordbelts' },
      praktijk: { label: 'Team start', volume: '8 Nordbelts' },
      partner: { label: 'Praktijk + thuisvoorraad', volume: '12 Nordbelts' },
      'multi-locatie': { label: 'Multi-locatie / grotere voorraad', volume: '20+ Nordbelts' },
      netwerk: { label: 'Grotere uitrol', volume: '32+ Nordbelts' },
      '20plus': { label: '20+ Nordbelts', volume: '20+ Nordbelts' }
    }
  };

  function getRoot() {
    return document.querySelector('[data-business-pricing-root]');
  }

  function getDefaultAudience() {
    var root = getRoot();
    if (!root) return 'teams';
    return root.getAttribute('data-default-audience') || 'teams';
  }

  function getPageContext() {
    var root = getRoot();
    if (!root) return '';
    return root.getAttribute('data-page-context') || '';
  }

  function pushBusinessEvent(eventName, detail) {
    if (!window.NordbeltTheme || typeof window.NordbeltTheme.pushEvent !== 'function') return;
    window.NordbeltTheme.pushEvent(
      Object.assign(
        {
          event: eventName,
          business_page_context: getPageContext(),
          business_default_audience: getDefaultAudience()
        },
        detail || {}
      )
    );
  }

  function runBusinessIdleTask(callback) {
    if (typeof callback !== 'function') return;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1200 });
      return;
    }
    window.setTimeout(callback, 160);
  }

  function getPracticeB2BLocaleBase() {
    var path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
    var firstSegment = path.split('/').filter(Boolean)[0] || '';
    if (firstSegment.indexOf('-') > -1) return firstSegment.split('-')[0];
    if (/^(nl|en|de|fr|es|pt|it|fi|sv|da|nb|et)$/.test(firstSegment)) return firstSegment;
    return ((document.documentElement.getAttribute('lang') || 'en').toLowerCase().split('-')[0] || 'en');
  }

  function getPracticeB2BFromPrefix() {
    var locale = getPracticeB2BLocaleBase();
    if (locale === 'de') return 'ab ';
    if (locale === 'fr') return 'à partir de ';
    if (locale === 'es') return 'desde ';
    if (locale === 'pt') return 'a partir de ';
    if (locale === 'it') return 'da ';
    if (locale === 'fi') return 'alkaen ';
    if (locale === 'sv') return 'från ';
    if (locale === 'da') return 'fra ';
    if (locale === 'nb') return 'fra ';
    if (locale === 'et') return 'alates ';
    if (locale === 'nl') return 'vanaf ';
    return 'from ';
  }

  function getPracticeB2BTierLabel() {
    var locale = getPracticeB2BLocaleBase();
    if (locale === 'de') return 'Staffelpreis auf Anfrage';
    if (locale === 'fr') return 'tarif palier sur demande';
    if (locale === 'es') return 'precio por tramo bajo solicitud';
    if (locale === 'pt') return 'preço por escalão sob pedido';
    if (locale === 'it') return 'prezzo a scaglione su richiesta';
    if (locale === 'fi') return 'porrashinta pyynnöstä';
    if (locale === 'sv') return 'staffelpris på begäran';
    if (locale === 'da') return 'staffelpris på forespørgsel';
    if (locale === 'nb') return 'trinnpris på forespørsel';
    if (locale === 'et') return 'astmehind päringul';
    if (locale === 'nl') return 'staffel op aanvraag';
    return 'tier price on request';
  }

  function getPracticeB2BText(key) {
    var locale = getPracticeB2BLocaleBase();
    var copy = {
      et: {
        unavailable: '',
        currentNordbeltPrice: 'praegune Nordbelti hind',
        taxLabel: 'Arvel käibemaksu ei lisata',
        microcopy: 'Need on arvutusnäited. Kontrollige oma maksukäsitlust raamatupidajaga.',
        unknownPackageSize: 'paketi suurus päringul',
        patientPriceLower: 'patsiendihind',
        savingAriaPrefix: 'Paketisääst: Säästa ',
        savingPrefix: 'Säästa ',
        packagePrice: 'Paketihind',
        unitCost: 'Ostuhind ühiku kohta',
        marginPerUnit: 'Marginaal ühiku kohta',
        totalMargin: 'Kogumarginaal',
        packageFallback: 'Pakett',
        locationOne: '1 asukoht',
        locationTwo: '2 asukohta',
        locationThreePlus: '3+ asukohta',
        issueSell: 'Müük kodutreeningu komplektina',
        issueInclude: 'Raviteekonna osana kaasa andmine',
        issueLend: 'Ajutine laenukomplekt',
        issueMixed: 'Veel paindlik',
        issuePracticeOnly: 'Ainult kliinikus kasutamine',
        vatOn: 'jah',
        vatOff: 'ei'
      },
      nl: {
        unavailable: 'Actuele pakketprijs via Shopify-variant.',
        currentNordbeltPrice: 'actuele Nordbelt-prijs',
        taxLabel: 'btw-vrij geleverd via KOR',
        microcopy: 'Dit zijn rekenvoorbeelden. Controleer je eigen fiscale situatie met je boekhouder.',
        unknownPackageSize: 'pakketgrootte op aanvraag',
        patientPriceLower: 'patiëntprijs',
        savingAriaPrefix: 'Pakketbesparing: Bespaar ',
        savingPrefix: 'Bespaar ',
        packagePrice: 'Pakketprijs',
        unitCost: 'Inkoop per stuk',
        marginPerUnit: 'Marge per stuk',
        totalMargin: 'Totale marge',
        packageFallback: 'Pakket',
        locationOne: '1 locatie',
        locationTwo: '2 locaties',
        locationThreePlus: '3+ locaties',
        issueSell: 'Verkopen als thuispakket',
        issueInclude: 'Meegeven binnen traject',
        issueLend: 'Tijdelijk uitlenen',
        issueMixed: 'Nog flexibel',
        issuePracticeOnly: 'Alleen praktijkgebruik',
        vatOn: 'aan',
        vatOff: 'uit'
      },
      fr: {
        unavailable: 'Prix actuel du pack via la variante Shopify.',
        currentNordbeltPrice: 'prix Nordbelt actuel',
        taxLabel: 'pas de TVA facturée sur la facture',
        microcopy: 'Il s’agit d’exemples de calcul. Vérifiez votre propre situation fiscale avec votre comptable.',
        unknownPackageSize: 'taille du pack sur demande',
        patientPriceLower: 'prix patient',
        savingAriaPrefix: 'Économie pack : économisez ',
        savingPrefix: 'Économisez ',
        packagePrice: 'Prix du pack',
        unitCost: 'Prix d’achat unitaire',
        marginPerUnit: 'Marge par unité',
        totalMargin: 'Marge totale',
        packageFallback: 'Pack',
        locationOne: '1 site',
        locationTwo: '2 sites',
        locationThreePlus: '3+ sites',
        issueSell: 'Vendre comme kit à domicile',
        issueInclude: 'Remettre dans le parcours',
        issueLend: 'Prêter temporairement',
        issueMixed: 'Encore flexible',
        issuePracticeOnly: 'Usage cabinet uniquement',
        vatOn: 'oui',
        vatOff: 'non'
      },
      es: {
        unavailable: 'Precio actual del pack vía variante de Shopify.',
        currentNordbeltPrice: 'precio actual de Nordbelt',
        taxLabel: 'Sin IVA en la factura',
        microcopy: 'Son ejemplos de cálculo. Revisa tu situación fiscal con tu asesor.',
        unknownPackageSize: 'tamaño del pack bajo solicitud',
        patientPriceLower: 'precio paciente',
        savingAriaPrefix: 'Ahorro del pack: ahorra ',
        savingPrefix: 'Ahorra ',
        packagePrice: 'Precio del pack',
        unitCost: 'Precio de compra por unidad',
        marginPerUnit: 'Margen por unidad',
        totalMargin: 'Margen total',
        packageFallback: 'Pack',
        locationOne: '1 ubicación',
        locationTwo: '2 ubicaciones',
        locationThreePlus: '3+ ubicaciones',
        issueSell: 'Vender como kit para casa',
        issueInclude: 'Entregar dentro del proceso',
        issueLend: 'Prestar temporalmente',
        issueMixed: 'Aún flexible',
        issuePracticeOnly: 'Solo uso en clínica',
        vatOn: 'sí',
        vatOff: 'no'
      },
      it: {
        unavailable: 'Prezzo attuale del pacchetto tramite variante Shopify.',
        currentNordbeltPrice: 'prezzo Nordbelt attuale',
        taxLabel: 'Nessuna IVA addebitata in fattura',
        microcopy: 'Sono esempi di calcolo. Verifica la tua situazione fiscale con il commercialista.',
        unknownPackageSize: 'dimensione pacchetto su richiesta',
        patientPriceLower: 'prezzo paziente',
        savingAriaPrefix: 'Risparmio pacchetto: risparmia ',
        savingPrefix: 'Risparmia ',
        packagePrice: 'Prezzo pacchetto',
        unitCost: 'Prezzo d’acquisto unitario',
        marginPerUnit: 'Margine unitario',
        totalMargin: 'Margine totale',
        packageFallback: 'Pacchetto',
        locationOne: '1 sede',
        locationTwo: '2 sedi',
        locationThreePlus: '3+ sedi',
        issueSell: 'Vendere come kit per casa',
        issueInclude: 'Consegnare dentro il percorso',
        issueLend: 'Prestare temporaneamente',
        issueMixed: 'Ancora flessibile',
        issuePracticeOnly: 'Solo uso in studio',
        vatOn: 'sì',
        vatOff: 'no'
      },
      fi: {
        unavailable: 'Ajantasainen pakettihinta Shopify-variantista.',
        currentNordbeltPrice: 'nykyinen Nordbelt-hinta',
        taxLabel: 'Laskulla ei veloiteta arvonlisäveroa',
        microcopy: 'Nämä ovat laskentaesimerkkejä. Tarkista oma verotilanteesi kirjanpitäjältä.',
        unknownPackageSize: 'paketin koko pyynnöstä',
        patientPriceLower: 'potilashinta',
        savingAriaPrefix: 'Pakettisäästö: säästä ',
        savingPrefix: 'Säästä ',
        packagePrice: 'Paketin hinta',
        unitCost: 'Ostohinta per kappale',
        marginPerUnit: 'Marginaali per kappale',
        totalMargin: 'Kokonaismarginaali',
        packageFallback: 'Paketti',
        locationOne: '1 toimipiste',
        locationTwo: '2 toimipistettä',
        locationThreePlus: '3+ toimipistettä',
        issueSell: 'Myynti kotiharjoittelupakettina',
        issueInclude: 'Annetaan hoitopolun osana',
        issueLend: 'Väliaikainen lainasetti',
        issueMixed: 'Vielä joustava',
        issuePracticeOnly: 'Vain vastaanottokäyttö',
        vatOn: 'kyllä',
        vatOff: 'ei'
      },
      sv: {
        unavailable: 'Aktuellt paketpris via Shopify-variant.',
        currentNordbeltPrice: 'aktuellt Nordbelt-pris',
        taxLabel: 'Ingen moms debiteras på fakturan',
        microcopy: 'Detta är räkneexempel. Kontrollera er egen skattehantering med er redovisning.',
        unknownPackageSize: 'paketstorlek på begäran',
        patientPriceLower: 'patientpris',
        savingAriaPrefix: 'Paketbesparing: spara ',
        savingPrefix: 'Spara ',
        packagePrice: 'Paketpris',
        unitCost: 'Inköpspris per styck',
        marginPerUnit: 'Marginal per styck',
        totalMargin: 'Total marginal',
        packageFallback: 'Paket',
        locationOne: '1 mottagning',
        locationTwo: '2 mottagningar',
        locationThreePlus: '3+ mottagningar',
        issueSell: 'Sälj som hemträningskit',
        issueInclude: 'Ge inom behandlingsupplägget',
        issueLend: 'Tillfälligt låneset',
        issueMixed: 'Fortfarande flexibelt',
        issuePracticeOnly: 'Endast klinikanvändning',
        vatOn: 'ja',
        vatOff: 'nej'
      },
      da: {
        unavailable: 'Aktuel pakkepris via Shopify-variant.',
        currentNordbeltPrice: 'aktuel Nordbelt-pris',
        taxLabel: 'Ingen moms opkræves på fakturaen',
        microcopy: 'Dette er beregningseksempler. Afstem jeres egen skattehåndtering med bogholderiet.',
        unknownPackageSize: 'pakkestørrelse på forespørgsel',
        patientPriceLower: 'patientpris',
        savingAriaPrefix: 'Pakkebesparelse: spar ',
        savingPrefix: 'Spar ',
        packagePrice: 'Pakkepris',
        unitCost: 'Indkøbspris per stk.',
        marginPerUnit: 'Margin per stk.',
        totalMargin: 'Samlet margin',
        packageFallback: 'Pakke',
        locationOne: '1 lokation',
        locationTwo: '2 lokationer',
        locationThreePlus: '3+ lokationer',
        issueSell: 'Sælg som hjemmetræningskit',
        issueInclude: 'Giv med i behandlingsforløbet',
        issueLend: 'Midlertidigt lånesæt',
        issueMixed: 'Stadig fleksibelt',
        issuePracticeOnly: 'Kun klinikbrug',
        vatOn: 'ja',
        vatOff: 'nej'
      },
      nb: {
        unavailable: 'Aktuell pakkepris via Shopify-variant.',
        currentNordbeltPrice: 'aktuell Nordbelt-pris',
        taxLabel: 'Ingen mva. belastes på fakturaen',
        microcopy: 'Dette er regneeksempler. Avklar egen skattehåndtering med regnskapsfører.',
        unknownPackageSize: 'pakkestørrelse på forespørsel',
        patientPriceLower: 'pasientpris',
        savingAriaPrefix: 'Pakkebesparelse: spar ',
        savingPrefix: 'Spar ',
        packagePrice: 'Pakkepris',
        unitCost: 'Innkjøpspris per stk.',
        marginPerUnit: 'Margin per stk.',
        totalMargin: 'Samlet margin',
        packageFallback: 'Pakke',
        locationOne: '1 sted',
        locationTwo: '2 steder',
        locationThreePlus: '3+ steder',
        issueSell: 'Selg som hjemmetreningssett',
        issueInclude: 'Gi med i behandlingsforløpet',
        issueLend: 'Midlertidig lånesett',
        issueMixed: 'Fortsatt fleksibelt',
        issuePracticeOnly: 'Kun klinikkbruk',
        vatOn: 'ja',
        vatOff: 'nei'
      }
    };
    var selected = copy[locale] || copy.nl;
    return selected[key] || copy.nl[key] || '';
  }

  function normalizePracticeB2BSplitHeadings(scope) {
    if (!window.location || window.location.pathname.indexOf('/pages/fysiopraktijken') === -1) return;
    var root = scope && scope.querySelector ? scope : document;
    var locale = getPracticeB2BLocaleBase();
    var copy = {
      en: {
        plans: '<span class="nb-practice-title-line">Choose the package that fits</span><span class="nb-practice-title-line">your <span class="nb-title-accent nb-title-accent--sand">clinic rollout</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Compare</span><span> packages</span></span><span class="nb-practice-title-line">for physiotherapy clinics</span>'
      },
      de: {
        plans: '<span class="nb-practice-title-line">Wählen Sie das passende Paket</span><span class="nb-practice-title-line">für Ihren <span class="nb-title-accent nb-title-accent--sand">Praxis-Rollout</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Pakete</span><span> vergleichen</span></span><span class="nb-practice-title-line">für Physiotherapiepraxen</span>'
      },
      fr: {
        plans: '<span class="nb-practice-title-line">Choisissez le pack adapté</span><span class="nb-practice-title-line">à votre <span class="nb-title-accent nb-title-accent--sand">déploiement cabinet</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Comparer</span><span> les packs</span></span><span class="nb-practice-title-line">pour les cabinets de kinésithérapie</span>'
      },
      es: {
        plans: '<span class="nb-practice-title-line">Elige el pack adecuado</span><span class="nb-practice-title-line">para tu <span class="nb-title-accent nb-title-accent--sand">implantación en clínica</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Comparar</span><span> packs</span></span><span class="nb-practice-title-line">para clínicas de fisioterapia</span>'
      },
      pt: {
        plans: '<span class="nb-practice-title-line">Escolha o pack certo</span><span class="nb-practice-title-line">para a sua <span class="nb-title-accent nb-title-accent--sand">implementação na clínica</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Comparar</span><span> packs</span></span><span class="nb-practice-title-line">para clínicas de fisioterapia</span>'
      },
      it: {
        plans: '<span class="nb-practice-title-line">Scegli il pacchetto giusto</span><span class="nb-practice-title-line">per la tua <span class="nb-title-accent nb-title-accent--sand">implementazione in studio</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Confronta</span><span> i pacchetti</span></span><span class="nb-practice-title-line">per studi di fisioterapia</span>'
      },
      fi: {
        plans: '<span class="nb-practice-title-line">Valitse sopiva paketti</span><span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--sand">vastaanoton käyttöönottoon</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Vertaile</span><span> paketteja</span></span><span class="nb-practice-title-line">fysioterapiaklinikoille</span>'
      },
      sv: {
        plans: '<span class="nb-practice-title-line">Välj paketet som passar</span><span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--sand">klinikens införande</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Jämför</span><span> paket</span></span><span class="nb-practice-title-line">för fysioterapikliniker</span>'
      },
      da: {
        plans: '<span class="nb-practice-title-line">Vælg pakken der passer</span><span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--sand">klinikkens implementering</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Sammenlign</span><span> pakker</span></span><span class="nb-practice-title-line">for fysioterapiklinikker</span>'
      },
      nb: {
        plans: '<span class="nb-practice-title-line">Velg pakken som passer</span><span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--sand">klinikkens utrulling</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Sammenlign</span><span> pakker</span></span><span class="nb-practice-title-line">for fysioterapiklinikker</span>'
      },
      et: {
        plans: '<span class="nb-practice-title-line">Vali pakett, mis sobib</span><span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--sand">kliinikus kasutuselevõtuks</span></span>',
        compare: '<span class="nb-practice-title-line"><span class="nb-title-accent nb-title-accent--lilac">Võrdle</span><span> pakette</span></span><span class="nb-practice-title-line">füsioteraapiakliinikutele</span>'
      }
    }[locale];

    if (!copy) return;

    [
      { selector: '.nb-business-plan-grid-shell [data-nb-practice-heading="plans"], .nb-business-plan-grid-shell [data-business-audience-group="practices"] .nb-practice-two-line-title', html: copy.plans },
      { selector: '.nb-business-compare-shell [data-nb-practice-heading="compare"], .nb-business-compare-shell [data-business-audience-group="practices"] .nb-practice-two-line-title', html: copy.compare }
    ].forEach(function (item) {
      root.querySelectorAll(item.selector).forEach(function (heading) {
        if (!heading || heading.innerHTML === item.html) return;
        heading.innerHTML = item.html;
      });
    });
  }

  function normalizePracticeB2BHomekitVideoLabels(scope) {
    if (!window.location || window.location.pathname.indexOf('/pages/fysiopraktijken') === -1) return;
    var root = scope && scope.querySelector ? scope : document;
    var locale = getPracticeB2BLocaleBase();
    var copy = {
      nl: {
        packageLabel: 'Nordbelt Thuispakket',
        unboxingLabel: 'Unboxingvideo',
        unboxingCta: 'Bekijk unboxing',
        unboxingAria: 'Unboxingvideo van het Nordbelt Thuispakket',
        exampleLabel: 'Voorbeeld video',
        exampleCta: 'Bekijk voorbeeld video',
        exampleAria: 'Voorbeeld video voor het Nordbelt Thuispakket'
      },
      en: {
        packageLabel: 'Nordbelt home setup',
        unboxingLabel: 'Unboxing video',
        unboxingCta: 'Watch unboxing',
        unboxingAria: 'Unboxing video of the Nordbelt home setup',
        exampleLabel: 'Example video',
        exampleCta: 'Watch example video',
        exampleAria: 'Example video for the Nordbelt home setup'
      },
      de: {
        packageLabel: 'Nordbelt Heim-Setup',
        unboxingLabel: 'Unboxing-Video',
        unboxingCta: 'Unboxing ansehen',
        unboxingAria: 'Unboxing-Video des Nordbelt Heim-Setups',
        exampleLabel: 'Beispielvideo',
        exampleCta: 'Beispielvideo ansehen',
        exampleAria: 'Beispielvideo für das Nordbelt Heim-Setup'
      },
      fr: {
        packageLabel: 'Nordbelt setup domicile',
        unboxingLabel: 'Vidéo d’ouverture',
        unboxingCta: 'Voir l’ouverture',
        unboxingAria: 'Vidéo d’ouverture du Nordbelt setup domicile',
        exampleLabel: 'Vidéo d’exemple',
        exampleCta: 'Voir la vidéo d’exemple',
        exampleAria: 'Vidéo d’exemple du Nordbelt setup domicile'
      },
      es: {
        packageLabel: 'Nordbelt setup en casa',
        unboxingLabel: 'Vídeo de unboxing',
        unboxingCta: 'Ver unboxing',
        unboxingAria: 'Vídeo de unboxing del Nordbelt setup en casa',
        exampleLabel: 'Vídeo de ejemplo',
        exampleCta: 'Ver vídeo de ejemplo',
        exampleAria: 'Vídeo de ejemplo del Nordbelt setup en casa'
      },
      pt: {
        packageLabel: 'Nordbelt em casa',
        unboxingLabel: 'Vídeo de unboxing',
        unboxingCta: 'Ver unboxing',
        unboxingAria: 'Vídeo de unboxing da Nordbelt em casa',
        exampleLabel: 'Vídeo de exemplo',
        exampleCta: 'Ver vídeo de exemplo',
        exampleAria: 'Vídeo de exemplo da Nordbelt em casa'
      },
      it: {
        packageLabel: 'Nordbelt a casa',
        unboxingLabel: 'Video unboxing',
        unboxingCta: 'Guarda unboxing',
        unboxingAria: 'Video unboxing della Nordbelt a casa',
        exampleLabel: 'Video di esempio',
        exampleCta: 'Guarda video di esempio',
        exampleAria: 'Video di esempio della Nordbelt a casa'
      },
      fi: {
        packageLabel: 'Nordbelt kotona',
        unboxingLabel: 'Unboxing-video',
        unboxingCta: 'Katso unboxing',
        unboxingAria: 'Nordbeltin unboxing-video',
        exampleLabel: 'Esimerkkivideo',
        exampleCta: 'Katso esimerkkivideo',
        exampleAria: 'Esimerkkivideo Nordbeltin käytöstä kotona'
      },
      sv: {
        packageLabel: 'Nordbelt hemma',
        unboxingLabel: 'Unboxingvideo',
        unboxingCta: 'Se unboxing',
        unboxingAria: 'Unboxingvideo av Nordbelt hemma',
        exampleLabel: 'Exempelvideo',
        exampleCta: 'Se exempelvideo',
        exampleAria: 'Exempelvideo för Nordbelt hemma'
      },
      da: {
        packageLabel: 'Nordbelt derhjemme',
        unboxingLabel: 'Unboxingvideo',
        unboxingCta: 'Se unboxing',
        unboxingAria: 'Unboxingvideo af Nordbelt derhjemme',
        exampleLabel: 'Eksempelvideo',
        exampleCta: 'Se eksempelvideo',
        exampleAria: 'Eksempelvideo for Nordbelt derhjemme'
      },
      nb: {
        packageLabel: 'Nordbelt hjemme',
        unboxingLabel: 'Unboxingvideo',
        unboxingCta: 'Se unboxing',
        unboxingAria: 'Unboxingvideo av Nordbelt hjemme',
        exampleLabel: 'Eksempelvideo',
        exampleCta: 'Se eksempelvideo',
        exampleAria: 'Eksempelvideo for Nordbelt hjemme'
      },
      et: {
        packageLabel: 'Nordbelt kodus',
        unboxingLabel: 'Unboxing-video',
        unboxingCta: 'Vaata unboxingut',
        unboxingAria: 'Nordbelti koduse seadistuse unboxing-video',
        exampleLabel: 'Näidisvideo',
        exampleCta: 'Vaata näidisvideot',
        exampleAria: 'Nordbelti koduse seadistuse näidisvideo'
      }
    }[locale];

    if (!copy) return;

    function setButtonText(button, label) {
      if (!button || !label) return;
      var icon = button.querySelector('span[aria-hidden="true"]');
      button.textContent = '';
      if (icon) button.appendChild(icon);
      button.appendChild(document.createTextNode(' ' + label));
    }

    function setCard(card, label, cta, aria) {
      if (!card) return;
      var packageNode = card.querySelector('.practice-b2b-homekit__video-top span');
      var labelNode = card.querySelector('.practice-b2b-homekit__video-top strong');
      var button = card.querySelector('[data-practice-b2b-homekit-play]');
      var video = card.querySelector('[data-practice-b2b-homekit-video]');
      if (packageNode) packageNode.textContent = copy.packageLabel;
      if (labelNode) labelNode.textContent = label;
      setButtonText(button, cta);
      if (video && aria) video.setAttribute('aria-label', aria);
    }

    var cards = root.querySelectorAll('.practice-b2b-homekit__video-frame');
    setCard(cards[0], copy.unboxingLabel, copy.unboxingCta, copy.unboxingAria);
    setCard(cards[1], copy.exampleLabel, copy.exampleCta, copy.exampleAria);
  }

  function cleanPracticeB2BMarginLocaleCopy(scope) {
    if (!window.location || window.location.pathname.indexOf('/pages/fysiopraktijken') === -1) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var locale = getPracticeB2BLocaleBase();
    var replacements = [
      { pattern: /Marge volgt uit je actuele pakketprijs\./g, value: '' },
      { pattern: /Marge volgt zodra pakketprijs bekend is\./g, value: '' },
      { pattern: /Marge volgt uit je actuele staffelprijs\./g, value: '' },
      { pattern: /Margin follows from your current package price\./g, value: '' },
      { pattern: /Die Marge ergibt sich aus Ihrem aktuellen Paketpreis\./g, value: '' },
      { pattern: /La marge dépend du prix actuel de votre pack\./g, value: '' }
    ];

    if (locale === 'de') {
      replacements.push(
        { pattern: /Möglich margin when sold/g, value: 'Mögliche Marge beim Weiterverkauf' },
        { pattern: /Possible margin when sold/g, value: 'Mögliche Marge beim Weiterverkauf' },
        { pattern: /We use your details to create a suitable proposal for room sets, Patientenbestand and possible replenishment\./g, value: 'Wir nutzen Ihre Angaben, um ein passendes Angebot für Raumsets, Patientenbestand und mögliche Nachbestellung zu erstellen.' },
        { pattern: /We use your details to create a suitable proposal for room sets, patient stock and possible replenishment\./g, value: 'Wir nutzen Ihre Angaben, um ein passendes Angebot für Raumsets, Patientenbestand und mögliche Nachbestellung zu erstellen.' },
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Aktueller Paketpreis via Shopify-Variante.' },
        { pattern: /Choose 12er-Paket/g, value: '12er-Paket wählen' },
        { pattern: /Revenue with full Weiterverkauf/g, value: 'Umsatz bei vollständigem Weiterverkauf' },
        { pattern: /Current Patientenpreis/g, value: 'Aktueller Patientenpreis' },
        { pattern: /Margin estimate for Weiterverkauf/g, value: 'Margeneinschätzung für den Weiterverkauf' },
        { pattern: /Marge für Physiotherapiepraxen bij Weiterverkauf van Nordbelt praktijkPakete/g, value: 'Marge für Physiotherapiepraxen beim Weiterverkauf von Nordbelt Praxispaketen' },
        { pattern: /bij Weiterverkauf van Nordbelt praktijkPakete/g, value: 'beim Weiterverkauf von Nordbelt Praxispaketen' },
        { pattern: /Marge pro Stück when sold at the current Nordbelt price/g, value: 'Marge pro Nordbelt beim Weiterverkauf zum aktuellen Nordbelt-Preis' },
        { pattern: /Marge pro Stück when sold/g, value: 'Marge pro Nordbelt beim Weiterverkauf' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Marge pro Nordbelt beim Weiterverkauf' },
        { pattern: /Potential total margin/g, value: 'Mögliche Gesamtmarge' },
        { pattern: /from €/g, value: 'ab €' }
      );
    } else if (locale === 'fr') {
      replacements.push(
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Prix actuel du pack via la variante Shopify.' },
        { pattern: /Actuele patiëntprijs/g, value: 'Prix patient actuel' },
        { pattern: /actuele Nordbelt-prijs/g, value: 'prix Nordbelt actuel' },
        { pattern: /Marge par Nordbelt à la revente at the current Nordbelt price/g, value: 'Marge par Nordbelt à la revente au prix Nordbelt actuel' },
        { pattern: /Marge par unité when sold at the current Nordbelt price/g, value: 'Marge par Nordbelt à la revente au prix Nordbelt actuel' },
        { pattern: /Marge par unité when sold/g, value: 'Marge par Nordbelt à la revente' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Marge par Nordbelt à la revente' },
        { pattern: /Choose Pack 12/g, value: 'Choisir le pack 12' },
        { pattern: /meerdere sites/g, value: 'plusieurs sites' },
        { pattern: /Potential total margin/g, value: 'Marge totale potentielle' },
        { pattern: /from €/g, value: 'à partir de €' }
      );
    } else if (locale === 'es') {
      replacements.push(
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Precio actual del pack vía variante de Shopify.' },
        { pattern: /Actuele patiëntprijs/g, value: 'Precio actual para paciente' },
        { pattern: /actuele Nordbelt-prijs/g, value: 'precio actual de Nordbelt' },
        { pattern: /Base científica-based/g, value: 'Base científica' },
        { pattern: /training principle\. Made practical for clinic and home\./g, value: 'principio de entrenamiento, práctico en clínica y en casa.' },
        { pattern: /Possible margin when sold/g, value: 'Margen posible al revender' },
        { pattern: /Base científica-based training principle\. Made practical for clinic and home\./g, value: 'Principio de entrenamiento respaldado por evidencia. Hecho práctico para la clínica y casa.' },
        { pattern: /Made practical for clinic and home/g, value: 'Hecho práctico para la clínica y casa' },
        { pattern: /For larger clinics, sports medical centres, multiple ubicaciones or structural home-use kits\./g, value: 'Para clínicas grandes, centros de medicina deportiva, varias ubicaciones o kits para casa de uso estructural.' },
        { pattern: /Para clínicas de fisioterapia, centros de medicina deportiva y médicos deportivos that want to use Nordbelt per treatment room, therapist, location or patient (?:home-use kit|kit para casa)\./g, value: 'Para clínicas de fisioterapia, centros de medicina deportiva y médicos deportivos que quieren usar Nordbelt por sala de tratamiento, terapeuta, ubicación o kit de paciente para casa.' },
        { pattern: /Margin estimate for reventa/g, value: 'Estimación de margen para reventa' },
        { pattern: /Revenue with full reventa/g, value: 'Ingresos con reventa completa' },
        { pattern: /20\+ tier/g, value: 'tramo 20+' },
        { pattern: /Stock de clínica Start/g, value: 'Inicio de stock de clínica' },
        { pattern: /home-use kits/g, value: 'kits para casa' },
        { pattern: /home-use kit/g, value: 'kit para casa' },
        { pattern: /MARGEN POR NORDBELT AT THE CURRENT RETAIL PRICE/g, value: 'MARGEN POR NORDBELT AL REVENDER' },
        { pattern: /Margen por Nordbelt at the current retail price/g, value: 'Margen por Nordbelt al revender' },
        { pattern: /For larger stock or multiple ubicaciones/g, value: 'Para mayor stock o varias ubicaciones' },
        { pattern: /Remit VAT on reventa/g, value: 'Gestionar IVA en la reventa' },
        { pattern: /From the 12-pack, reventa becomes especially interesting: your margin per Nordbelt is higher because your purchase price per unit is lower\./g, value: 'A partir del pack 12, la reventa resulta especialmente interesante: tu margen por Nordbelt sube porque tu precio de compra por unidad baja.' },
        { pattern: /Marge para clínicas de fisioterapia bij reventa van Nordbelt praktijkpacks/g, value: 'Margen para clínicas de fisioterapia al revender packs Nordbelt' },
        { pattern: /PACKAGE/g, value: 'PACK' },
        { pattern: /Not included/g, value: 'No incluido' },
        { pattern: /Margins are calculation examples based on the current Nordbelt price\. Uso the margin block and package cards to include VAT handling in your decision\./g, value: 'Los márgenes son ejemplos de cálculo basados en el precio actual de Nordbelt. Usa el bloque de margen y las tarjetas de packs para incluir la gestión del IVA en tu decisión.' },
        { pattern: /Margins are calculation examples based on the current Nordbelt price\. Use the margin block and package cards to include VAT handling in your decision\./g, value: 'Los márgenes son ejemplos de cálculo basados en el precio actual de Nordbelt. Usa el bloque de margen y las tarjetas de packs para incluir la gestión del IVA en tu decisión.' },
        { pattern: /KIT PARA CASA CONTENTS/g, value: 'CONTENIDO DEL KIT PARA CASA' },
        { pattern: /Base científica-based training principle\. Hecho práctico para la clínica y casa\./g, value: 'Principio de entrenamiento respaldado por evidencia. Hecho práctico para la clínica y casa.' },
        { pattern: /What therapists see/g, value: 'Lo que ven los terapeutas' },
        { pattern: /in the clinic\./g, value: 'en la clínica.' },
        { pattern: /External reviews that help assess how Nordbelt fits treatment-room explanation, home continuation and fixed clinic stock\./g, value: 'Reseñas externas que ayudan a valorar cómo encaja Nordbelt en la explicación en consulta, la continuidad en casa y el stock fijo de clínica.' },
        { pattern: /Usor experiences\. Results differ per person and application\./g, value: 'Experiencias de usuarios. Los resultados varían según la persona y la aplicación.' },
        { pattern: /User experiences\. Results differ per person and application\./g, value: 'Experiencias de usuarios. Los resultados varían según la persona y la aplicación.' },
        { pattern: /The treating professional determines use, progression and load\./g, value: 'El profesional tratante determina el uso, la progresión y la carga.' },
        { pattern: /GOOGLE REVIEWS/g, value: 'RESEÑAS DE GOOGLE' },
        { pattern: /TRUSTPILOT REVIEWS/g, value: 'RESEÑAS DE TRUSTPILOT' },
        { pattern: /PHYSIO/g, value: 'FISIO' },
        { pattern: /A great solution for performing the Nordic Hamstring Curl properly and easily\. Usoful during my work as a physiotherapist and usable in different ubicaciones\./g, value: 'Una gran solución para realizar el Nordic Hamstring Curl de forma correcta y sencilla. Muy útil en mi trabajo como fisioterapeuta y utilizable en diferentes ubicaciones.' },
        { pattern: /A great solution for performing the Nordic Hamstring Curl properly and easily\. Useful during my work as a physiotherapist and usable in different locations\./g, value: 'Una gran solución para realizar el Nordic Hamstring Curl de forma correcta y sencilla. Muy útil en mi trabajo como fisioterapeuta y utilizable en diferentes ubicaciones.' },
        { pattern: /Google review · physiotherapy clinic/g, value: 'Reseña de Google · clínica de fisioterapia' },
        { pattern: /We use the NordBelt in our physiotherapy clinic and recommend it to anyone who wants to recover from a hamstring injury or optimise performance\./g, value: 'Usamos Nordbelt en nuestra clínica de fisioterapia y lo recomendamos a cualquiera que quiera recuperarse de una lesión de isquiotibiales u optimizar su rendimiento.' },
        { pattern: /A good tool for performing the effective Nordic Hamstring exercise at home; it works well for hamstring-injury recovery\. The included bag contains the exercise protocol and you can attach the Nordic belt in different ways, making training easy wherever you are\./g, value: 'Una buena herramienta para realizar en casa el eficaz ejercicio Nordic Hamstring; funciona bien en la recuperación de lesiones de isquiotibiales. La bolsa incluida contiene el protocolo de ejercicios y permite fijar Nordbelt de varias formas, facilitando el entrenamiento estés donde estés.' },
        { pattern: /Trustpilot · sports physio/g, value: 'Trustpilot · fisioterapia deportiva' },
        { pattern: /Show more reviews/g, value: 'Ver más reseñas' },
        { pattern: /View Trustpilot reviews/g, value: 'Ver reseñas de Trustpilot' },
        { pattern: /Become visible to clientes Nordbelt in your region\./g, value: 'Hazte visible para clientes Nordbelt de tu zona.' },
        { pattern: /For suitable home continuation, your clinic can add its instrucción propias, stamp, sticker or note with the product\./g, value: 'Para una continuidad en casa adecuada, tu clínica puede añadir sus propias instrucciones, sello, pegatina o nota junto al producto.' },
        { pattern: /Preguntas frecuentes from clinics/g, value: 'Preguntas frecuentes de clínicas' },
        { pattern: /from clinics/g, value: 'de clínicas' },
        { pattern: /How much margin do we make on reventa\?/g, value: '¿Qué margen obtenemos en la reventa?' },
        { pattern: /Which package is best for reventa\?/g, value: '¿Qué pack es mejor para reventa?' },
        { pattern: /Solicitar precio para clínicas for 20\+ Nordbelts/g, value: 'Solicitar precio para clínicas para 20+ Nordbelts' },
        { pattern: /Number of ubicaciones/g, value: 'Número de ubicaciones' },
        { pattern: /meerdere ubicaciones/g, value: 'varias ubicaciones' },
        { pattern: /We use your details to create a suitable proposal for room sets, stock de pacientes and possible replenishment\./g, value: 'Usamos tus datos para preparar una propuesta adecuada de sets de sala, stock de pacientes y posible reposición.' },
        { pattern: /Google reviews/g, value: 'Reseñas de Google' },
        { pattern: /Trustpilot reviews/g, value: 'Reseñas de Trustpilot' },
        { pattern: /Open Google reviews/g, value: 'Abrir reseñas de Google' },
        { pattern: /^Physio$/g, value: 'Fisio' },
        { pattern: /\bPackage\b/g, value: 'Pack' },
        { pattern: /A great solution for performing the Nordic Hamstring Curl properly and easily\. Useful during my work as a physiotherapist and usable in different ubicaciones\./g, value: 'Una gran solución para realizar el Nordic Hamstring Curl de forma correcta y sencilla. Muy útil en mi trabajo como fisioterapeuta y utilizable en diferentes ubicaciones.' },
        { pattern: /Margen por Nordbelt al revender at the current Nordbelt price/g, value: 'Margen por Nordbelt al revender al precio actual de Nordbelt' },
        { pattern: /Marge por Nordbelt when sold at the current Nordbelt price/g, value: 'Margen por Nordbelt al revender al precio actual de Nordbelt' },
        { pattern: /Marge por Nordbelt when sold/g, value: 'Margen por Nordbelt al revender' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Margen por Nordbelt al revender' },
        { pattern: /Potential total margin/g, value: 'Margen total potencial' },
        { pattern: /from €/g, value: 'desde €' }
      );
    } else if (locale === 'pt') {
      replacements.push(
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Preço atual do pack via variante Shopify.' },
        { pattern: /Evidência-based/g, value: 'Evidência' },
        { pattern: /training principle\. Made practical for clinic and home\./g, value: 'princípio de treino, prático na clínica e em casa.' },
        { pattern: /Possible margin when sold/g, value: 'Margem possível na revenda' },
        { pattern: /Revenue with full revenda/g, value: 'Receita com revenda completa' },
        { pattern: /Revenue with full resale/g, value: 'Receita com revenda completa' },
        { pattern: /Margin estimate for revenda/g, value: 'Estimativa de margem para revenda' },
        { pattern: /Margin estimate for resale/g, value: 'Estimativa de margem para revenda' },
        { pattern: /Marge para clínicas de fisioterapia bij revenda van Nordbelt praktijkpacks/g, value: 'Margem para clínicas de fisioterapia na revenda de packs Nordbelt' },
        { pattern: /For larger stock or multiple localizações/g, value: 'Para maior stock ou várias localizações' },
        { pattern: /For physiotherapy clinics, sports medical centres and sports physicians that want to use Nordbelt per treatment room, therapist, location or patient kit para casa\./g, value: 'Para clínicas de fisioterapia, centros de medicina desportiva e médicos do desporto que querem usar Nordbelt por sala de tratamento, terapeuta, localização ou kit de paciente para casa.' },
        { pattern: /For clinics that want to use Nordbelt structurally and keep stock to provide, lend or sell to patients immediately\./g, value: 'Para clínicas que querem usar Nordbelt de forma estrutural e manter stock para fornecer, emprestar ou vender imediatamente aos pacientes.' },
        { pattern: /Buy Nordbelt through practice pricing and sell the kit para casa to patients at the current Nordbelt price\. The larger the clinic stock, the lower your purchase price per unit and the higher your margin\./g, value: 'Compre Nordbelt com preço de clínica e venda o kit para casa aos pacientes ao preço Nordbelt atual. Quanto maior o stock da clínica, menor o preço de compra por unidade e maior a margem.' },
        { pattern: /From the 12-pack, revenda becomes especially interesting: your margin per Nordbelt is higher because your purchase price per unit is lower\./g, value: 'A partir do pack 12, a revenda torna-se especialmente interessante: a margem por Nordbelt é maior porque o preço de compra por unidade é mais baixo.' },
        { pattern: /Remit VAT on revenda/g, value: 'Liquidar IVA na revenda' },
        { pattern: /meerdere localizações/g, value: 'várias localizações' },
        { pattern: /PACKAGE/g, value: 'PACK' },
        { pattern: /Not included/g, value: 'Não incluído' },
        { pattern: /Margem por Nordbelt na revenda at the current Nordbelt price/g, value: 'Margem por Nordbelt na revenda ao preço atual da Nordbelt' },
        { pattern: /Marge por Nordbelt when sold at the current Nordbelt price/g, value: 'Margem por Nordbelt na revenda ao preço atual da Nordbelt' },
        { pattern: /Marge por Nordbelt when sold/g, value: 'Margem por Nordbelt na revenda' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Margem por Nordbelt na revenda' },
        { pattern: /Potential total margin/g, value: 'Margem total potencial' },
        { pattern: /from €/g, value: 'a partir de €' }
      );
    } else if (locale === 'it') {
      replacements.push(
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Prezzo attuale del pacchetto tramite variante Shopify.' },
        { pattern: /Evidenza-based/g, value: 'Evidenza' },
        { pattern: /training principle\. Made practical for clinic and home\./g, value: 'principio di allenamento, reso pratico in studio e a casa.' },
        { pattern: /Possible margin when sold/g, value: 'Margine possibile alla rivendita' },
        { pattern: /Marge voor fisioterapia studi bij rivendita van Nordbelt praktijkpacchetti/g, value: 'Margine per studi di fisioterapia sulla rivendita dei pacchetti Nordbelt' },
        { pattern: /Marge per studi di fisioterapia bij rivendita van Nordbelt praktijkpacchetti/g, value: 'Margine per studi di fisioterapia sulla rivendita dei pacchetti Nordbelt' },
        { pattern: /Marge per fisioterapia studi bij rivendita van Nordbelt praktijkpacchetti/g, value: 'Margine per studi di fisioterapia sulla rivendita dei pacchetti Nordbelt' },
        { pattern: /Margine per Nordbelt alla rivendita at the current Nordbelt price/g, value: 'Margine per Nordbelt alla rivendita al prezzo Nordbelt attuale' },
        { pattern: /Marge por Nordbelt when sold at the current Nordbelt price/g, value: 'Margine per Nordbelt alla rivendita al prezzo Nordbelt attuale' },
        { pattern: /Marge por Nordbelt when sold/g, value: 'Margine per Nordbelt alla rivendita' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Margine per Nordbelt alla rivendita' },
        { pattern: /Potential total margin/g, value: 'Margine totale potenziale' },
        { pattern: /Revenue with full rivendita/g, value: 'Ricavo con rivendita completa' },
        { pattern: /For larger stock or multiple sedi/g, value: 'Per scorte maggiori o più sedi' },
        { pattern: /Più scelto — Clinic \+ Home-Use Kits/g, value: 'Più scelto — Studio + kit per casa' },
        { pattern: /Piu scelto — Clinic \+ Home-Use Kits/g, value: 'Più scelto — Studio + kit per casa' },
        { pattern: /Most chosen — Clinic \+ Home-Use Kits/g, value: 'Più scelto — Studio + kit per casa' },
        { pattern: /Most chosen - Clinic \+ Home-Use Kits/g, value: 'Più scelto - Studio + kit per casa' },
        { pattern: /Clinic \+ Home-Use Kits/g, value: 'Studio + kit per casa' },
        { pattern: /PACKAGE/g, value: 'PACCHETTO' },
        { pattern: /Not included/g, value: 'Non incluso' },
        { pattern: /Margins are calculation examples based on the current Nordbelt price\. Uso the margin block and package cards to include VAT handling in your decision\./g, value: 'I margini sono esempi di calcolo basati sul prezzo Nordbelt attuale. Usa il blocco margine e le schede pacchetto per includere la gestione IVA nella decisione.' },
        { pattern: /Margins are calculation examples based on the current Nordbelt price\. Use the margin block and package cards to include VAT handling in your decision\./g, value: 'I margini sono esempi di calcolo basati sul prezzo Nordbelt attuale. Usa il blocco margine e le schede pacchetto per includere la gestione IVA nella decisione.' },
        { pattern: /Buy Nordbelt through practice pricing and sell the kit per casa to patients at the current Nordbelt price\. The larger the clinic stock, the lower your purchase price per unit and the higher your margin\./g, value: 'Acquista Nordbelt con prezzo studio e vendi il kit per casa ai pazienti al prezzo Nordbelt attuale. Più grande è la scorta dello studio, più basso è il prezzo d’acquisto per unità e più alto è il margine.' },
        { pattern: /From the 12-pack, rivendita becomes especially interesting: your margin per Nordbelt is higher because your purchase price per unit is lower\./g, value: 'Dal pack da 12, la rivendita diventa particolarmente interessante: il margine per Nordbelt aumenta perché il prezzo d’acquisto per unità è più basso.' },
        { pattern: /What therapists see in the clinic\./g, value: 'Cosa vedono i terapisti in studio.' },
        { pattern: /What therapists see/g, value: 'Cosa vedono i terapisti' },
        { pattern: /in the clinic\./g, value: 'in studio.' },
        { pattern: /External reviews that help assess how Nordbelt fits treatment-room explanation, home continuation and fixed clinic stock\./g, value: 'Recensioni esterne che aiutano a valutare come Nordbelt si inserisce nella spiegazione in studio, nella continuità a casa e nella scorta fissa dello studio.' },
        { pattern: /Usor experiences\. Results differ per person and application\./g, value: 'Esperienze degli utenti. I risultati variano per persona e applicazione.' },
        { pattern: /User experiences\. Results differ per person and application\./g, value: 'Esperienze degli utenti. I risultati variano per persona e applicazione.' },
        { pattern: /The treating professional determines use, progression and load\./g, value: 'Il professionista curante determina uso, progressione e carico.' },
        { pattern: /from €/g, value: 'da €' }
      );
    } else if (locale === 'fi') {
      replacements.push(
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Ajantasainen pakettihinta Shopify-variantista.' },
        { pattern: /Näyttö-based/g, value: 'Näyttöön perustuva' },
        { pattern: /training principle\. Made practical for clinic and home\./g, value: 'harjoitusperiaate, käytännöllinen klinikalla ja kotona.' },
        { pattern: /Possible margin when sold/g, value: 'Mahdollinen marginaali myytäessä' },
        { pattern: /Actuele patiëntprijs/g, value: 'Nykyinen potilashinta' },
        { pattern: /actuele Nordbelt-prijs/g, value: 'nykyinen Nordbelt-hinta' },
        { pattern: /Most chosen — Clinic \+ Home-Use Kits/g, value: 'Suosituin - klinikka + kotiharjoittelupaketit' },
        { pattern: /Most chosen - Clinic \+ Home-Use Kits/g, value: 'Suosituin - klinikka + kotiharjoittelupaketit' },
        { pattern: /Clinic \+ Home-Use Kits/g, value: 'Klinikka + kotiharjoittelupaketit' },
        { pattern: /Revenue with full jälleenmyynnissä/g, value: 'Liikevaihto täydellä jälleenmyynnillä' },
        { pattern: /Revenue with full resale/g, value: 'Liikevaihto täydellä jälleenmyynnillä' },
        { pattern: /Margin estimate for jälleenmyynnissä/g, value: 'Marginaaliarvio jälleenmyyntiin' },
        { pattern: /Margin estimate for resale/g, value: 'Marginaaliarvio jälleenmyyntiin' },
        { pattern: /meerdere toimipistettä/g, value: 'useita toimipisteitä' },
        { pattern: /Buy Nordbelt through practice pricing and sell the kotiharjoittelupaketti to patients at the current Nordbelt price\. The larger the clinic stock, the lower your purchase price per unit and the higher your margin\./g, value: 'Osta Nordbelt klinikkahinnoittelulla ja myy kotiharjoittelupaketti potilaille nykyisellä Nordbelt-hinnalla. Mitä suurempi klinikkavarasto on, sitä alempi ostohinta per kappale ja sitä parempi marginaali.' },
        { pattern: /For larger stock or multiple toimipistettä/g, value: 'Suuremmalle varastolle tai useille toimipisteille' },
        { pattern: /PACKAGE/g, value: 'PAKETTI' },
        { pattern: /Not included/g, value: 'Ei sisälly' },
        { pattern: /Margins are calculation examples based on the current Nordbelt price\. Use the margin block and package cards to include VAT handling in your decision\./g, value: 'Marginaalit ovat laskentaesimerkkejä nykyisen Nordbelt-hinnan perusteella. Huomioi arvonlisäveron käsittely marginaaliosion ja pakettikorttien avulla.' },
        { pattern: /What therapists see in the clinic\./g, value: 'Mitä terapeutit näkevät vastaanotolla.' },
        { pattern: /What therapists see/g, value: 'Mitä terapeutit näkevät' },
        { pattern: /in the clinic\./g, value: 'vastaanotolla.' },
        { pattern: /External reviews that help assess how Nordbelt fits treatment-room explanation, home continuation and fixed clinic stock\./g, value: 'Ulkoiset arvostelut auttavat arvioimaan, miten Nordbelt sopii hoitohuoneen ohjeistukseen, kotijatkumoon ja klinikan kiinteään varastoon.' },
        { pattern: /Usor experiences\. Results differ per person and application\./g, value: 'Käyttäjäkokemuksia. Tulokset vaihtelevat henkilön ja käyttötavan mukaan.' },
        { pattern: /User experiences\. Results differ per person and application\./g, value: 'Käyttäjäkokemuksia. Tulokset vaihtelevat henkilön ja käyttötavan mukaan.' },
        { pattern: /The treating professional determines use, progression and load\./g, value: 'Hoitava ammattilainen määrittää käytön, progression ja kuormituksen.' },
        { pattern: /We use your details to create a suitable proposal for room sets, potilasvarasto and possible replenishment\./g, value: 'Käytämme tietojasi sopivan ehdotuksen laatimiseen hoitohuoneseteistä, potilasvarastosta ja mahdollisesta täydennyksestä.' },
        { pattern: /Physioterapiaklinikoiden/g, value: 'Fysioterapiaklinikoiden' },
        { pattern: /Physiotherapy clinics/g, value: 'Fysioterapiaklinikat' },
        { pattern: /PHYSIOTHERAPY CLINICS/g, value: 'FYSIOTERAPIAKLINIKAT' },
        { pattern: /PHYSIOTERAPIAKLINIKAT/g, value: 'FYSIOTERAPIAKLINIKAT' },
        { pattern: /Physio clinics/g, value: 'Fysioklinikat' },
        { pattern: /Physio/g, value: 'Fysio' },
        { pattern: /PHYSIO/g, value: 'FYSIO' },
        { pattern: /Pyydä klinikkahinta for 20\+ Nordbelts/g, value: 'Pyydä klinikkahinta 20+ Nordbeltille' },
        { pattern: /Pyydä klinikkahinta for /g, value: 'Pyydä klinikkahinta ' },
        { pattern: /20\+ Nordbelts/g, value: '20+ Nordbeltiä' },
        { pattern: /Fysioterapiaklinikoille, urheilulääketieteen keskuksille ja urheilulääkäreille that want to use Nordbelt per treatment room, therapist, location or patient kotiharjoittelupaketti\./g, value: 'Fysioterapiaklinikoille, urheilulääketieteen keskuksille ja urheilulääkäreille, jotka haluavat käyttää Nordbeltia hoitohuoneittain, terapeuteittain, toimipisteittäin tai potilaan kotiharjoittelupakettina.' },
        { pattern: /From the 12-pack, jälleenmyynnissä becomes especially interesting: your margin per Nordbelt is higher because your purchase price per unit is lower\./g, value: '12-packista alkaen jälleenmyynti on erityisen kiinnostavaa: marginaali per Nordbelt on suurempi, koska ostohinta per kappale on alempi.' },
        { pattern: /From the 12-pack, resale becomes especially interesting: your margin per Nordbelt is higher because your purchase price per unit is lower\./g, value: '12-packista alkaen jälleenmyynti on erityisen kiinnostavaa: marginaali per Nordbelt on suurempi, koska ostohinta per kappale on alempi.' },
        { pattern: /Marge fysioterapiaklinikoille bij jälleenmyynnissä van Nordbelt praktijkpaketteja/g, value: 'Marginaali fysioterapiaklinikoille Nordbelt-klinikkapakettien jälleenmyynnissä' },
        { pattern: /Marge fysioterapiaklinikoille bij resale van Nordbelt praktijkpaketteja/g, value: 'Marginaali fysioterapiaklinikoille Nordbelt-klinikkapakettien jälleenmyynnissä' },
        { pattern: /Marginaali per Nordbelt at the current retail price/g, value: 'Marginaali per Nordbelt nykyisellä Nordbelt-hinnalla' },
        { pattern: /MARGINAALI PER NORDBELT AT THE CURRENT RETAIL PRICE/g, value: 'MARGINAALI PER NORDBELT NYKYISELLÄ NORDBELT-HINNALLA' },
        { pattern: /^Package$/g, value: 'Paketti' },
        { pattern: /Meest gekozen/g, value: 'Suosituin' },
        { pattern: /Most chosen — Clinic \+ Home-Käyttö Kits/g, value: 'Suosituin - klinikka + kotiharjoittelupaketit' },
        { pattern: /MOST CHOSEN/g, value: 'SUOSITUIN' },
        { pattern: /Most chosen/g, value: 'Suosituin' },
        { pattern: /Google reviews/g, value: 'Google-arvostelut' },
        { pattern: /GOOGLE REVIEWS/g, value: 'GOOGLE-ARVOSTELUT' },
        { pattern: /Trustpilot reviews/g, value: 'Trustpilot-arvostelut' },
        { pattern: /TRUSTPILOT REVIEWS/g, value: 'TRUSTPILOT-ARVOSTELUT' },
        { pattern: /Google review · physiotherapy clinic/g, value: 'Google-arvostelu · fysioterapiaklinikka' },
        { pattern: /Google review · fysio praktijk/g, value: 'Google-arvostelu · fysioterapiaklinikka' },
        { pattern: /Trustpilot · sports physio/g, value: 'Trustpilot · urheilufysioterapia' },
        { pattern: /Show more reviews/g, value: 'Näytä lisää arvosteluja' },
        { pattern: /Laat meer reviews zien/g, value: 'Näytä lisää arvosteluja' },
        { pattern: /View Trustpilot reviews/g, value: 'Katso Trustpilot-arvostelut' },
        { pattern: /Bekijk Trustpilot reviews/g, value: 'Katso Trustpilot-arvostelut' },
        { pattern: /Open Google reviews/g, value: 'Avaa Google-arvostelut' },
        { pattern: /A great solution for performing the Nordic Hamstring Curl properly and easily\. Useful during my work as a physiotherapist and usable in different locations\./g, value: 'Erinomainen ratkaisu Nordic Hamstring Curlin tekemiseen oikein ja helposti. Hyödyllinen työssäni fysioterapeuttina ja käytettävissä eri paikoissa.' },
        { pattern: /A great solution for performing the Nordic Hamstring Curl properly and easily\. Useful during my work as a physiotherapist and usable in different toimipistettä\./g, value: 'Erinomainen ratkaisu Nordic Hamstring Curlin tekemiseen oikein ja helposti. Hyödyllinen työssäni fysioterapeuttina ja käytettävissä eri paikoissa.' },
        { pattern: /We use the NordBelt in our physiotherapy clinic and recommend it to anyone who wants to recover from a hamstring injury or optimise performance\./g, value: 'Käytämme Nordbeltia fysioterapiaklinikallamme ja suosittelemme sitä kaikille, jotka haluavat palautua takareisivammasta tai optimoida suorituskykyä.' },
        { pattern: /A good tool for performing the effective Nordic Hamstring exercise at home; it works well for hamstring-injury recovery\. The included bag contains the exercise protocol and you can attach the Nordic belt in different ways, making training easy wherever you are\./g, value: 'Hyvä väline tehokkaan Nordic Hamstring -harjoituksen tekemiseen kotona. Se toimii hyvin takareisivamman kuntoutuksessa. Mukana oleva laukku sisältää harjoitusprotokollan, ja Nordbeltin voi kiinnittää usealla tavalla, joten harjoittelu on helppoa missä tahansa.' },
        { pattern: /^Use$/g, value: 'Käyttö' },
        { pattern: /Marge pro Stück when sold at the current Nordbelt price/g, value: 'Marginaali per Nordbelt nykyisellä Nordbelt-hinnalla' },
        { pattern: /Marge pro Stück when sold/g, value: 'Marginaali per Nordbelt jälleenmyynnissä' },
        { pattern: /Marge por Nordbelt when sold at the current Nordbelt price/g, value: 'Marginaali per Nordbelt nykyisellä Nordbelt-hinnalla' },
        { pattern: /Marge por Nordbelt when sold/g, value: 'Marginaali per Nordbelt jälleenmyynnissä' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Marginaali per Nordbelt nykyisellä Nordbelt-hinnalla' },
        { pattern: /Potential total margin/g, value: 'Mahdollinen kokonaismarginaali' },
        { pattern: /from €/g, value: 'alkaen €' }
      );
    } else if (locale === 'sv') {
      replacements.push(
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Aktuellt paketpris via Shopify-variant.' },
        { pattern: /Actuele patiëntprijs/g, value: 'Aktuellt patientpris' },
        { pattern: /actuele Nordbelt-prijs/g, value: 'aktuellt Nordbelt-pris' },
        { pattern: /Most chosen — Clinic \+ Home-Use Kits/g, value: 'Mest valt - klinik + hemträningskit' },
        { pattern: /Most chosen - Clinic \+ Home-Use Kits/g, value: 'Mest valt - klinik + hemträningskit' },
        { pattern: /Most chosen for clinic \+ home stock/g, value: 'Mest valt för kliniklager och hemträning' },
        { pattern: /Most chosen/g, value: 'Mest valt' },
        { pattern: /Clinic \+ Home-Use Kits/g, value: 'Klinik + hemträningskit' },
        { pattern: /Revenue with full återförsäljning/g, value: 'Intäkt vid full återförsäljning' },
        { pattern: /Revenue with full resale/g, value: 'Intäkt vid full återförsäljning' },
        { pattern: /For larger stock or multiple mottagningar/g, value: 'För större lager eller flera mottagningar' },
        { pattern: /For larger stock or multiple locations/g, value: 'För större lager eller flera mottagningar' },
        { pattern: /Marge för fysioterapikliniker bij återförsäljning van Nordbelt praktijkpaket/g, value: 'Marginal för fysioterapikliniker vid återförsäljning av Nordbelt-paket' },
        { pattern: /återförsäljning becomes especially interesting: your margin per Nordbelt is higher because your purchase price per unit is lower\./g, value: 'återförsäljning extra intressant: din marginal per Nordbelt blir högre eftersom inköpspriset per enhet är lägre.' },
        { pattern: /Margin estimate for återförsäljning/g, value: 'Marginalestimat för återförsäljning' },
        { pattern: /Marginal indication/g, value: 'Marginalindikation' },
        { pattern: /Quantity/g, value: 'Antal' },
        { pattern: /Inköpspris per unit/g, value: 'Inköpspris per enhet' },
        { pattern: /Patient price/g, value: 'Patientpris' },
        { pattern: /Marginal per unit/g, value: 'Marginal per enhet' },
        { pattern: /QUANTITY/g, value: 'ANTAL' },
        { pattern: /INKÖPSPRIS PER UNIT/g, value: 'INKÖPSPRIS PER ENHET' },
        { pattern: /PATIENT PRICE/g, value: 'PATIENTPRIS' },
        { pattern: /12-PACK EXAMPLE/g, value: 'EXEMPEL PACK 12' },
        { pattern: /Potential margin/g, value: 'Möjlig marginal' },
        { pattern: /MARGINAL INDICATION/g, value: 'MARGINALINDIKATION' },
        { pattern: /MARGINAL PER UNIT/g, value: 'MARGINAL PER ENHET' },
        { pattern: /Use fasta set/g, value: 'Använd fasta set' },
        { pattern: /meerdere mottagningar/g, value: 'flera mottagningar' },
        { pattern: /from ([0-9])/g, value: 'från $1' },
        { pattern: /PACKAGE/g, value: 'PAKET' },
        { pattern: /^Package$/g, value: 'Paket' },
        { pattern: /Not included/g, value: 'Ingår inte' },
        { pattern: /Included/g, value: 'Ingår' },
        { pattern: /Buy Nordbelt through practice pricing and sell the hemträningskit to patients at the current Nordbelt price\. The larger the clinic stock, the lower your purchase price per unit and the higher your margin\./g, value: 'Köp Nordbelt via klinikpris och sälj hemträningskitet till patienter till aktuellt Nordbelt-pris. Ju större kliniklager, desto lägre inköpspris per enhet och desto högre marginal.' },
        { pattern: /Margins are calculation examples based on the current Nordbelt price\. Use the margin block and package cards to include VAT handling in your decision\./g, value: 'Marginalerna är räkneexempel baserade på aktuellt Nordbelt-pris. Använd marginalblocket och paketkorten för att ta med momshantering i beslutet.' },
        { pattern: /Evidence-based training principle\. Made practical for clinic and home\./g, value: 'Evidensbaserad träningsprincip. Gjord praktisk för klinik och hem.' },
        { pattern: /Evidence-based training principle\. Gjord praktisk för klinik och hem\./g, value: 'Evidensbaserad träningsprincip. Gjord praktisk för klinik och hem.' },
        { pattern: /Evidence-based training principle/g, value: 'Evidensbaserad träningsprincip' },
        { pattern: /EVIDENCE/g, value: 'EVIDENS' },
        { pattern: /Evidence/g, value: 'Evidens' },
        { pattern: /Evidens-based/g, value: 'Evidensbaserad' },
        { pattern: /training principle\. Gjord/g, value: 'träningsprincip. Gjord' },
        { pattern: /Made practical for clinic and home/g, value: 'Gjord praktisk för klinik och hem' },
        { pattern: /The Nordic Hamstring Exercise is a widely studied training principle in hamstring injury prevention programmes\. In a systematic review and meta-analysis, programmes that included the Nordic Hamstring Exercise reported up to 51% fewer hamstring injuries\. Nordbelt makes this exercise practical without a partner or large machine, so you can use the same setup in the treatment room and at home\./g, value: 'Nordic Hamstring Exercise är en välstuderad träningsprincip i program för att förebygga hamstringsskador. I en systematisk översikt och metaanalys rapporterade program med Nordic Hamstring Exercise upp till 51 % färre hamstringsskador. Nordbelt gör övningen praktisk utan partner eller stor maskin, så att samma setup kan användas i behandlingsrummet och hemma.' },
        { pattern: /Open: view protocol, clinic quotes and source detail/g, value: 'Öppna: se protokoll, klinikcitat och källdetaljer' },
        { pattern: /What therapists see in the clinic\./g, value: 'Det terapeuter ser på kliniken.' },
        { pattern: /What therapists see/g, value: 'Det terapeuter ser' },
        { pattern: /Det terapeuter ser in the clinic\./g, value: 'Det terapeuter ser på kliniken.' },
        { pattern: /in the clinic\./g, value: 'på kliniken.' },
        { pattern: /External reviews that help assess how Nordbelt fits treatment-room explanation, home continuation and fixed clinic stock\./g, value: 'Externa recensioner som hjälper till att bedöma hur Nordbelt passar instruktion i behandlingsrummet, hemuppföljning och fast kliniklager.' },
        { pattern: /External reviews/g, value: 'Externa recensioner' },
        { pattern: /User experiences\. Results differ per person and application\./g, value: 'Användarerfarenheter. Resultat varierar per person och användning.' },
        { pattern: /The treating professional determines use, progression and load\./g, value: 'Behandlaren avgör användning, progression och belastning.' },
        { pattern: /GOOGLE REVIEWS/g, value: 'GOOGLE-RECENSIONER' },
        { pattern: /TRUSTPILOT REVIEWS/g, value: 'TRUSTPILOT-RECENSIONER' },
        { pattern: /Google reviews/g, value: 'Google-recensioner' },
        { pattern: /Trustpilot reviews/g, value: 'Trustpilot-recensioner' },
        { pattern: /Google review · physiotherapy clinic/g, value: 'Google-recension · fysioterapiklinik' },
        { pattern: /Trustpilot · sports physio/g, value: 'Trustpilot · idrottsfysio' },
        { pattern: /Show more reviews/g, value: 'Visa fler recensioner' },
        { pattern: /View Trustpilot reviews/g, value: 'Se Trustpilot-recensioner' },
        { pattern: /View Trustpilot-recensioner/g, value: 'Se Trustpilot-recensioner' },
        { pattern: /View 12-pack/g, value: 'Se 12-pack' },
        { pattern: /Request practice pricing/g, value: 'Begär klinikpris' },
        { pattern: /Open Google reviews/g, value: 'Öppna Google-recensioner' },
        { pattern: /PHYSIOTHERAPY CLINICS/g, value: 'FYSIOTERAPIKLINIKER' },
        { pattern: /PHYSIOTERAPIKLINIKER/g, value: 'FYSIOTERAPIKLINIKER' },
        { pattern: /Physioterapikliniker/g, value: 'Fysioterapikliniker' },
        { pattern: /Physiotherapy clinics/g, value: 'Fysioterapikliniker' },
        { pattern: /Physio clinics/g, value: 'Fysiokliniker' },
        { pattern: /^Physio$/g, value: 'Fysio' },
        { pattern: /PHYSIO/g, value: 'FYSIO' },
        { pattern: /A great solution for performing the Nordic Hamstring Curl properly and easily\. Useful during my work as a physiotherapist and usable in different locations\./g, value: 'En mycket bra lösning för att utföra Nordic Hamstring Curl korrekt och enkelt. Användbar i mitt arbete som fysioterapeut och på olika platser.' },
        { pattern: /A great solution for performing the Nordic Hamstring Curl properly and easily\. Useful during my work as a physiotherapist and usable in different mottagningar\./g, value: 'En mycket bra lösning för att utföra Nordic Hamstring Curl korrekt och enkelt. Användbar i mitt arbete som fysioterapeut och på olika mottagningar.' },
        { pattern: /We use the NordBelt in our physiotherapy clinic and recommend it to anyone who wants to recover from a hamstring injury or optimise performance\./g, value: 'Vi använder Nordbelt i vår fysioterapiklinik och rekommenderar den till alla som vill återhämta sig från en hamstringsskada eller optimera prestationen.' },
        { pattern: /A good tool for performing the effective Nordic Hamstring exercise at home; it works well for hamstring-injury recovery\. The included bag contains the exercise protocol and you can attach the Nordic belt in different ways, making training easy wherever you are\./g, value: 'Ett bra verktyg för att utföra den effektiva Nordic Hamstring-övningen hemma. Det fungerar bra vid återhämtning efter hamstringsskada. Den medföljande väskan innehåller träningsprotokollet och Nordbelt kan fästas på flera sätt, vilket gör träningen enkel var du än är.' },
        { pattern: /Guide the first repetitions and match technique, dosage and progression to the patient's capacity\. This makes the home programme concrete before you provide a hemträningskit or loan set\./g, value: 'Handleda de första repetitionerna och anpassa teknik, dosering och progression till patientens kapacitet. Då blir hemprogrammet konkret innan du lämnar ut ett hemträningskit eller låneset.' },
        { pattern: /For suitable home continuation, your clinic can add its egen instruktions, stamp, sticker or note with the product\./g, value: 'Vid passande hemuppföljning kan din klinik lägga till egna instruktioner, stämpel, etikett eller notering med produkten.' },
        { pattern: /För fysioterapikliniker, idrottsmedicinska center och idrottsläkare that want to use Nordbelt per treatment room, therapist, location or patient hemträningskit\./g, value: 'För fysioterapikliniker, idrottsmedicinska center och idrottsläkare som vill använda Nordbelt per behandlingsrum, terapeut, mottagning eller patientkit för hemträning.' },
        { pattern: /Webbplats listing/g, value: 'Webbplatsomnämnande' },
        { pattern: /20\+ tier/g, value: '20+ staffel' },
        { pattern: /Begär klinikpris for/g, value: 'Begär klinikpris för' },
        { pattern: /For clinics that want to use Nordbelt structurally and keep stock to provide, lend or sell to patients immediately\./g, value: 'För kliniker som vill använda Nordbelt strukturerat och ha lager för att ge, låna ut eller sälja direkt till patienter.' },
        { pattern: /We use your details to create a suitable proposal for room sets, patient stock and possible replenishment\./g, value: 'Vi använder dina uppgifter för att ta fram ett passande förslag för rumsset, patientlager och eventuell påfyllning.' },
        { pattern: /We use your details to create a suitable proposal for room sets, patientlager and possible replenishment\./g, value: 'Vi använder dina uppgifter för att ta fram ett passande förslag för rumsset, patientlager och eventuell påfyllning.' },
        { pattern: /^Use$/g, value: 'Användning' },
        { pattern: /Marge pro Stück when sold at the current Nordbelt price/g, value: 'Marginal per Nordbelt vid aktuellt Nordbelt-pris' },
        { pattern: /Marge pro Stück when sold/g, value: 'Marginal per Nordbelt vid återförsäljning' },
        { pattern: /Marge por Nordbelt when sold at the current Nordbelt price/g, value: 'Marginal per Nordbelt vid aktuellt Nordbelt-pris' },
        { pattern: /Marge por Nordbelt when sold/g, value: 'Marginal per Nordbelt vid återförsäljning' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Marginal per Nordbelt vid återförsäljning' },
        { pattern: /Potential total margin/g, value: 'Potentiell total marginal' },
        { pattern: /from €/g, value: 'från €' }
      );
    } else if (locale === 'da') {
      replacements.push(
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Aktuel pakkepris via Shopify-variant.' },
        { pattern: /Actuele patiëntprijs/g, value: 'Aktuel patientpris' },
        { pattern: /actuele Nordbelt-prijs/g, value: 'aktuel Nordbelt-pris' },
        { pattern: /Give patients the same Nordic Hamstring Curl setup for/g, value: 'Giv patienten samme Nordic Hamstring Curl-setup til' },
        { pattern: /From treatment room to/g, value: 'Fra behandlingsrum til' },
        { pattern: /home-use kits/g, value: 'hjemmetræningskit' },
        { pattern: /home-use kit/g, value: 'hjemmetræningskit' },
        { pattern: /Home-Use Kits/g, value: 'hjemmetræningskit' },
        { pattern: /hjemmetræningskits/g, value: 'hjemmetræningskit' },
        { pattern: /home use\./g, value: 'hjemmetræning.' },
        { pattern: /Ready in 1 minute/g, value: 'Klar på 1 minut' },
        { pattern: /Ready in/g, value: 'Klar på' },
        { pattern: /1 minute/g, value: '1 minut' },
        { pattern: /in clinic and at home/g, value: 'i klinikken og hjemme' },
        { pattern: /Choose your setup: door, treatment bench, fence or anchor point\./g, value: 'Vælg setup: dør, briks, hegn eller ankerpunkt.' },
        { pattern: /Clip in and adjust the strap to size\./g, value: 'Klik remmen fast og justér længden.' },
        { pattern: /Start directly with the first guided repetition\./g, value: 'Start direkte med den første vejledte gentagelse.' },
        { pattern: /Door in treatment room/g, value: 'Dør i behandlingsrum' },
        { pattern: /Treatment bench or exercise space/g, value: 'Briks eller træningsområde' },
        { pattern: /Most chosen — Clinic \+ Home-Use Kits/g, value: 'Mest valgt - klinik + hjemmetræningskit' },
        { pattern: /Most chosen - Clinic \+ Home-Use Kits/g, value: 'Mest valgt - klinik + hjemmetræningskit' },
        { pattern: /Clinic \+ Home-Use Kits/g, value: 'Klinik + hjemmetræningskit' },
        { pattern: /PACKAGE/g, value: 'PAKKE' },
        { pattern: /^Package$/g, value: 'Pakke' },
        { pattern: /Not included/g, value: 'Ikke inkluderet' },
        { pattern: /Included/g, value: 'Inkluderet' },
        { pattern: /Evidence-based training principle\. Made practical for clinic and home\./g, value: 'Evidensbaseret træningsprincip. Gjort praktisk til klinik og hjem.' },
        { pattern: /Evidence-based training principle/g, value: 'Evidensbaseret træningsprincip' },
        { pattern: /Evidensbaseret training principle/g, value: 'Evidensbaseret træningsprincip' },
        { pattern: /training principle/g, value: 'træningsprincip' },
        { pattern: /EVIDENCE/g, value: 'EVIDENS' },
        { pattern: /Evidence/g, value: 'Evidens' },
        { pattern: /Evidens-based/g, value: 'Evidensbaseret' },
        { pattern: /Made practical for clinic and home/g, value: 'Gjort praktisk til klinik og hjem' },
        { pattern: /The Nordic Hamstring Exercise is a widely studied training principle in hamstring injury prevention programmes\. In a systematic review and meta-analysis, programmes that included the Nordic Hamstring Exercise reported up to 51% fewer hamstring injuries\. Nordbelt makes this exercise practical without a partner or large machine, so you can use the same setup in the treatment room and at home\./g, value: 'Nordic Hamstring Exercise er et velundersøgt træningsprincip i programmer til forebyggelse af hamstringskader. I et systematisk review og en metaanalyse rapporterede programmer med Nordic Hamstring Exercise op til 51 % færre hamstringskader. Nordbelt gør øvelsen praktisk uden makker eller stor maskine, så samme setup kan bruges i behandlingsrummet og hjemme.' },
        { pattern: /The Nordic Hamstring Exercise is a strongly researched training principle; programmes with NHE report up to 51% færre hamstring injuries\./g, value: 'Nordic Hamstring Exercise er et solidt undersøgt træningsprincip; programmer med NHE rapporterer op til 51 % færre hamstringskader.' },
        { pattern: /The Nordic Hamstring Exercise is a strongly researched training principle; programmes with NHE report up to 51% fewer hamstring injuries\./g, value: 'Nordic Hamstring Exercise er et solidt undersøgt træningsprincip; programmer med NHE rapporterer op til 51 % færre hamstringskader.' },
        { pattern: /hamstring injuries/g, value: 'hamstringskader' },
        { pattern: /Open: view protocol, clinic quotes and source detail/g, value: 'Åbn: se protokol, klinikcitater og kildedetaljer' },
        { pattern: /What therapists see in the clinic\./g, value: 'Hvad terapeuter ser i klinikken.' },
        { pattern: /What therapists see/g, value: 'Hvad terapeuter ser' },
        { pattern: /Hvad terapeuter ser in the clinic\./g, value: 'Hvad terapeuter ser i klinikken.' },
        { pattern: /in the clinic\./g, value: 'i klinikken.' },
        { pattern: /External reviews that help assess how Nordbelt fits treatment-room explanation, home continuation and fixed clinic stock\./g, value: 'Eksterne anmeldelser hjælper med at vurdere, hvordan Nordbelt passer til instruktion i behandlingsrummet, hjemmetræning og fast kliniklager.' },
        { pattern: /External reviews/g, value: 'Eksterne anmeldelser' },
        { pattern: /User experiences\. Results differ per person and application\./g, value: 'Brugeroplevelser. Resultater varierer efter person og anvendelse.' },
        { pattern: /The treating professional determines use, progression and load\./g, value: 'Den behandlende fagperson bestemmer brug, progression og belastning.' },
        { pattern: /20\+ tier/g, value: '20+ staffel' },
        { pattern: /Advice for practice pricing: 20\+ Nordbelts/g, value: 'Rådgivning om klinikpris: 20+ Nordbelts' },
        { pattern: /Proposal for 20\+ practice pricing/g, value: 'Forslag til 20+ klinikpris' },
        { pattern: /Margin estimate for resale/g, value: 'Avanceestimat ved videresalg' },
        { pattern: /Options for replenishment/g, value: 'Muligheder for genopfyldning' },
        { pattern: /Advice on implementation in your clinic flow/g, value: 'Rådgivning om implementering i klinikkens flow' },
        { pattern: /Margin indication/g, value: 'Avanceindikation' },
        { pattern: /MARGIN INDICATION/g, value: 'AVANCEINDIKATION' },
        { pattern: /Tier price/g, value: 'Staffelpris' },
        { pattern: /Purchase price per Nordbelt/g, value: 'Indkøbspris per Nordbelt' },
        { pattern: /Current patient price/g, value: 'Aktuel patientpris' },
        { pattern: /Margin per Nordbelt/g, value: 'Avance per Nordbelt' },
        { pattern: /Indication based on 20/g, value: 'Indikation baseret på 20' },
        { pattern: /Use faste sæt/g, value: 'Brug faste sæt' },
        { pattern: /provide within pathway/g, value: 'giv med i forløbet' },
        { pattern: /meerdere kliniklokationer/g, value: 'flere kliniklokationer' },
        { pattern: /from ([0-9])/g, value: 'fra $1' },
        { pattern: /We use your details to create a suitable proposal for room sets, patientlager and possible replenishment\./g, value: 'Vi bruger oplysningerne til at lave et passende forslag til rumsets, patientlager og eventuel genopfyldning.' },
        { pattern: /We use your details to create a suitable proposal for room sets, patient stock and possible replenishment\./g, value: 'Vi bruger oplysningerne til at lave et passende forslag til rumsets, patientlager og eventuel genopfyldning.' },
        { pattern: /For fysioterapiklinikker, sportsmedicinske centre og sportslæger that want to use Nordbelt per treatment room, therapist, location or patient hjemmetræningskit\./g, value: 'For fysioterapiklinikker, sportsmedicinske centre og sportslæger, der vil bruge Nordbelt per behandlingsrum, terapeut, lokation eller patientens hjemmetræningskit.' },
        { pattern: /Request practice pricing/g, value: 'Anmod om klinikpris' },
        { pattern: /Marge pro Stück when sold at the current Nordbelt price/g, value: 'Avance per Nordbelt ved aktuel Nordbelt-pris' },
        { pattern: /Marge pro Stück when sold/g, value: 'Avance per Nordbelt ved videresalg' },
        { pattern: /Possible margin when sold/g, value: 'Avance ved videresalg' },
        { pattern: /Marge por Nordbelt when sold at the current Nordbelt price/g, value: 'Avance per Nordbelt ved aktuel Nordbelt-pris' },
        { pattern: /Marge por Nordbelt when sold/g, value: 'Avance per Nordbelt ved videresalg' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Avance per Nordbelt ved aktuel Nordbelt-pris' },
        { pattern: /Potential total margin/g, value: 'Potentiel samlet avance' },
        { pattern: /from €/g, value: 'fra €' }
      );
    } else if (locale === 'nb') {
      replacements.push(
        { pattern: /Actuele pakketprijs via Shopify-variant\./g, value: 'Aktuell pakkepris via Shopify-variant.' },
        { pattern: /Aktuel pakkepris via Shopify-variant\./g, value: 'Aktuell pakkepris via Shopify-variant.' },
        { pattern: /Actuele patiëntprijs/g, value: 'Aktuell pasientpris' },
        { pattern: /Aktuel patientpris/g, value: 'Aktuell pasientpris' },
        { pattern: /actuele Nordbelt-prijs/g, value: 'aktuell Nordbelt-pris' },
        { pattern: /aktuel Nordbelt-pris/g, value: 'aktuell Nordbelt-pris' },
        { pattern: /Giv pasienten/g, value: 'Gi pasienten' },
        { pattern: /Giv patienten/g, value: 'Gi pasienten' },
        { pattern: /Nordic Hamstring Curl-setup/g, value: 'Nordic Hamstring Curl-oppsett' },
        { pattern: /Klar på 1 minut+t*/g, value: 'Klar på 1 minutt' },
        { pattern: /1 minut\b/g, value: '1 minutt' },
        { pattern: /Vælg setup: dør, briks, hegn eller ankerpunkt\./g, value: 'Velg oppsett: dør, behandlingsbenk, gjerde eller ankerpunkt.' },
        { pattern: /Klik remmen fast og justér længden\./g, value: 'Fest remmen og juster lengden.' },
        { pattern: /Start direkte med den første vejledte gentagelse\./g, value: 'Start direkte med den første veiledede repetisjonen.' },
        { pattern: /Briks eller treningsområde/g, value: 'Behandlingsbenk eller treningsområde' },
        { pattern: /Evidensbaseret træningsprincip\. Gjort praktisk til klinik og hjem\./g, value: 'Dokumentert treningsprinsipp. Gjort praktisk for klinikk og hjemme.' },
        { pattern: /Evidensbaseret treningsprincip\. Gjort praktisk til klinik og hjem\./g, value: 'Dokumentert treningsprinsipp. Gjort praktisk for klinikk og hjemme.' },
        { pattern: /Dokumentert treningsprincip\. Gjort praktisk til klinik og hjem\./g, value: 'Dokumentert treningsprinsipp. Gjort praktisk for klinikk og hjemme.' },
        { pattern: /training principle/g, value: 'treningsprinsipp' },
        { pattern: /treningsprincip/g, value: 'treningsprinsipp' },
        { pattern: /til klinik og hjem/g, value: 'for klinikk og hjemme' },
        { pattern: /What therapists see in the clinic\./g, value: 'Hva terapeuter ser i klinikken.' },
        { pattern: /What therapists see/g, value: 'Hva terapeuter ser' },
        { pattern: /Hvad terapeuter ser in the clinic\./g, value: 'Hva terapeuter ser i klinikken.' },
        { pattern: /Hvad terapeuter ser/g, value: 'Hva terapeuter ser' },
        { pattern: /in the clinic\./g, value: 'i klinikken.' },
        { pattern: /Hvad I modtager/g, value: 'Hva dere får' },
        { pattern: /20\+ staffel/g, value: '20+ staffel' },
        { pattern: /Rådgivning om klinikpris/g, value: 'Råd om klinikkpris' },
        { pattern: /Proposal for 20\+ practice pricing/g, value: 'Forslag til 20+ klinikkpris' },
        { pattern: /Rådgivning om fordeling mellem klinikksett og patientlager/g, value: 'Rådgivning om fordeling mellom klinikksett og pasientlager' },
        { pattern: /Margin estimate for resale/g, value: 'Marginestimat ved videresalg' },
        { pattern: /Options for replenishment/g, value: 'Alternativer for påfylling' },
        { pattern: /Advice on implementation in your clinic flow/g, value: 'Råd om implementering i klinikkflyten' },
        { pattern: /Margin indication/g, value: 'Marginindikasjon' },
        { pattern: /MARGIN INDICATION/g, value: 'MARGININDIKASJON' },
        { pattern: /Tier price/g, value: 'Staffelpris' },
        { pattern: /Purchase price per Nordbelt/g, value: 'Innkjøpspris per Nordbelt' },
        { pattern: /Current patient price/g, value: 'Aktuell pasientpris' },
        { pattern: /Indication based on 20/g, value: 'Indikasjon basert på 20' },
        { pattern: /Use faste sæt/g, value: 'Bruk faste sett' },
        { pattern: /provide within pathway/g, value: 'gi med i forløpet' },
        { pattern: /lånesæt/g, value: 'lånesett' },
        { pattern: /meerdere klinikksteder/g, value: 'flere klinikksteder' },
        { pattern: /Vælg fordeling/g, value: 'Velg fordeling' },
        { pattern: /from ([0-9])/g, value: 'fra $1' },
        { pattern: /Vi bruker oplysningerne til at lave et passende forslag til rumsets, patientlager og eventuel genopfyldning\./g, value: 'Vi bruker opplysningene til å lage et passende forslag for romsett, pasientlager og eventuell påfylling.' },
        { pattern: /We use your details to create a suitable proposal for room sets, patientlager and possible replenishment\./g, value: 'Vi bruker opplysningene til å lage et passende forslag for romsett, pasientlager og eventuell påfylling.' },
        { pattern: /We use your details to create a suitable proposal for room sets, patient stock and possible replenishment\./g, value: 'Vi bruker opplysningene til å lage et passende forslag for romsett, pasientlager og eventuell påfylling.' },
        { pattern: /PACKAGE/g, value: 'PAKKE' },
        { pattern: /^Package$/g, value: 'Pakke' },
        { pattern: /Not included/g, value: 'Ikke inkludert' },
        { pattern: /Included/g, value: 'Inkludert' },
        { pattern: /Marge pro Stück when sold at the current Nordbelt price/g, value: 'Fortjeneste per Nordbelt ved aktuell Nordbelt-pris' },
        { pattern: /Marge pro Stück when sold/g, value: 'Fortjeneste per Nordbelt ved videresalg' },
        { pattern: /Marge por Nordbelt when sold at the current Nordbelt price/g, value: 'Fortjeneste per Nordbelt ved aktuell Nordbelt-pris' },
        { pattern: /Marge por Nordbelt when sold/g, value: 'Fortjeneste per Nordbelt ved videresalg' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Fortjeneste per Nordbelt ved aktuell Nordbelt-pris' },
        { pattern: /Potential total margin/g, value: 'Potensiell samlet fortjeneste' },
        { pattern: /from €/g, value: 'fra €' }
      );
    } else if (locale === 'et') {
      replacements.push(
        { pattern: /From treatment room to/g, value: 'Raviruumist' },
        { pattern: /Raviruumist kodutreeningu komplekt/g, value: 'Raviruumist kodutreeninguni' },
        { pattern: /Ready in 1 minute/g, value: 'Valmis 1 minutiga' },
        { pattern: /Ready in/g, value: 'Valmis' },
        { pattern: /1 minute/g, value: '1 minutiga' },
        { pattern: /Margin for your clinic on/g, value: 'Kliiniku marginaal' },
        { pattern: /\bon resale\b/g, value: 'edasimüügil' },
        { pattern: /\bresale\b/g, value: 'edasimüügil' },
        { pattern: /Praktijkpackages/g, value: 'Kliinikupaketid' },
        { pattern: /praktijkpackages/g, value: 'kliinikupaketid' },
        { pattern: /Marge füsioteraapiakliinikutele bij edasimüügil van Nordbelt kliinikupaketid/g, value: 'Nordbelti kliinikupakettide edasimüügi marginaal füsioteraapiakliinikutele' },
        { pattern: /For larger stock or mitu asukohta/g, value: 'Suurema varu või mitme asukoha jaoks' },
        { pattern: /Vali pakett, mis sobib your rooms, therapists, home continuation and locations\. For suitable partner packages, extra visibility can help guide Nordbelti klientidele in your region to your clinic faster\./g, value: 'Vali pakett, mis sobib raviruumide, terapeutide, koduse jätku ja asukohtadega. Sobivate partnerpakettide puhul võib lis nähtavus aidata sinu piirkonna Nordbelti klientidel kiiremini kliinikuni jõuda.' },
        { pattern: /Füsioteraapiakliinikutele, spordimeditsiini keskustele ja spordiarstidele that want to use Nordbelt per treatment room, therapist, location or patient kodutreeningu komplekt\./g, value: 'Füsioteraapiakliinikutele, spordimeditsiini keskustele ja spordiarstidele, kes soovivad kasutada Nordbelti raviruumi, terapeudi, asukoha või patsiendi kodutreeningu komplekti kohta.' },
        { pattern: /Proposal for 20\+ practice pricing/g, value: '20+ kliinikuhinna pakkumine' },
        { pattern: /Margin estimate for edasimüügil/g, value: 'Edasimüügi marginaali hinnang' },
        { pattern: /Margin estimate for resale/g, value: 'Edasimüügi marginaali hinnang' },
        { pattern: /Options for replenishment/g, value: 'Täiendamise võimalused' },
        { pattern: /Võrdle kliinikukomplektid, patsiendivaru, distribution models and margin based on the current Nordbelt price\./g, value: 'Võrdle kliinikukomplekte, patsiendivaru, jaotusmudeleid ja marginaali praeguse Nordbelti hinna põhjal.' },
        { pattern: /Comparison of Nordbelt packages füsioteraapiakliinikutele/g, value: 'Nordbelti pakettide võrdlus füsioteraapiakliinikutele' },
        { pattern: /Physiotherapy clinics/g, value: 'Füsioteraapiakliinikud' },
        { pattern: /PHYSIOTHERAPY CLINICS/g, value: 'FÜSIOTERAAPIAKLIINIKUD' },
        { pattern: /^locations$/g, value: 'asukohta' },
        { pattern: /training principle/g, value: 'treeningupõhimõte' },
        { pattern: /Made practical for clinic and home/g, value: 'Praktiliseks tehtud kliinikus ja kodus' },
        { pattern: /The Nordic Hamstring Exercise is a widely studied treeningupõhimõte in hamstring injury prevention programmes\./g, value: 'Nordic Hamstring Exercise on laialdaselt uuritud treeningupõhimõte hamstringivigastuste ennetusprogrammides.' },
        { pattern: /Nordbelt makes this exercise practical without a partner or large machine, so you can use the same setup in the treatment room and at home\./g, value: 'Nordbelt teeb sama harjutuse praktiliseks ilma partneri või suure masinata, nii et sama seadistust saab kasutada raviruumis ja kodus.' },
        { pattern: /Open: view protocol, clinic quotes and source detail/g, value: 'Ava: vaata protokolli, kliinikute tsitaate ja allika üksikasju' },
        { pattern: /The Nordic Hamstring Exercise is a strongly researched treeningupõhimõte; programmes with NHE report up to 51% fewer hamstring injuries\./g, value: 'Nordic Hamstring Exercise on tugevalt uuritud treeningupõhimõte; NHE-d sisaldavad programmid raporteerivad kuni 51% vähem hamstringivigastusi.' },
        { pattern: /Google reviews/g, value: 'Google\'i arvustused' },
        { pattern: /Trustpilot reviews/g, value: 'Trustpiloti arvustused' },
        { pattern: /Reviews from physiotherapists and customers/g, value: 'Füsioterapeutide ja klientide arvustused' },
        { pattern: /Google review/g, value: 'Google\'i arvustus' },
        { pattern: /View Trustpiloti arvustused/g, value: 'Vaata Trustpiloti arvustusi' },
        { pattern: /View Trustpilot reviews/g, value: 'Vaata Trustpiloti arvustusi' },
        { pattern: /What therapists see in the clinic\./g, value: 'Mida terapeudid kliinikus näevad.' },
        { pattern: /What therapists see in practice\./g, value: 'Mida terapeudid kliinikus näevad.' },
        { pattern: /What therapists see/g, value: 'Mida terapeudid näevad' },
        { pattern: /in the clinic\./g, value: 'kliinikus.' },
        { pattern: /External reviews that help assess how Nordbelt fits treatment-room explanation, home continuation and fixed clinic stock\./g, value: 'Välised arvustused aitavad hinnata, kuidas Nordbelt sobib raviruumis selgitamiseks, koduseks jätkuks ja püsivaks kliinikuvaruks.' },
        { pattern: /User experiences\. Results differ per person and application\./g, value: 'Kasutajakogemused. Tulemused erinevad inimeseti ja kasutusviisiti.' },
        { pattern: /The treating professional determines use, progression and load\./g, value: 'Kasutuse, progressiooni ja koormuse määrab ravispetsialist.' },
        { pattern: /A great solution for performing the Nordic Hamstring Curl properly and easily\. Useful during my work as a physiotherapist and usable in different locations\./g, value: 'Suurepärane lahendus Nordic Hamstring Curli korrektseks ja lihtsaks sooritamiseks. Kasulik minu füsioterapeudi töös ning kasutatav eri asukohtades.' },
        { pattern: /We use the NordBelt in our physiotherapy clinic and recommend it to anyone who wants to recover from a hamstring injury or optimise performance\./g, value: 'Kasutame Nordbelti oma füsioteraapiakliinikus ja soovitame seda kõigile, kes soovivad hamstringvigastusest taastuda või sooritust parandada.' },
        { pattern: /Trustpilot · sports physio/g, value: 'Trustpilot · spordifüsio' },
        { pattern: /Show more reviews/g, value: 'Näita rohkem arvustusi' },
        { pattern: /Open Google reviews/g, value: 'Ava Google\'i arvustused' },
        { pattern: /Kasutusful/g, value: 'Kasulik' },
        { pattern: /Number of asukohta/g, value: 'Asukohtade arv' },
        { pattern: /E\.g\. 2/g, value: 'Nt 2' },
        { pattern: /E\.g\. 6/g, value: 'Nt 6' },
        { pattern: /E\.g\. 12/g, value: 'Nt 12' },
        { pattern: /E\.g\. 20, 32 of 50/g, value: 'Nt 20, 32 või 50' },
        { pattern: /E\.g\. within 4 weeks/g, value: 'Nt 4 nädala jooksul' },
        { pattern: /Nimi or department/g, value: 'Nimi või osakond' },
        { pattern: /sell as a kodutreeningu komplekt/g, value: 'müü kodutreeningu komplektina' },
        { pattern: /^Use$/g, value: 'Kasutus' },
        { pattern: /meerdere asukohta/g, value: 'mitu asukohta' },
        { pattern: /meerdere locations/g, value: 'mitu asukohta' },
        { pattern: /Vertel kort hoe je Nordbelt wilt inzetten per kamer, therapeut, locatie of patsiendivaru\./g, value: 'Kirjelda lühidalt, kuidas soovite Nordbelti kasutada ruumi, terapeudi, asukoha või patsiendivaru kaupa.' },
        { pattern: /Advies voor praktijkstaffel:/g, value: 'Kliinikuhinna soovitus:' },
        { pattern: /Locations:/g, value: 'Asukohad:' },
        { pattern: /Therapists\/sports physicians:/g, value: 'Terapeudid\/spordiarstid:' },
        { pattern: /Rooms:/g, value: 'Ruumid:' },
        { pattern: /Patients\/month:/g, value: 'Patsiente kuus:' },
        { pattern: /Distribution model:/g, value: 'Jaotusmudel:' },
        { pattern: /VAT toggle:/g, value: 'Käibemaksu lüliti:' },
        { pattern: /Marge pro Stück when sold at the current Nordbelt price/g, value: 'Marginaal Nordbelti kohta praeguse Nordbelti hinna juures' },
        { pattern: /Marge pro Stück when sold/g, value: 'Marginaal Nordbelti edasimüügil' },
        { pattern: /Marge por Nordbelt when sold at the current Nordbelt price/g, value: 'Marginaal Nordbelti kohta praeguse Nordbelti hinna juures' },
        { pattern: /Marge por Nordbelt when sold/g, value: 'Marginaal Nordbelti edasimüügil' },
        { pattern: /Margin per Nordbelt at the current retail price/g, value: 'Marginaal Nordbelti kohta praeguse jaehinna juures' },
        { pattern: /Potential total margin/g, value: 'Võimalik kogumarginaal' },
        { pattern: /Margins are calculation examples based on the current Nordbelt price\. Use the margin block and package cards to include VAT handling in your decision\./g, value: 'Marginaalid on arvutusnäited praeguse Nordbelti hinna põhjal. Kasuta marginaaliplokki ja paketikaarte, et otsustada, kas käibemaksuarvestus on vajalik.' },
        { pattern: /Shipping/g, value: 'Tarne' },
        { pattern: /Not included/g, value: 'Ei sisaldu' },
        { pattern: /Included/g, value: 'Kaasas' },
        { pattern: /Limited \/ internal start/g, value: 'Piiratud / sisemine algus' },
        { pattern: /Limited/g, value: 'Piiratud' },
        { pattern: /Package saving/g, value: 'Paketisääst' },
        { pattern: /from €/g, value: 'alates €' }
      );
    } else if (locale === 'en') {
      replacements.push(
        { pattern: /Margin per unit when sold/g, value: 'Margin per Nordbelt at the current retail price' }
      );
    }

    function cleanValue(value) {
      if (!value) return value;
      var next = value;
      replacements.forEach(function (replacement) {
        next = next.replace(replacement.pattern, replacement.value);
      });
      return next;
    }

    var walkerRoot = root.body || root;
    if (!walkerRoot || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(walkerRoot, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node || !node.parentElement) continue;
      var parentTag = (node.parentElement.tagName || '').toUpperCase();
      if (parentTag === 'SCRIPT' || parentTag === 'STYLE' || parentTag === 'NOSCRIPT' || parentTag === 'TEMPLATE' || parentTag === 'TEXTAREA') continue;
      var cleaned = cleanValue(node.nodeValue || '');
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    }

    if (locale === 'es') {
      root.querySelectorAll('h2.nb-section-title, h2.nb-home-science__section-title').forEach(function (title) {
        if ((title.innerText || '').indexOf('Base científica-based') === -1) return;
        title.innerHTML = '<span class="nb-title-accent nb-title-accent--science">Principio de entrenamiento</span><span> respaldado por evidencia. Hecho práctico para la clínica y casa.</span>';
      });
    }

    if (locale === 'sv') {
      root.querySelectorAll('.nb-home-science__section-eyebrow').forEach(function (eyebrow) {
        if ((eyebrow.innerText || '').trim() === 'Evidence') eyebrow.textContent = 'Evidens';
      });
      root.querySelectorAll('h2.nb-home-science__section-title').forEach(function (title) {
        if ((title.innerText || '').indexOf('Evidence-based') === -1) return;
        title.innerHTML = '<span class="nb-title-accent nb-title-accent--science">Evidensbaserad</span><span> träningsprincip. Gjord praktisk för klinik och hem.</span>';
      });
      root.querySelectorAll('.nb-review-proof-fysio__title').forEach(function (title) {
        if ((title.innerText || '').indexOf('in the clinic') === -1) return;
        title.innerHTML = '<span class="nb-practice-title-line">Det terapeuter ser</span><span class="nb-practice-title-line">på <span class="nb-review-proof-fysio__title-accent">kliniken.</span></span>';
      });
      root.querySelectorAll('th, td, caption').forEach(function (cell) {
        if ((cell.textContent || '').trim() === 'Physioterapikliniker') cell.textContent = 'Fysioterapikliniker';
      });
    }

    if (locale === 'da') {
      root.querySelectorAll('.nb-home-science__section-eyebrow').forEach(function (eyebrow) {
        if ((eyebrow.innerText || '').trim() === 'Evidence') eyebrow.textContent = 'Evidens';
      });
      root.querySelectorAll('h2.nb-home-science__section-title').forEach(function (title) {
        if ((title.innerText || '').indexOf('Evidence-based') === -1 && (title.innerText || '').indexOf('training principle') === -1) return;
        title.innerHTML = '<span class="nb-title-accent nb-title-accent--science">Evidensbaseret</span><span> træningsprincip. Gjort praktisk til klinik og hjem.</span>';
      });
      root.querySelectorAll('.nb-review-proof-fysio__title').forEach(function (title) {
        if ((title.innerText || '').indexOf('in the clinic') === -1) return;
        title.innerHTML = '<span class="nb-practice-title-line">Hvad terapeuter ser</span><span class="nb-practice-title-line">i <span class="nb-review-proof-fysio__title-accent">klinikken.</span></span>';
      });
    }

    if (locale === 'nb') {
      root.querySelectorAll('.nb-home-science__section-eyebrow').forEach(function (eyebrow) {
        if ((eyebrow.innerText || '').trim() === 'Evidence') eyebrow.textContent = 'Dokumentasjon';
      });
      root.querySelectorAll('h2.nb-home-science__section-title').forEach(function (title) {
        var titleText = title.innerText || '';
        if (titleText.indexOf('training principle') === -1 && titleText.indexOf('treningsprincip') === -1 && titleText.indexOf('til klinik') === -1) return;
        title.innerHTML = '<span class="nb-title-accent nb-title-accent--science">Dokumentert</span><span> treningsprinsipp. Gjort praktisk for klinikk og hjemme.</span>';
      });
      root.querySelectorAll('.nb-review-proof-fysio__title').forEach(function (title) {
        var titleText = title.innerText || '';
        if (titleText.indexOf('in the clinic') === -1 && titleText.indexOf('Hvad') === -1) return;
        title.innerHTML = '<span class="nb-practice-title-line">Hva terapeuter ser</span><span class="nb-practice-title-line">i <span class="nb-review-proof-fysio__title-accent">klinikken.</span></span>';
      });
    }

    if (locale === 'et') {
      root.querySelectorAll('h2.nb-section-title').forEach(function (title) {
        if ((title.innerText || '').trim() !== 'Raviruumist kodutreeningu komplekt') return;
        var accent = title.querySelector('.nb-title-accent');
        if (accent) accent.textContent = 'kodutreeninguni';
      });
    }
  }

  function cleanPracticeB2BPlatformCopy(scope) {
    if (!window.location || !/\/pages\/fysiopraktijken(?:\/)?$/.test(window.location.pathname)) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var platformName = 'Shop' + 'ify';
    var replacements = [
      { pattern: new RegExp(platformName + ' checkout · 30 dagen proberen', 'gi'), value: 'Veilig afrekenen · 30 dagen proberen' },
      { pattern: new RegExp('actuele ' + platformName + '-prijs', 'gi'), value: 'actuele Nordbelt-prijs' },
      { pattern: new RegExp('actuele ' + platformName + '-verkoopprijs', 'gi'), value: 'actuele Nordbelt-verkoopprijs' },
      { pattern: new RegExp('automatisch uit ' + platformName + ' geladen', 'gi'), value: 'automatisch actueel gehouden op basis van de Nordbelt-productprijs' }
    ];

    function cleanValue(value) {
      if (!value) return value;
      var next = value;
      replacements.forEach(function (replacement) {
        next = next.replace(replacement.pattern, replacement.value);
      });
      return next;
    }

    root.querySelectorAll('script[type="application/ld+json"], script[type="application/json"]').forEach(function (script) {
      script.textContent = cleanValue(script.textContent);
    });

    var walkerRoot = root.body || root;
    if (!walkerRoot || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(walkerRoot, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node || !node.parentElement) continue;
      var parentTag = (node.parentElement.tagName || '').toUpperCase();
      if (parentTag === 'SCRIPT' || parentTag === 'STYLE' || parentTag === 'NOSCRIPT' || parentTag === 'TEMPLATE' || parentTag === 'TEXTAREA') continue;
      var cleaned = cleanValue(node.nodeValue || '');
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    }
  }

  function cleanPracticeB2BStaleLocaleCopy(scope) {
    if (!window.location || window.location.pathname.indexOf('/pages/fysiopraktijken') === -1) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var locale = getPracticeB2BLocaleBase();
    var replacements = [];

    function add(pattern, value) {
      replacements.push({ pattern: pattern, value: value });
    }

    function replaceInValue(value) {
      if (!value) return value;
      var next = value;
      replacements.forEach(function (replacement) {
        next = next.replace(replacement.pattern, replacement.value);
      });
      return next;
    }

    function cleanTextAndLabels() {
      var walkerRoot = root.body || root;
      if (walkerRoot && document.createTreeWalker) {
        var walker = document.createTreeWalker(walkerRoot, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          if (!node || !node.parentElement) continue;
          var parentTag = (node.parentElement.tagName || '').toUpperCase();
          if (parentTag === 'SCRIPT' || parentTag === 'STYLE' || parentTag === 'NOSCRIPT' || parentTag === 'TEMPLATE') continue;
          var cleaned = replaceInValue(node.nodeValue || '');
          if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
        }
      }

      root.querySelectorAll('[aria-label], [title], [alt]').forEach(function (node) {
        ['aria-label', 'title', 'alt'].forEach(function (attribute) {
          if (!node.hasAttribute(attribute)) return;
          var current = node.getAttribute(attribute);
          var cleaned = replaceInValue(current);
          if (cleaned !== current) node.setAttribute(attribute, cleaned);
        });
      });
    }

    function setLegend(number, label) {
      root.querySelectorAll('.practice-b2b-staffel__fieldset legend').forEach(function (legend) {
        var span = legend.querySelector('span');
        if (!span || (span.textContent || '').trim() !== String(number)) return;
        var current = (legend.textContent || '').replace(/\s+/g, ' ').trim();
        var expected = String(number) + ' ' + label;
        if (current === expected) return;
        legend.innerHTML = '<span>' + number + '</span> ' + label;
      });
    }

    function collapseDuplicateHeroSubtitle() {
      root.querySelectorAll('.nb-business-conversion-hero__subtitle').forEach(function (subtitle) {
        var desktop = subtitle.querySelector('.nb-business-conversion-hero__subtitle-desktop');
        var mobile = subtitle.querySelector('.nb-business-conversion-hero__subtitle-mobile');
        if (!desktop || !mobile) return;
        var text = (desktop.textContent || mobile.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        subtitle.textContent = text;
      });
    }

    collapseDuplicateHeroSubtitle();

    if (locale === 'en') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Margin for physiotherapy clinics on resale of Nordbelt clinic packages');
    } else if (locale === 'de') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Marge für Physiotherapiepraxen beim Weiterverkauf von Nordbelt Praxispaketen');
    } else if (locale === 'fr') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Marge pour cabinets de kinésithérapie lors de la revente de packs Nordbelt');
    } else if (locale === 'es') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Margen para clínicas de fisioterapia al revender packs Nordbelt');
    } else if (locale === 'pt') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Margem para clínicas de fisioterapia na revenda de packs Nordbelt');
    } else if (locale === 'it') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Margine per studi di fisioterapia nella rivendita dei pack Nordbelt');
    } else if (locale === 'fi') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Marginaali fysioterapiaklinikoille Nordbelt-klinikkapakettien jälleenmyynnissä');
    } else if (locale === 'sv') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Marginal för fysioterapikliniker vid återförsäljning av Nordbelt-klinikpaket');
    } else if (locale === 'da') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Avance for fysioterapiklinikker ved videresalg af Nordbelt-klinikpakker');
    } else if (locale === 'nb') {
      add(/Marginaal füsioteraapiakliinikutele Nordbelti kliinikupakettide edasimüügil/g, 'Fortjeneste for fysioterapiklinikker ved videresalg av Nordbelt-klinikkpakker');
    }

    if (locale === 'de') {
      add(/Einsatz the current Nordbelt retail price as the starting point\. This price is kept current automatically in the clinic flow based on the Nordbelt product price\. With practice Pakete, your purchase price per Nordbelt is lower, creating Weiterverkauf margin\./g, 'Nutzen Sie den aktuellen Nordbelt-Endkundenpreis als Ausgangspunkt. Dieser Preis wird im Praxisablauf automatisch auf Basis des Nordbelt-Produktpreises aktuell gehalten. Bei Praxispaketen ist Ihr Einkaufspreis pro Nordbelt niedriger, wodurch Marge im Weiterverkauf entsteht.');
      add(/How much margin do we make on Weiterverkauf\?/g, 'Wie viel Marge erzielen wir beim Weiterverkauf?');
      add(/Which package is best for Weiterverkauf\?/g, 'Welches Paket eignet sich am besten für den Weiterverkauf?');
      add(/For serious Patientenbestand, 12 or 20\+ is most logical\. The 4er-Paket is mainly suitable for fixed clinic sets\. The 8er-Paket is a good start, but the 12er-Paket gives more room to keep clinic sets and patient stock separate\./g, 'Für einen ernsthaften Patientenbestand sind 12 oder 20+ am sinnvollsten. Das 4er-Paket eignet sich vor allem für feste Praxis-Sets. Das 8er-Paket ist ein guter Start, aber das 12er-Paket gibt mehr Spielraum, Praxis-Sets und Patientenbestand getrennt zu halten.');
      add(/Yes\. You can start with a trial set or small package and expand afterwards\. Starting with a trial set or 4er-Paket\? You can expand to a larger package within 60 days\./g, 'Ja. Sie können mit einem Test-Set oder einem kleinen Paket starten und später erweitern. Starten Sie mit einem Test-Set oder 4er-Paket, können Sie innerhalb von 60 Tagen auf ein größeres Paket erweitern.');
      add(/in the clinic/g, 'in der Praxis');
    } else if (locale === 'fr') {
      setLegend(3, 'Utilisation');
      add(/Start with Pack 4/g, 'Démarrer avec le pack 4');
      add(/Start with Pack 8/g, 'Démarrer avec le pack 8');
      add(/Use the current Nordbelt retail price as the starting point\. This price is kept current automatically in the clinic flow based on the Nordbelt product price\. With practice packs, your purchase price per Nordbelt is lower, creating revente margin\./g, "Utilisez le prix public actuel de Nordbelt comme point de départ. Ce prix reste automatiquement à jour dans le flux cabinet selon le prix du produit Nordbelt. Avec les packs cabinet, votre prix d'achat par Nordbelt est plus bas, ce qui crée une marge à la revente.");
      add(/in the clinic/g, 'au cabinet');
    } else if (locale === 'sv') {
      setLegend(3, 'Användning');
    } else if (locale === 'da') {
      setLegend(2, 'Klinikstørrelse');
      setLegend(3, 'Brug');
      add(/Ready to use fast/g, 'Hurtigt klar til brug');
      add(/Leave this field empty/g, 'Lad dette felt være tomt');
      add(/Filled from package advice/g, 'Udfyldt fra pakkerådgivning');
      add(/20 Nordbelts and the current Nordbelt price\. Your final margin follows from the tier proposal\./g, '20 Nordbelts og den aktuelle Nordbelt-pris. Den endelige avance følger af staffelforslaget.');
      add(/based on tier price/g, 'baseret på staffelpris');
      add(/not filled in yet/g, 'ikke udfyldt endnu');
      add(/Number of kliniklokationer/g, 'Antal kliniklokationer');
      add(/Clinic size/g, 'Klinikstørrelse');
      add(/Google reviews/g, 'Google-anmeldelser');
      add(/Trustpilot reviews/g, 'Trustpilot-anmeldelser');
      add(/10 weeks/g, '10 uger');
      add(/Package saving/g, 'Pakkebesparelse');
      add(/Per unit/g, 'Per enhed');
      add(/Stock & Multi-location/g, 'Lager og flere kliniklokationer');
      add(/§ Bron:/g, 'Kilde:');
    } else if (locale === 'nb') {
      setLegend(3, 'Bruk');
      add(/Leave this field empty/g, 'La dette feltet stå tomt');
      add(/Filled from package advice/g, 'Utfylt fra pakkeråd');
      add(/20 Nordbelts and the current Nordbelt price\. Your final margin follows from the tier proposal\./g, '20 Nordbelts og aktuell Nordbelt-pris. Endelig margin følger av staffelforslaget.');
      add(/based on tier price/g, 'basert på staffelpris');
      add(/not filled in yet/g, 'ennå ikke utfylt');
      add(/Kliniknavn/g, 'Klinikknavn');
      add(/Professionel e-mail/g, 'Profesjonell e-post');
      add(/Organisationstype/g, 'Organisasjonstype');
      add(/Vælg organisationstype/g, 'Velg organisasjonstype');
      add(/sportslæge \/ klinik/g, 'idrettslege / klinikk');
      add(/performancecenter andet/g, 'prestasjonssenter annet');
      add(/faste sæt/g, 'faste sett');
      add(/salg som hjemmetreningssett/g, 'selg som hjemmetreningssett');
    } else if (locale === 'fi') {
      setLegend(3, 'Käyttö');
    } else if (locale === 'pt') {
      setLegend(3, 'Utilização');
      add(/Guide the first repetitions and match technique, dosage and progression to the patient's capacity\. This makes the home programme concrete before you provide a kit para casa or loan set\./g, 'Oriente as primeiras repetições e ajuste técnica, dose e progressão à capacidade do paciente. Assim, o programa para casa fica concreto antes de entregar um kit para casa ou set de empréstimo.');
      add(/Home continuation after clinic instruction/g, 'Continuação em casa após instrução na clínica');
      add(/Kit para casa contents/g, 'Conteúdo do kit para casa');
      add(/contents/g, 'conteúdo');
      add(/Utilização the current Nordbelt retail price as the starting point\. This price is kept current automatically in the clinic flow based on the Nordbelt product price\. With practice packs, your purchase price per Nordbelt is lower, creating revenda margin\./g, 'Use o preço atual de venda da Nordbelt como ponto de partida. Este preço é mantido atualizado automaticamente no fluxo de clínica com base no preço do produto Nordbelt. Com packs de clínica, o preço de compra por Nordbelt é mais baixo e cria margem de revenda.');
      add(/in the clinic/g, 'na clínica');
      add(/Leave this field empty/g, 'Deixe este campo vazio');
      add(/Filled from package advice/g, 'Preenchido a partir da recomendação de pack');
    } else if (locale === 'it') {
      setLegend(3, 'Utilizzo');
      add(/Guide the first repetitions and match technique, dosage and progression to the patient's capacity\. This makes the home programme concrete before you provide a kit per casa or loan set\./g, 'Guida le prime ripetizioni e adatta tecnica, dosaggio e progressione alla capacità del paziente. Così il programma per casa è concreto prima di consegnare un kit per casa o un set in prestito.');
      add(/Home continuation after clinic instruction/g, "Continuità a casa dopo l'istruzione in studio");
    } else if (locale === 'et') {
      setLegend(3, 'Kasutus');
      add(/Vali pakett, mis sobib your kliinikus kasutuselevõtt/g, 'Vali pakett, mis sobib sinu kliiniku kasutuselevõtuga');
      add(/Voor praktijken/g, 'Füsiokliinikutele');
      add(/Website/g, 'Veebisait');
    } else if (locale === 'es') {
      setLegend(3, 'Uso');
      add(/Use the current Nordbelt retail price as the starting point\. This price is kept current automatically in the clinic flow based on the Nordbelt product price\. With practice packs, your purchase price per Nordbelt is lower, creating reventa margin\./g, 'Usa el precio de venta actual de Nordbelt como punto de partida. Este precio se mantiene actualizado automáticamente en el flujo para clínicas según el precio del producto Nordbelt. Con los packs para clínicas, tu precio de compra por Nordbelt es más bajo y crea margen de reventa.');
      add(/Solicitar precio para clínicas for 20\+ Nordbelts/g, 'Solicitar precio para clínicas para 20+ Nordbelts');
      add(/for 20\+ Nordbelts/g, 'para 20+ Nordbelts');
      add(/in the clinic/g, 'en la clínica');
      add(/Leave this field empty/g, 'Deja este campo vacío');
      add(/Filled from package advice/g, 'Rellenado desde la recomendación de pack');
      add(/not filled in yet/g, 'aún sin completar');
      add(/based on tier price/g, 'según precio por tramo');
    } else if (locale === 'en') {
      add(/8\.459 participants/g, '8,459 participants');
      add(/meerdere locations/g, 'multiple locations');
      add(/Remit VAT on resale/g, 'Account for VAT on resale');
      add(/§ Bron:/g, 'Source:');
      add(/Bron:/g, 'Source:');
    }

    if (replacements.length) cleanTextAndLabels();
  }

  function setAudience(audience, options) {
    options = options || {};
    var root = getRoot();
    if (root) {
      if (!options.force && root.getAttribute('data-active-audience') === audience) {
        return;
      }
      root.setAttribute('data-active-audience', audience);
    }

    var groups = document.querySelectorAll('[data-business-audience-group]');
    groups.forEach(function (node) {
      var shouldShow = node.getAttribute('data-business-audience-group') === audience;
      node.hidden = !shouldShow;
      node.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });

    var tabs = document.querySelectorAll('[data-business-tab]');
    tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-business-tab') === audience;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    if (options.track) {
      pushBusinessEvent('business_tab_switch', {
        business_audience: audience,
        interaction_method: options.interactionMethod || 'unknown'
      });
    }

    syncPlanGrids();
    syncPlanStage();
    syncReferralDiagram();
    syncCompareBadgeReveal();
  }

  function syncPlanGrids() {
    document.querySelectorAll('[data-business-plan-grid]').forEach(function (grid) {
      var visibleCards = 0;
      grid.querySelectorAll('.nb-business-plan-card').forEach(function (card) {
        if (!card.hidden) {
          visibleCards += 1;
        }
      });
      grid.classList.toggle('nb-business-plan-grid--two', visibleCards === 2);
    });
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  var businessAnchorScrollFrame = 0;

  function readBusinessScrollVar(name) {
    var value = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name) || '');
    return Number.isFinite(value) ? value : 0;
  }

  function getBusinessAnchorScrollOffset() {
    return Math.max(
      readBusinessScrollVar('--nb-fixed-stack-height'),
      readBusinessScrollVar('--nb-header-live-height'),
      readBusinessScrollVar('--nb-header-height'),
      0
    ) + 10;
  }

  function easeBusinessAnchorScroll(progress) {
    if (progress <= 0.1) {
      var intro = progress / 0.1;
      return 0.08 * intro * intro;
    }

    var tail = (progress - 0.1) / 0.9;
    return 0.08 + (0.92 * (1 - Math.pow(1 - tail, 3.6)));
  }

  function finishBusinessAnchorScroll(hash) {
    businessAnchorScrollFrame = 0;
    if (!hash) return;
    if (window.location.hash === hash) return;

    if (window.history && typeof window.history.pushState === 'function') {
      window.history.pushState(null, '', hash);
      return;
    }

    window.location.hash = hash;
  }

  function animateBusinessAnchorScroll(targetTop, hash) {
    if (businessAnchorScrollFrame) {
      window.cancelAnimationFrame(businessAnchorScrollFrame);
      businessAnchorScrollFrame = 0;
    }

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      window.scrollTo(0, targetTop);
      finishBusinessAnchorScroll(hash);
      return;
    }

    var startTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var distance = targetTop - startTop;
    if (Math.abs(distance) < 2) {
      finishBusinessAnchorScroll(hash);
      return;
    }

    var duration = Math.min(1300, Math.max(520, 420 + (Math.sqrt(Math.abs(distance)) * 18)));
    var startTime = null;

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = clamp(elapsed / duration, 0, 1);
      var eased = easeBusinessAnchorScroll(progress);
      window.scrollTo(0, Math.round(startTop + (distance * eased)));

      if (progress < 1) {
        businessAnchorScrollFrame = window.requestAnimationFrame(step);
        return;
      }

      window.scrollTo(0, targetTop);
      finishBusinessAnchorScroll(hash);
    }

    businessAnchorScrollFrame = window.requestAnimationFrame(step);
  }

  function setPlanCardFinalState(card) {
    card.style.setProperty('--nb-plan-card-x', '0px');
    card.style.setProperty('--nb-plan-card-y', '0px');
    card.style.setProperty('--nb-plan-card-rotate', '0deg');
    card.style.setProperty('--nb-plan-card-scale', '1');
    card.style.setProperty('--nb-plan-card-opacity', '1');
    card.style.setProperty('--nb-plan-card-saturate', '1');
    card.style.setProperty('--nb-plan-card-blur', '0px');
  }

  function syncPlanStage() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var offsetXMap = [-28, -10, 18, -16, 22, 8];
    var offsetYMap = [78, 118, 56, 102, 74, 62];
    var rotateMap = [-4, -2.5, 2.5, 4, -3, 2];

    document.querySelectorAll('[data-business-plan-panel]').forEach(function (panel) {
      var grid = panel.querySelector('[data-business-plan-grid]');
      if (!grid) return;
      var isHorizontalPlanRail =
        window.matchMedia &&
        window.matchMedia('(max-width: 750px)').matches &&
        grid.offsetWidth > 0 &&
        grid.scrollWidth > grid.clientWidth;

      grid.querySelectorAll('[data-business-plan-card]').forEach(function (card) {
        if (isHorizontalPlanRail) {
          card.style.setProperty('transition', 'none');
        } else {
          card.style.removeProperty('transition');
        }
      });

      if (panel.dataset.planStageRevealed === 'true') {
        grid.querySelectorAll('[data-business-plan-card]').forEach(function (card) {
          setPlanCardFinalState(card);
        });
        return;
      }

      var rect = panel.getBoundingClientRect();

      if (
        isHorizontalPlanRail &&
        grid.dataset.mobileStartApplied !== 'true' &&
        rect.top <= viewportHeight * 0.95
      ) {
        var targetCard = grid.querySelector('.nb-business-plan-card.is-featured') || grid.querySelector('.nb-business-plan-card[data-plan-key="scale-12"]');

        if (targetCard) {
          grid.dataset.mobileStartApplied = 'pending';

          var applyMobileStart = function () {
            if (grid.dataset.mobileStartApplied === 'true') return;
            var targetLeft = targetCard.offsetLeft - Math.max(0, (grid.clientWidth - targetCard.offsetWidth) / 2);
            grid.scrollTo({ left: Math.max(0, targetLeft), behavior: 'auto' });
            grid.dataset.mobileStartApplied = 'true';
          };

          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(applyMobileStart);
          });
          window.setTimeout(applyMobileStart, 80);
        }
      }

      if (isHorizontalPlanRail) {
        grid.querySelectorAll('[data-business-plan-card]').forEach(function (card) {
          setPlanCardFinalState(card);
        });
        return;
      }

      if (window.getComputedStyle && window.getComputedStyle(grid).display === 'grid') {
        panel.dataset.planStageRevealed = 'true';
        grid.querySelectorAll('[data-business-plan-card]').forEach(function (card) {
          setPlanCardFinalState(card);
        });
        return;
      }

      var startLine = viewportHeight * 0.98;
      var firstRowEndLine = viewportHeight * 0.39;
      var secondRowEndLine = viewportHeight * 0.44;
      var firstRowProgress = clamp((startLine - rect.top) / Math.max(1, startLine - firstRowEndLine), 0, 1);
      var allCardsRevealed = true;

      grid.querySelectorAll('[data-business-plan-card]').forEach(function (card) {
        var index = Number(card.getAttribute('data-business-plan-card-index') || '0');
        var rowIndex = index >= 3 ? 1 : 0;
        var rowProgress = firstRowProgress;

        if (rowIndex === 1) {
          var cardRect = card.getBoundingClientRect();
          rowProgress = clamp((startLine - cardRect.top) / Math.max(1, startLine - secondRowEndLine), 0, 1);
        }

        var stagger = rowIndex === 0 ? index * 0.08 : (index - 3) * 0.1;
        var duration = rowIndex === 0 ? 0.67 : 0.62;
        var cardProgress = clamp((rowProgress - stagger) / duration, 0, 1);
        if (cardProgress < 1) {
          allCardsRevealed = false;
        }
        var inverse = 1 - cardProgress;
        var baseX = offsetXMap[index % offsetXMap.length];
        var baseY = offsetYMap[index % offsetYMap.length];
        var baseRotate = rotateMap[index % rotateMap.length];

        card.style.setProperty('--nb-plan-card-x', (baseX * inverse).toFixed(2) + 'px');
        card.style.setProperty('--nb-plan-card-y', (baseY * inverse).toFixed(2) + 'px');
        card.style.setProperty('--nb-plan-card-rotate', (baseRotate * inverse).toFixed(2) + 'deg');
        card.style.setProperty('--nb-plan-card-scale', (0.93 + (cardProgress * 0.07)).toFixed(3));
        card.style.setProperty('--nb-plan-card-opacity', (0.52 + (cardProgress * 0.48)).toFixed(3));
        card.style.setProperty('--nb-plan-card-saturate', (0.82 + (cardProgress * 0.18)).toFixed(3));
        card.style.setProperty('--nb-plan-card-blur', (0.65 * inverse).toFixed(3) + 'px');
      });

      if (allCardsRevealed) {
        panel.dataset.planStageRevealed = 'true';
        grid.querySelectorAll('[data-business-plan-card]').forEach(function (card) {
          setPlanCardFinalState(card);
        });
      }
    });
  }

  function syncReferralDiagram() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.nb-business-referral').forEach(function (section) {
      var rect = section.getBoundingClientRect();
      var progress = 1;

      if (!reduceMotion) {
        var start = viewportHeight * 0.96;
        var end = viewportHeight * 0.32;
        progress = clamp((start - rect.top) / Math.max(1, start - end), 0, 1);
      }

      section.style.setProperty('--nb-referral-connector-progress', progress.toFixed(3));
      section.style.setProperty('--nb-referral-node-scale', (0.76 + (progress * 0.24)).toFixed(3));
      section.style.setProperty('--nb-referral-node-opacity', (0.52 + (progress * 0.48)).toFixed(3));

      section.querySelectorAll('.nb-business-referral__card').forEach(function (card, index) {
        var stagger = index * 0.1;
        var cardProgress = reduceMotion ? 1 : clamp((progress - stagger) / 0.82, 0, 1);
        var baseShift = index === 1 ? 18 : 24;
        var baseScale = index === 1 ? 1.02 : 1;
        var liveScale = (baseScale - 0.03) + (cardProgress * 0.03);
        var hoverReady = cardProgress >= 0.9;

        card.style.setProperty('--nb-referral-card-progress', cardProgress.toFixed(3));
        card.style.setProperty('--nb-referral-card-shift', ((1 - cardProgress) * baseShift).toFixed(2) + 'px');
        card.style.setProperty('--nb-referral-card-scale', liveScale.toFixed(3));
        card.setAttribute('data-referral-hover-ready', hoverReady ? 'true' : 'false');
      });
    });
  }

  function syncCompareBadgeReveal() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.nb-business-compare-table-wrap--practices').forEach(function (compareWrap) {
      var compareTable = compareWrap.querySelector('.nb-business-compare-table');
      var featuredHeader = compareWrap.querySelector('.nb-business-compare-table thead th[data-is-featured="true"]');
      var planHeaders = compareWrap.querySelectorAll('.nb-business-compare-table thead th:not(:first-child)');
      var badge = compareWrap.querySelector('.nb-business-compare-table__header-badge--detached');
      var scrollHint = compareWrap.querySelector('.nb-business-compare-table__scroll-hint--detached');

      function syncDetachedX(node, cssVar, desiredCenter) {
        if (!node || !Number.isFinite(desiredCenter)) return;
        var baseCenter = node.offsetLeft + (node.offsetWidth / 2);
        var translateX = desiredCenter - baseCenter;
        node.style.setProperty(cssVar, translateX.toFixed(2) + 'px');
      }

      if (compareWrap && compareTable && featuredHeader) {
        var wrapRect = compareWrap.getBoundingClientRect();
        var featuredRect = featuredHeader.getBoundingClientRect();
        var featuredCenter = (featuredRect.left - wrapRect.left) + (featuredRect.width / 2);
        syncDetachedX(badge, '--nb-detached-badge-x', featuredCenter);

        if (scrollHint && planHeaders.length >= 2) {
          var starterRect = planHeaders[0].getBoundingClientRect();
          var plusRect = planHeaders[1].getBoundingClientRect();
          var starterCenter = (starterRect.left - wrapRect.left) + (starterRect.width / 2);
          var plusCenter = (plusRect.left - wrapRect.left) + (plusRect.width / 2);
          syncDetachedX(scrollHint, '--nb-detached-hint-x', (starterCenter + plusCenter) / 2);
        } else if (scrollHint) {
          scrollHint.style.setProperty('--nb-detached-hint-x', '0px');
        }
      } else {
        if (badge) badge.style.setProperty('--nb-detached-badge-x', '0px');
        if (scrollHint) scrollHint.style.setProperty('--nb-detached-hint-x', '0px');
      }

      if (!badge) return;

      if (badge.dataset.badgeRevealed === 'true') {
        badge.classList.add('is-revealed');
        return;
      }

      var rect = badge.getBoundingClientRect();
      var shouldReveal = rect.top <= viewportHeight * 0.42;

      if (reduceMotion) {
        if (shouldReveal) {
          badge.dataset.badgeRevealed = 'true';
          badge.classList.add('is-revealed');
        }
        return;
      }

      if (shouldReveal) {
        badge.dataset.badgeRevealed = 'true';
        badge.classList.add('is-revealed');
      } else {
        badge.classList.remove('is-revealed');
      }
    });
  }

  function bindPlanStage() {
    if (!document.querySelector('[data-business-plan-panel]')) return;

    var ticking = false;

    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncPlanStage();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    window.addEventListener('load', requestSync);
    window.addEventListener('hashchange', requestSync);
    window.setTimeout(requestSync, 220);
    requestSync();
  }

  function bindReferralDiagram() {
    if (!document.querySelector('.nb-business-referral')) return;

    var ticking = false;

    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncReferralDiagram();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    requestSync();
  }

  function bindCompareBadgeReveal() {
    if (!document.querySelector('.nb-business-compare-table__header-badge--detached')) return;

    var ticking = false;

    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncCompareBadgeReveal();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    document.querySelectorAll('.nb-business-compare-table').forEach(function (table) {
      table.addEventListener('scroll', requestSync, { passive: true });
    });
    requestSync();
  }

  function bindCompareWheelIntent() {
    document.querySelectorAll('.nb-business-compare-table').forEach(function (table) {
      if (table.dataset.nbCompareWheelBound === 'true') return;
      table.dataset.nbCompareWheelBound = 'true';

      table.addEventListener('wheel', function (event) {
        if (table.scrollWidth <= table.clientWidth + 1) return;

        var deltaX = Number(event.deltaX) || 0;
        var deltaY = Number(event.deltaY) || 0;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        var horizontalIntent = event.shiftKey ? absY > 0 : absX > absY && absX > 0;

        if (!horizontalIntent) return;

        var nextDelta = event.shiftKey && absX === 0 ? deltaY : deltaX;
        if (!nextDelta) return;

        var maxLeft = Math.max(0, table.scrollWidth - table.clientWidth);
        var nextLeft = Math.max(0, Math.min(maxLeft, table.scrollLeft + nextDelta));
        if (Math.abs(nextLeft - table.scrollLeft) < 1) return;

        event.preventDefault();
        table.scrollLeft = nextLeft;
      }, { passive: false });
    });
  }

  function bindTabs() {
    var tabs = document.querySelectorAll('[data-business-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setAudience(tab.getAttribute('data-business-tab') || 'teams', {
          track: true,
          interactionMethod: 'click'
        });
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var currentIndex = Array.prototype.indexOf.call(tabs, tab);
        var nextIndex = event.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1;
        if (nextIndex < 0) nextIndex = tabs.length - 1;
        if (nextIndex >= tabs.length) nextIndex = 0;
        tabs[nextIndex].focus();
        setAudience(tabs[nextIndex].getAttribute('data-business-tab') || 'teams', {
          track: true,
          interactionMethod: 'keyboard'
        });
      });
    });
  }

  function bindFaqTracking() {
    var items = document.querySelectorAll('[data-business-faq-item]');
    if (!items.length) return;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        pushBusinessEvent('business_faq_open', {
          business_audience: item.getAttribute('data-business-faq-audience') || '',
          faq_question: item.getAttribute('data-business-faq-question') || ''
        });
      });
    });
  }

  function bindDisabledLinks() {
    var disabledLinks = document.querySelectorAll('[data-business-link-disabled="true"]');
    if (!disabledLinks.length) return;

    disabledLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
      });
    });
  }

  function buildBusinessCtaEvents(type, intent) {
    var events = [];
    if (type === 'primary') events.push('business_primary_cta_click');
    if (intent === 'quote' || type === 'quote') events.push('business_quote_cta_click');
    if (type === 'trial' || intent === 'trial') events.push('business_trial_cta_click');
    if (type === 'pricing-card') events.push('business_pricing_card_cta_click');
    return events;
  }

  function bindBusinessCtaTracking() {
    var ctas = document.querySelectorAll('[data-business-cta-type]');
    if (!ctas.length) return;

    ctas.forEach(function (cta) {
      cta.addEventListener('click', function () {
        if (cta.getAttribute('aria-disabled') === 'true') return;
        if (cta.getAttribute('data-business-link-disabled') === 'true') return;

        var type = cta.getAttribute('data-business-cta-type') || '';
        var intent = cta.getAttribute('data-business-cta-intent') || '';
        var events = buildBusinessCtaEvents(type, intent);
        if (!events.length) return;

        var detail = {
          business_audience: cta.getAttribute('data-business-audience') || getPageContext() || getDefaultAudience(),
          business_cta_type: type,
          business_cta_intent: intent,
          business_cta_location: cta.getAttribute('data-business-cta-location') || '',
          business_plan_key: cta.getAttribute('data-business-plan-key') || '',
          business_cta_id: cta.getAttribute('data-nb-cta') || '',
          business_cta_label: (cta.textContent || '').trim(),
          business_cta_href: cta.getAttribute('href') || ''
        };

        events.forEach(function (eventName) {
          pushBusinessEvent(eventName, detail);
        });
      });
    });
  }

  function bindBusinessAnchorScroll() {
    var root = getRoot();
    if (!root) return;

    document.querySelectorAll('a[href*="#"]').forEach(function (link) {
      if (link.dataset.businessAnchorScrollBound === 'true') return;
      link.dataset.businessAnchorScrollBound = 'true';

      link.addEventListener('click', function (event) {
        if (link.getAttribute('aria-disabled') === 'true') return;
        if (link.getAttribute('data-business-link-disabled') === 'true') return;

        var href = link.getAttribute('href') || '';
        if (!href || href === '#') return;

        var url = null;
        try {
          url = new URL(href, window.location.href);
        } catch (error) {
          return;
        }

        if (!url.hash) return;

        var normalizePath = function (value) {
          return String(value || '').replace(/\/+$/, '') || '/';
        };

        if (url.origin !== window.location.origin) return;
        if (normalizePath(url.pathname) !== normalizePath(window.location.pathname)) return;

        var targetId = decodeURIComponent(String(url.hash).replace(/^#/, ''));
        var target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();
        var targetTop = Math.max(0, Math.round(window.scrollY + target.getBoundingClientRect().top - getBusinessAnchorScrollOffset()));
        animateBusinessAnchorScroll(targetTop, '#' + targetId);
      });
    });
  }

  function normalizeSegment(segment) {
    if (segment === 'practices') return 'practice';
    return segment;
  }

  function setRequiredState(field, shouldRequire) {
    if (!field) return;
    if (shouldRequire) {
      field.setAttribute('required', 'required');
      return;
    }
    field.removeAttribute('required');
  }

  function getPracticeQuotePlanMeta(plan) {
    switch (plan) {
      case '20plus':
      case 'group-20plus':
      case '20-plus':
        return {
          requestType: '20+ Nordbelts',
          summaryLabel: '20+ Nordbelts',
          volume: '20+ Nordbelts'
        };
      case 'multi-locatie':
      case 'multilocatie':
      case 'multiple-locations':
        return {
          requestType: 'Meerdere locaties',
          summaryLabel: 'meerdere locaties',
          volume: ''
        };
      case 'thuisvoorraad':
      case 'practice-home-stock':
      case 'home-stock':
        return {
          requestType: 'Praktijk + thuisvoorraad',
          summaryLabel: 'praktijk + thuisvoorraad',
          volume: ''
        };
      case 'uitleensets':
      case 'uitleenset':
      case 'thuispakketten':
      case 'home-kits':
        return {
          requestType: 'Uitleensets / thuispakketten',
          summaryLabel: 'uitleensets of thuispakketten',
          volume: ''
        };
      case 'workshop':
      case 'onboarding':
      case 'workshop-onboarding':
        return {
          requestType: 'Workshop / onboarding',
          summaryLabel: 'workshop of onboarding',
          volume: ''
        };
      case 'start':
        return {
          requestType: '',
          summaryLabel: '4 Nordbelts',
          volume: '4 Nordbelts'
        };
      case 'praktijk':
        return {
          requestType: '',
          summaryLabel: '8 Nordbelts',
          volume: '8 Nordbelts'
        };
      case 'partner':
        return {
          requestType: '',
          summaryLabel: '12 Nordbelts',
          volume: '12 Nordbelts'
        };
      case 'netwerk':
        return {
          requestType: '',
          summaryLabel: 'grotere uitrol',
          volume: '32+ Nordbelts'
        };
      default:
        return {
          requestType: '',
          summaryLabel: '',
          volume: ''
        };
    }
  }

  function getPracticeQuoteRequestType(plan) {
    return getPracticeQuotePlanMeta(plan).requestType || '';
  }

  function buildQuotePrefillCopy(segment, plan) {
    var normalizedSegment = normalizeSegment(segment);
    var segmentLabel = normalizedSegment === 'teams' ? 'Teams & clubs' : 'Fysiopraktijken';
    var planConfig = quotePrefillConfig[normalizedSegment] && quotePrefillConfig[normalizedSegment][plan];
    var practicePlanMeta = normalizedSegment === 'practice' ? getPracticeQuotePlanMeta(plan) : null;
    if (!planConfig) return null;

    var summary = 'Je komt binnen via ' + segmentLabel + ' en vraagt nu informatie aan over ' + planConfig.label + ' (' + planConfig.volume + ').';
    var message = 'Aanvraag via business pricing pagina.\nSegment: ' + segmentLabel + '\nPakket: ' + planConfig.label + '\nGewenste staffel: ' + planConfig.volume + '\n\nExtra context:';
    var requestType = '';

    if (normalizedSegment === 'practice') {
      var summaryLabel = practicePlanMeta && practicePlanMeta.summaryLabel ? practicePlanMeta.summaryLabel : planConfig.label;
      var volume = practicePlanMeta && practicePlanMeta.volume ? practicePlanMeta.volume : planConfig.volume;
      summary = 'Je vraagt een praktijkofferte aan voor ' + summaryLabel + (volume ? ' (' + volume + ')' : '') + '.';
      message = '';
      requestType = getPracticeQuoteRequestType(plan);
      planConfig = {
        label: planConfig.label,
        volume: volume
      };
    }

    return {
      subjectSuffix: segmentLabel + ' | ' + planConfig.label,
      summary: summary,
      volume: planConfig.volume,
      message: message,
      messagePlaceholder: normalizedSegment === 'practice'
        ? 'Vertel kort wat je wilt uitrollen, voor hoeveel kamers, therapeuten of locaties, en of thuiscontinuatie of onboarding meespeelt.'
        : undefined,
      requestType: requestType
    };
  }

  function buildTrialPrefillCopy(segment) {
    var normalizedSegment = normalizeSegment(segment);
    var segmentLabel = normalizedSegment === 'teams' ? 'Teams & clubs' : 'Fysiopraktijken';
    var trialLabel = normalizedSegment === 'teams' ? '1 demo-unit' : '1 proef-Nordbelt';
    var pricingConfig = readBusinessPricingConfig();
    var trialPricing = pricingConfig && pricingConfig.shared && pricingConfig.shared.trial || null;
    var trialPriceKnown = Boolean(trialPricing && trialPricing.priceCents !== null && trialPricing.priceCents !== undefined);
    var trialHasNoProductCost = trialPriceKnown && Number(trialPricing.priceCents) === 0;
    var trialPaymentCopy = trialHasNoProductCost
      ? 'Je betaalt alleen de verzendkosten.'
      : trialPricing && trialPricing.priceFormatted
        ? 'De actuele productprijs is ' + trialPricing.priceFormatted + '; verzendkosten worden bij checkout berekend.'
        : 'De actuele productprijs en verzendkosten worden bij checkout getoond.';
    var trialPricePoint = trialHasNoProductCost
      ? 'Alleen verzendkosten'
      : trialPricing && trialPricing.priceFormatted
        ? 'Productprijs ' + trialPricing.priceFormatted
        : 'Actuele prijs in checkout';

    return {
      subjectSuffix: segmentLabel + ' | ' + trialLabel,
      lead: normalizedSegment === 'teams'
        ? 'Vraag een demo-unit aan voor staff of één atleet. ' + trialPaymentCopy + ' We beoordelen iedere aanvraag handmatig.'
        : 'Vraag een proef-Nordbelt aan voor gebruik in de behandelkamer. ' + trialPaymentCopy + ' We beoordelen iedere aanvraag handmatig.',
      summaryTitle: normalizedSegment === 'teams' ? 'Demo-aanvraag teams' : 'Proefaanvraag fysiopraktijk',
      summary: normalizedSegment === 'teams'
        ? 'Je vraagt 1 demo-unit aan voor een team-, staff- of pilotmoment.'
        : 'Je vraagt 1 proef-Nordbelt aan om de setup eerst in behandeling te testen.',
      points: [
        'Één aanvraag per organisatie',
        trialPricePoint,
        'Geen retour nodig'
      ],
      messageLabel: 'Kwalificatie en toelichting',
      messagePlaceholder: normalizedSegment === 'teams'
        ? 'Beschrijf kort hoe je Nordbelt wilt testen, met wie en wat een logische vervolgstaffel zou zijn.'
        : 'Beschrijf kort hoe je Nordbelt in de behandelkamer wilt testen en hoe je het daarna mogelijk wilt opschalen.',
      message: 'Trial-aanvraag via business pricing pagina.\nSegment: ' + segmentLabel + '\nGewenst: ' + trialLabel + '\n\nBeoogd gebruik en context:',
      submitLabel: normalizedSegment === 'teams' ? 'Demo-unit aanvragen' : 'Proef-Nordbelt aanvragen'
    };
  }

  function setFlowVisibility(flow) {
    var normalizedFlow = flow === 'trial' ? 'trial' : 'quote';
    document.querySelectorAll('[data-business-flow-only]').forEach(function (node) {
      var nodeFlow = node.getAttribute('data-business-flow-only') || '';
      var shouldShow = nodeFlow === normalizedFlow;
      node.hidden = !shouldShow;
      node.querySelectorAll('[data-business-required-for]').forEach(function (field) {
        setRequiredState(field, shouldShow && field.getAttribute('data-business-required-for') === normalizedFlow);
      });
    });
  }

  function getPracticeQuoteMeta() {
    var node = document.querySelector('[data-practice-trial-cart-url]');
    return {
      trialUrl: node && node.getAttribute('data-practice-trial-cart-url') || '/products/proef-nordbelt-voor-fysiopraktijken',
      practicePageUrl: node && node.getAttribute('data-practice-page-url') || '/pages/fysiopraktijken',
      practicePlansUrl: node && node.getAttribute('data-practice-plans-url') || '/pages/fysiopraktijken#business-pricing-plans'
    };
  }

  function applyPracticeRouteChrome(mode) {
    var isTrial = mode === 'trial';
    var body = document.body;
    var locale = getPracticeB2BLocaleBase();
    var medicalProofCopy = locale === 'et'
      ? 'Kujundatud koostöös meditsiinispetsialistidega'
      : 'Ontwikkeld in Nederland met medische professionals';
    if (body) {
      body.setAttribute('data-b2b-layout', 'true');
      body.setAttribute('data-b2b-context', isTrial ? 'practice-trial' : 'practice-quote');
      body.setAttribute('data-practice-funnel', 'true');
      body.setAttribute('data-quote-segment', 'practice');
      body.classList.add('nb-theme--b2b', 'nb-theme--practice-funnel');
    }

    var announcementText = document.querySelector('.nb-announcement__inner span');
    if (announcementText) {
      announcementText.textContent = medicalProofCopy;
    }

    var header = document.querySelector('[data-nb-header]');
    if (!header) return;

    header.classList.add('nb-header--business');
    header.setAttribute('data-nb-header-business', 'true');

    header.querySelectorAll('[data-b2b-nav="practices"], [data-nb-cta="header_practices_link"]').forEach(function (link) {
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'page');
    });

    var practicesCard = header.querySelector('[data-nb-cta="header_panel_practices"]');
    if (practicesCard) {
      practicesCard.classList.add('is-featured');
    }

    var microproof = header.querySelector('.nb-header__microproof');
    if (!microproof) return;

    microproof.classList.add('nb-header__microproof--business');
    microproof.setAttribute('aria-label', 'Zakelijke context');

    var pills = microproof.querySelectorAll('.nb-header__microproof-pill');
    if (!pills.length) return;

    for (var index = 1; index < pills.length; index += 1) {
      pills[index].remove();
    }

    var firstPill = pills[0];
    var pillText = firstPill.querySelector('span:last-child');
    if (pillText) {
      pillText.textContent = medicalProofCopy;
    }
  }

  function hidePracticeQuoteChrome(shell) {
    if (!shell) return;

    var rte = shell.querySelector('.nb-page-shell__rte');
    var links = shell.querySelector('.nb-page-links');
    if (rte) rte.hidden = true;
    if (links) links.hidden = true;
  }

  function hideQuoteRow(form, fieldId) {
    if (!form) return;
    var field = form.querySelector('#' + fieldId);
    if (!field) return;

    var row = field.closest('.nb-page-form__row');
    if (!row) return;

    row.hidden = true;
    row.style.display = 'none';
    row.querySelectorAll('input, textarea, select').forEach(function (input) {
      input.disabled = true;
      input.removeAttribute('required');
    });
  }

  function insertPracticeRowAfter(targetRow, rowId, labelText, fieldHtml) {
    if (!targetRow || !targetRow.parentNode) return null;

    var existing = targetRow.parentNode.querySelector('#' + rowId);
    if (existing) {
      return existing.closest('.nb-page-form__row');
    }

    var row = document.createElement('div');
    row.className = 'nb-page-form__row';
    row.innerHTML = '<label for="' + rowId + '">' + labelText + '</label>' + fieldHtml;
    targetRow.insertAdjacentElement('afterend', row);
    return row;
  }

  function applyPracticeQuoteVariant(plan) {
    var shell = document.querySelector('.nb-page-shell--quote');
    if (!shell) return;

    applyPracticeRouteChrome('quote');
    hidePracticeQuoteChrome(shell);

    var title = shell.querySelector('.nb-page-shell__title');
    if (title) {
      title.textContent = 'Vraag een offerte aan voor 20+ Nordbelts of meerdere locaties';
    }

    var block = shell.querySelector('.nb-page-block');
    if (!block) return;
    block.classList.add('nb-page-block--practice-quote');

    var lead = block.querySelector('[data-business-request-lead]');
    if (lead) {
      lead.textContent = 'Voor praktijken, sportmedische centra en sportartsen die Nordbelt willen uitrollen per kamer, team of locatie. Laat kort weten wat je nodig hebt; we stemmen de rest daarna samen af.';
    }
    var summaryTitle = block.querySelector('[data-business-request-summary-title]');
    if (summaryTitle) {
      summaryTitle.textContent = 'Geselecteerde route';
    }

    var microcopy = block.querySelector('.nb-page-block__microcopy');
    if (!microcopy && lead && lead.parentNode) {
      microcopy = document.createElement('p');
      microcopy.className = 'nb-page-block__microcopy';
      lead.insertAdjacentElement('afterend', microcopy);
    }
    if (microcopy) {
      microcopy.textContent = 'Reactie doorgaans binnen 1 werkdag';
    }

    var form = block.querySelector('form.nb-page-form');
    if (!form) return;

    form.classList.add('nb-page-form--practice-quote');

    var subject = form.querySelector('input[name="contact[subject]"]');
    if (subject) {
      subject.value = 'Offerte aanvraag Nordbelt | Praktijk 20+ / maatwerk';
    }

    var flowInput = form.querySelector('#QuoteFlow');
    var segmentInput = form.querySelector('#QuoteSegment');
    var planInput = form.querySelector('#QuotePlan');
    if (flowInput) flowInput.value = 'quote';
    if (segmentInput) segmentInput.value = 'practice';
    if (planInput && plan && !planInput.value) planInput.value = plan;

    var companyInput = form.querySelector('#QuoteCompany');
    var companyRow = companyInput && companyInput.closest('.nb-page-form__row');
    var nameInput = form.querySelector('#QuoteName');
    var nameRow = nameInput && nameInput.closest('.nb-page-form__row');
    if (nameRow) {
      var nameLabel = nameRow.querySelector('label');
      if (nameLabel) nameLabel.textContent = 'Naam';
    }
    var emailInput = form.querySelector('#QuoteEmail');
    var emailRow = emailInput && emailInput.closest('.nb-page-form__row');
    if (emailRow) {
      var emailLabel = emailRow.querySelector('label');
      if (emailLabel) emailLabel.textContent = 'Zakelijk e-mailadres';
    }
    if (companyInput && companyRow) {
      var companyLabel = companyRow.querySelector('label');
      if (companyLabel) companyLabel.textContent = 'Praktijk / organisatie';
    }

    var phoneRow = insertPracticeRowAfter(
      companyRow,
      'QuotePhone',
      'Telefoon (optioneel)',
      '<input id="QuotePhone" type="tel" name="contact[phone]">'
    );
    var requestTypeRow = insertPracticeRowAfter(
      phoneRow || companyRow,
      'PracticeQuoteRequestType',
      'Type aanvraag',
      '<select id="PracticeQuoteRequestType" name="contact[type_aanvraag]" required>' +
        '<option value="">Kies een aanvraagtype</option>' +
        '<option value="20+ Nordbelts">20+ Nordbelts</option>' +
        '<option value="Meerdere locaties">Meerdere locaties</option>' +
        '<option value="Praktijk + thuisvoorraad">Praktijk + thuisvoorraad</option>' +
        '<option value="Uitleensets / thuispakketten">Uitleensets / thuispakketten</option>' +
        '<option value="Workshop / onboarding">Workshop / onboarding</option>' +
        '<option value="Anders">Anders</option>' +
      '</select>'
    );

    var volumeInput = form.querySelector('#QuoteVolume');
    var volumeRow = volumeInput && volumeInput.closest('.nb-page-form__row');
    if (volumeRow) {
      var volumeLabel = volumeRow.querySelector('label');
      if (volumeLabel) volumeLabel.textContent = 'Gewenst aantal';
      volumeInput.setAttribute('placeholder', 'Bijv. 20, 24 of 40 Nordbelts');
    }

    insertPracticeRowAfter(
      volumeRow || requestTypeRow,
      'PracticeQuoteLocations',
      'Aantal locaties (optioneel)',
      '<input id="PracticeQuoteLocations" type="text" name="contact[aantal_locaties]" placeholder="Bijv. 2 of 5 locaties">'
    );

    ['QuoteRole', 'QuoteWebsite', 'QuoteCountry', 'QuoteShipping', 'QuoteFutureQuantity', 'QuoteUse'].forEach(function (fieldId) {
      hideQuoteRow(form, fieldId);
    });

    var messageLabel = form.querySelector('[data-business-message-label]');
    var messageInput = form.querySelector('#QuoteMessage');
    if (messageLabel) {
      messageLabel.textContent = 'Korte toelichting';
    }
    if (messageInput) {
      messageInput.setAttribute('placeholder', 'Vertel kort wat je wilt uitrollen, voor hoeveel kamers, therapeuten of locaties, en of thuiscontinuatie of onboarding meespeelt.');
    }

    var submitButton = form.querySelector('[data-business-request-submit]');
    if (submitButton) {
      submitButton.textContent = 'Vraag offerte aan';
      submitButton.setAttribute('data-nb-cta', 'practice_quote_submit');
      submitButton.setAttribute('data-business-cta-type', 'primary');
      submitButton.setAttribute('data-business-cta-intent', 'quote');
      submitButton.setAttribute('data-business-cta-location', 'practice-quote-page');
      submitButton.setAttribute('data-business-audience', 'practices');
    }

    var scopeCard = block.querySelector('.nb-page-mini-card--practice-scope');
    if (!scopeCard) {
      scopeCard = document.createElement('div');
      scopeCard.className = 'nb-page-mini-card nb-page-mini-card--practice-scope';
      scopeCard.innerHTML =
        '<h3>Geschikt voor grotere praktijkuitrol</h3>' +
        '<ul class="nb-page-mini-card__list">' +
          '<li>20+ Nordbelts</li>' +
          '<li>Meerdere locaties</li>' +
          '<li>Praktijk + thuisvoorraad</li>' +
          '<li>Uitleensets / thuispakketten</li>' +
          '<li>Workshop / onboarding</li>' +
        '</ul>';
      if (microcopy) {
        microcopy.insertAdjacentElement('afterend', scopeCard);
      } else if (lead) {
        lead.insertAdjacentElement('afterend', scopeCard);
      }
    }

    var meta = getPracticeQuoteMeta();
    var returnCard = block.querySelector('.nb-page-mini-card--practice-return');
    if (!returnCard) {
      returnCard = document.createElement('div');
      returnCard.className = 'nb-page-mini-card nb-page-mini-card--practice-return';
      block.appendChild(returnCard);
    }
    returnCard.innerHTML =
      '<h3>Liever eerst testen?</h3>' +
      '<p>Bestel eerst een proef-Nordbelt of start met een kleiner pakket vanaf de praktijkpagina. Schaal daarna op zodra Nordbelt goed in je praktijkflow zit.</p>' +
      '<div class="nb-page-cta-row">' +
        '<a class="nb-button nb-button--secondary" href="' + meta.practicePageUrl + '" data-nb-cta="practice_quote_back_to_page" data-business-cta-type="secondary" data-business-cta-intent="back-to-page" data-business-cta-location="practice-quote-page" data-business-audience="practices">Terug naar praktijkpagina</a>' +
        '<a class="nb-button" href="' + meta.trialUrl + '" data-nb-cta="practice_quote_trial_direct_order" data-business-cta-type="primary" data-business-cta-intent="buy" data-business-cta-location="practice-quote-page" data-business-audience="practices">Bestel proef-Nordbelt</a>' +
      '</div>';
  }

  function applyPracticeTrialVariant() {
    var shell = document.querySelector('.nb-page-shell--quote');
    if (!shell) return;

    applyPracticeRouteChrome('trial');
    hidePracticeQuoteChrome(shell);

    var title = shell.querySelector('.nb-page-shell__title');
    if (title) {
      title.textContent = 'Test Nordbelt eerst in je eigen praktijk';
    }

    var block = shell.querySelector('.nb-page-block');
    if (!block) return;

    var meta = getPracticeQuoteMeta();
    block.className = 'nb-page-block nb-page-block--practice-trial';
    block.innerHTML =
      '<p class="nb-page-block__lead">Bestel 1 proef-Nordbelt, test hem in behandeling en schaal daarna op per kamer of team.</p>' +
      '<div class="nb-page-mini-card nb-page-mini-card--practice-trial">' +
        '<ul class="nb-page-mini-card__list">' +
          '<li>1 proef-Nordbelt</li>' +
          '<li>Verzendkosten worden berekend bij checkout</li>' +
          '<li>Schaal daarna op naar een passende staffel</li>' +
          '<li>Direct inzetbaar in behandeling en thuisuitleg</li>' +
        '</ul>' +
      '</div>' +
      '<div class="nb-page-cta-row">' +
        '<a class="nb-button" href="' + meta.trialUrl + '" data-nb-cta="practice_quote_trial_direct_order" data-business-cta-type="primary" data-business-cta-intent="buy" data-business-cta-location="practice-trial-page" data-business-audience="practices">Bestel proef-Nordbelt</a>' +
        '<a class="nb-button nb-button--secondary" href="' + meta.practicePlansUrl + '" data-nb-cta="practice_quote_trial_back_to_plans" data-business-cta-type="secondary" data-business-cta-intent="view-plans" data-business-cta-location="practice-trial-page" data-business-audience="practices">Bekijk praktijkpakketten</a>' +
      '</div>' +
      '<p class="nb-page-block__microcopy">Geen uitgebreide offerte nodig om te testen</p>';
  }

	  function initQuotePrefill() {
	    var path = (window.location.pathname || '').toLowerCase();
	    if (path.indexOf('/pages/request-a-quote') === -1) return;

    var params = new URLSearchParams(window.location.search || '');
    var flow = (params.get('flow') || 'quote').toLowerCase();
    var segment = normalizeSegment((params.get('segment') || '').toLowerCase());
    var plan = (params.get('plan') || '').toLowerCase();
    var normalizedFlow = flow === 'trial' ? 'trial' : 'quote';

    var config = null;
    if (normalizedFlow === 'trial') {
      if (!segment) segment = 'practice';
      config = buildTrialPrefillCopy(segment);
    } else if (segment && plan) {
      config = buildQuotePrefillCopy(segment, plan);
    } else if (segment) {
      config = {
        subjectSuffix: (segment === 'teams' ? 'Teams & clubs' : 'Fysiopraktijken') + ' | Zakelijke aanvraag',
        summary: 'Je vraagt meer informatie aan voor een zakelijke Nordbelt-uitrol.',
        volume: '',
        message: 'Aanvraag via business pricing pagina.\nSegment: ' + (segment === 'teams' ? 'Teams & clubs' : 'Fysiopraktijken') + '\n\nExtra context:'
      };
    }

    if (segment === 'practice' && normalizedFlow === 'trial') {
      applyPracticeTrialVariant();
      return;
    }

    if (segment === 'practice') {
      applyPracticeQuoteVariant(plan);
    }

    setFlowVisibility(normalizedFlow);

    var summary = document.querySelector('[data-business-quote-prefill-summary]');
    var summaryTitle = document.querySelector('[data-business-request-summary-title]');
    var summaryCopy = document.querySelector('[data-business-quote-prefill-copy]');
    var summaryPoints = document.querySelector('[data-business-request-summary-points]');
    var lead = document.querySelector('[data-business-request-lead]');
    var subject = document.querySelector('input[name="contact[subject]"]');
    var flowInput = document.getElementById('QuoteFlow');
    var segmentInput = document.getElementById('QuoteSegment');
    var planInput = document.getElementById('QuotePlan');
    var volumeInput = document.getElementById('QuoteVolume');
    var messageInput = document.getElementById('QuoteMessage');
    var messageLabel = document.querySelector('[data-business-message-label]');
    var submitButton = document.querySelector('[data-business-request-submit]');
    var requestTypeInput = document.getElementById('PracticeQuoteRequestType');

    if (flowInput) flowInput.value = normalizedFlow;
    if (segmentInput) segmentInput.value = segment || '';
    if (planInput) planInput.value = plan || '';

    if (!config) return;

    if (summary && summaryCopy) {
      summary.hidden = false;
      if (summaryTitle && config.summaryTitle) {
        summaryTitle.textContent = config.summaryTitle;
      }
      summaryCopy.textContent = config.summary;
      if (summaryPoints) {
        summaryPoints.innerHTML = '';
        if (Array.isArray(config.points) && config.points.length) {
          config.points.forEach(function (item) {
            var li = document.createElement('li');
            li.textContent = item;
            summaryPoints.appendChild(li);
          });
          summaryPoints.hidden = false;
        } else {
          summaryPoints.hidden = true;
        }
      }
    }

    if (lead && config.lead) {
      lead.textContent = config.lead;
    }

    if (subject) {
      var baseSubject = subject.getAttribute('data-base-subject') || subject.value;
      subject.setAttribute('data-base-subject', baseSubject);
      subject.value = baseSubject + ' | ' + config.subjectSuffix;
    }

    if (volumeInput && !volumeInput.value) {
      volumeInput.value = config.volume;
    }

    if (requestTypeInput && config.requestType && !requestTypeInput.value) {
      requestTypeInput.value = config.requestType;
    }

    if (messageLabel && config.messageLabel) {
      messageLabel.textContent = config.messageLabel;
    }

    if (messageInput && !messageInput.value) {
      messageInput.value = config.message;
    }

    if (messageInput && config.messagePlaceholder) {
      messageInput.setAttribute('placeholder', config.messagePlaceholder);
    }

    if (submitButton && config.submitLabel) {
      submitButton.textContent = config.submitLabel;
	    }
	  }

	  var businessPricingConfigCache = undefined;

	  function readBusinessPricingConfig() {
	    if (businessPricingConfigCache !== undefined) return businessPricingConfigCache;

	    var script = document.querySelector('script[data-business-pricing-config]');
	    if (!script) {
	      businessPricingConfigCache = null;
	      return businessPricingConfigCache;
	    }

	    try {
	      businessPricingConfigCache = JSON.parse(script.textContent || '{}');
	    } catch (error) {
	      businessPricingConfigCache = null;
	    }

	    if (businessPricingConfigCache) {
	      if (
	        businessPricingConfigCache.practicePricing &&
	        !businessPricingConfigCache.practicePricing.packages &&
	        Array.isArray(businessPricingConfigCache.practicePricing.pakette)
	      ) {
	        businessPricingConfigCache.practicePricing.packages = businessPricingConfigCache.practicePricing.pakette;
	      }
	      window.NordbeltBusinessPricingConfig = businessPricingConfigCache;
	      if (businessPricingConfigCache.practicePricing) {
	        window.NordbeltPracticeB2BPricing = businessPricingConfigCache.practicePricing;
	      }
	    }

	    return businessPricingConfigCache;
	  }

	  function getPracticePricingConfig() {
	    var config = readBusinessPricingConfig();
	    return config && config.practicePricing ? config.practicePricing : null;
	  }

	  function getBusinessPricingCurrency() {
	    var config = readBusinessPricingConfig();
	    return String(
	      config && config.currency ||
	      window.Shopify && window.Shopify.currency && window.Shopify.currency.active ||
	      ''
	    ).toUpperCase();
	  }

	  function formatPracticeB2BCents(cents) {
	    var value = Number(cents);
	    if (!Number.isFinite(value)) return getPracticeB2BText('unavailable');
	    var currency = getBusinessPricingCurrency();
	    var locale = document.documentElement.getAttribute('lang') || navigator.language || 'nl-NL';
	    if (!currency) return (value / 100).toFixed(2);

	    try {
	      return new Intl.NumberFormat(locale, {
	        style: 'currency',
	        currency: currency,
	        minimumFractionDigits: 2,
	        maximumFractionDigits: 2
	      }).format(value / 100);
	    } catch (error) {
	      return currency + ' ' + (value / 100).toFixed(2);
	    }
	  }

	  function calculatePracticeB2BPackage(config, packageConfig, useVatCorrection) {
	    var patientPriceCents = Number(config && config.patientPriceCents);
	    var packagePriceCents = Number(packageConfig && packageConfig.priceCents);
	    var quantity = Number(packageConfig && packageConfig.quantity);
	    var vatRate = Number(config && config.vatRate) || 1.21;
	    var sourceCompareAtCents = Number(packageConfig && packageConfig.compareAtCents);
	    var sourceUnitCostCents = Number(packageConfig && packageConfig.unitCostCents);
	    var sourceMarginCents = Number(packageConfig && packageConfig.marginCents);
	    var sourceMarginPerUnitCents = Number(packageConfig && packageConfig.marginPerUnitCents);
	    var sourceRevenueCents = Number(packageConfig && packageConfig.revenueCents);

	    if (
	      !Number.isFinite(patientPriceCents) ||
	      !Number.isFinite(packagePriceCents) ||
	      !Number.isFinite(quantity) ||
	      patientPriceCents <= 0 ||
	      packagePriceCents <= 0 ||
	      quantity <= 0
	    ) {
	      return null;
	    }

	    var unitCost = Number.isFinite(sourceUnitCostCents) && sourceUnitCostCents > 0
	      ? sourceUnitCostCents
	      : packagePriceCents / quantity;
	    var revenueWithoutVat = Number.isFinite(sourceRevenueCents) && sourceRevenueCents > 0
	      ? sourceRevenueCents
	      : Number.isFinite(sourceCompareAtCents) && sourceCompareAtCents > 0
	        ? sourceCompareAtCents
	        : patientPriceCents * quantity;
	    var marginWithoutVat = Number.isFinite(sourceMarginCents) && sourceMarginCents > 0
	      ? sourceMarginCents
	      : revenueWithoutVat - packagePriceCents;
	    var marginPerUnitWithoutVat = Number.isFinite(sourceMarginPerUnitCents) && sourceMarginPerUnitCents > 0
	      ? sourceMarginPerUnitCents
	      : marginWithoutVat / quantity;
	    var netPatientPriceWithVat = patientPriceCents / vatRate;
	    var revenueWithVat = netPatientPriceWithVat * quantity;
	    var marginWithVat = revenueWithVat - packagePriceCents;
	    var marginPerUnitWithVat = marginWithVat / quantity;

	    return {
	      unitCost: unitCost,
	      packagePrice: packagePriceCents,
	      revenue: useVatCorrection ? revenueWithVat : revenueWithoutVat,
	      margin: useVatCorrection ? marginWithVat : marginWithoutVat,
	      marginPerUnit: useVatCorrection ? marginPerUnitWithVat : marginPerUnitWithoutVat,
	      netPatientPriceWithVat: netPatientPriceWithVat,
	      revenueWithoutVat: revenueWithoutVat,
	      marginWithoutVat: marginWithoutVat,
	      marginPerUnitWithoutVat: marginPerUnitWithoutVat,
	      revenueWithVat: revenueWithVat,
	      marginWithVat: marginWithVat,
	      marginPerUnitWithVat: marginPerUnitWithVat
	    };
	  }

	  window.NordbeltPracticeB2BTools = {
	    formatCents: formatPracticeB2BCents,
	    calculatePackage: calculatePracticeB2BPackage
	  };

	  function getPracticeB2BPackageShortLabel(packageConfig) {
	    var quantity = Number(packageConfig && packageConfig.quantity);
	    var key = String(packageConfig && packageConfig.key || '');
	    if (key.indexOf('20plus') !== -1 || quantity >= 20) return '20+';
	    if (quantity > 0) return quantity + '-pack';
	    return packageConfig && packageConfig.label ? packageConfig.label : getPracticeB2BText('packageFallback');
	  }

	  function getPracticeB2BPackageName(packageConfig) {
	    var shortLabel = getPracticeB2BPackageShortLabel(packageConfig);
	    var label = packageConfig && packageConfig.label ? packageConfig.label : '';
	    if (!label || label === shortLabel) return shortLabel;
	    return shortLabel + ' - ' + label;
	  }

	  function getPracticeB2BPatientPriceLabel(config) {
	    if (config && config.patientPriceFormatted) return config.patientPriceFormatted;
	    if (config && Number.isFinite(Number(config.patientPriceCents)) && Number(config.patientPriceCents) > 0) {
	      return formatPracticeB2BCents(config.patientPriceCents);
	    }
	    return getPracticeB2BText('currentNordbeltPrice');
	  }

	  function getPracticeB2BUnavailableMessage() {
	    return getPracticeB2BText('unavailable');
	  }

	  var practiceB2BStaffelStorageKey = 'nordbelt_practice_staffel_context_v1';

	  function sanitizePracticeB2BStaffelValue(value, maxLength) {
	    var clean = String(value == null ? '' : value)
	      .replace(/[\u0000-\u001F\u007F]/g, ' ')
	      .replace(/[<>]/g, '')
	      .replace(/\s+/g, ' ')
	      .trim();
	    var limit = Number(maxLength) || 120;
	    return clean.slice(0, limit);
	  }

	  function getPracticeB2BRoomLabel(value) {
	    return String(value) === '4' ? '4+' : String(value || '1');
	  }

	  function getPracticeB2BTherapistLabel(value) {
	    var labels = {
	      '1': '1-2',
	      '2': '3-4',
	      '4': '5-8',
	      '5': '9+'
	    };
	    return labels[String(value)] || String(value || '1-2');
	  }

	  function getPracticeB2BLocationLabel(value) {
	    if (value === '3plus') return getPracticeB2BText('locationThreePlus');
	    if (value === '2') return getPracticeB2BText('locationTwo');
	    return getPracticeB2BText('locationOne');
	  }

	  function getPracticeB2BMonthlyPatientsLabel(value) {
	    var labels = {
	      '0-2': '0-2',
	      '3-5': '3-5',
	      '6-10': '6-10',
	      '10plus': '10+'
	    };
	    return labels[String(value)] || String(value || '');
	  }

	  function getPracticeB2BIssueModelLabel(value) {
	    var labels = {
	      sell: getPracticeB2BText('issueSell'),
	      include: getPracticeB2BText('issueInclude'),
	      lend: getPracticeB2BText('issueLend'),
	      mixed: getPracticeB2BText('issueMixed'),
	      'practice-only': getPracticeB2BText('issuePracticeOnly')
	    };
	    return labels[String(value)] || String(value || '');
	  }

	  var practiceB2BTrackingOnceKeys = {};
	  var practiceB2BTrackingKeys = [
	    'recommended_pack',
	    'practice_sets',
	    'patient_sets',
	    'reserve_sets',
	    'vat_toggle',
	    'estimated_margin',
	    'issue_model',
	    'locations',
	    'monthly_patients_range',
	    'business_cta_location',
	    'business_plan_key',
	    'practice_event_trigger',
	    'quote_flow',
	    'item_name',
	    'item_id',
	    'variant_id',
	    'package_size',
	    'price',
	    'currency',
	    'value',
	    'content_type'
	  ];

	  function normalizePracticeB2BRecommendedPack(value) {
	    var text = sanitizePracticeB2BStaffelValue(value, 40).toLowerCase();
	    if (text.indexOf('20+') !== -1 || text.indexOf('20plus') !== -1) return '20+';
	    if (text.indexOf('12') !== -1) return '12';
	    if (text.indexOf('8') !== -1) return '8';
	    if (text.indexOf('4') !== -1) return '4';
	    return sanitizePracticeB2BStaffelValue(value, 40);
	  }

	  function parsePracticeB2BTrackingMoneyCents(value) {
	    if (typeof value === 'number' && Number.isFinite(value)) return Math.round(value);
	    var text = sanitizePracticeB2BStaffelValue(value, 80);
	    if (!/[0-9]/.test(text)) return '';
	    if (/[^0-9\s-]/.test(text)) {
	      var normalized = text.replace(/[^0-9,.-]/g, '');
	      var comma = normalized.lastIndexOf(',');
	      var dot = normalized.lastIndexOf('.');
	      var decimalAt = Math.max(comma, dot);
	      if (decimalAt > -1) {
	        normalized = normalized.slice(0, decimalAt).replace(/[.,]/g, '') + '.' + normalized.slice(decimalAt + 1).replace(/[.,]/g, '');
	      }
	      var majorUnits = Number(normalized);
	      return Number.isFinite(majorUnits) ? Math.round(majorUnits * 100) : '';
	    }
	    var cents = Number(text.replace(/[^0-9.-]/g, ''));
	    return Number.isFinite(cents) ? Math.round(cents) : '';
	  }

	  function normalizePracticeB2BTrackingValue(key, value) {
	    if (value == null || value === '') return '';
	    if (key === 'recommended_pack') return normalizePracticeB2BRecommendedPack(value);
	    if (key === 'vat_toggle') {
	      return value === true || value === 'true' || value === 'aan' || value === 'on';
	    }
	    if (key === 'estimated_margin') {
	      return parsePracticeB2BTrackingMoneyCents(value);
	    }
	    if (key === 'price' || key === 'value') {
	      var amount = Number(value);
	      if (Number.isFinite(amount)) return Number(Math.max(0, amount).toFixed(2));
	    }
	    if (key === 'practice_sets' || key === 'patient_sets' || key === 'reserve_sets' || key === 'estimated_margin') {
	      if (typeof value === 'number' && Number.isFinite(value)) return Math.round(value);
	      var numeric = Number(String(value).replace(/[^0-9.-]/g, ''));
	      if (Number.isFinite(numeric)) return Math.round(numeric);
	    }
	    return sanitizePracticeB2BStaffelValue(value, 120);
	  }

	  function normalizePracticeB2BTrackingPayload(detail) {
	    var source = detail || {};
	    var payload = {
	      page_type: 'fysiopraktijken',
	      audience: 'fysiopraktijk',
	      business_audience: 'practices',
	      business_page_context: getPageContext() || 'practices'
	    };

	    practiceB2BTrackingKeys.forEach(function (key) {
	      if (!Object.prototype.hasOwnProperty.call(source, key)) return;
	      var value = normalizePracticeB2BTrackingValue(key, source[key]);
	      if (value === '') return;
	      payload[key] = value;
	    });

	    return payload;
	  }

	  function pushPracticeB2BTrackingEvent(eventName, detail) {
	    if (!eventName) return '';

	    var payload = Object.assign(
	      { event: sanitizePracticeB2BStaffelValue(eventName, 80) },
	      normalizePracticeB2BTrackingPayload(detail)
	    );
	    if (detail && typeof detail === 'object') {
	      ['ecommerce', 'items', 'content_ids'].forEach(function (key) {
	        if (detail[key] == null || detail[key] === '') return;
	        payload[key] = detail[key];
	      });
	    }

	    try {
	      if (window.NordbeltTheme && typeof window.NordbeltTheme.pushEvent === 'function') {
	        return window.NordbeltTheme.pushEvent(payload);
	      }
	    } catch (error) {
	      // Tracking should never block the page flow.
	    }

	    try {
	      window.dataLayer = window.dataLayer || [];
	      if (typeof window.dataLayer.push === 'function') {
	        window.dataLayer.push(payload);
	      }
	    } catch (error) {
	      // no-op
	    }

	    return '';
	  }

	  function pushPracticeB2BTrackingEventOnce(eventName, detail, onceKey) {
	    var key = sanitizePracticeB2BStaffelValue(onceKey || eventName, 120);
	    if (key && practiceB2BTrackingOnceKeys[key]) return '';
	    if (key) practiceB2BTrackingOnceKeys[key] = true;
	    return pushPracticeB2BTrackingEvent(eventName, detail);
	  }

	  function buildPracticeB2BAdviceTrackingPayload(advice, calculation, useVatCorrection, estimatedMargin) {
	    if (!advice) {
	      return {
	        vat_toggle: Boolean(useVatCorrection)
	      };
	    }

	    var recommendedPack = advice.adviceKey === 'group-20plus' ? '20+' : String(advice.recommendedQty || advice.adviceKey || '');
	    var marginValue = Number.isFinite(Number(estimatedMargin))
	      ? Number(estimatedMargin)
	      : calculation && Number.isFinite(Number(calculation.margin))
	        ? Number(calculation.margin)
	        : '';

	    return {
	      recommended_pack: recommendedPack,
	      practice_sets: advice.practiceSets,
	      patient_sets: advice.patientStock,
	      reserve_sets: advice.reserveSets,
	      vat_toggle: Boolean(useVatCorrection),
	      estimated_margin: marginValue,
	      issue_model: advice.distribution || '',
	      locations: advice.locations || '',
	      monthly_patients_range: advice.monthlyPatients || ''
	    };
	  }

	  function practiceB2BNumberFromCents(cents) {
	    var value = Number(cents);
	    return Number.isFinite(value) && value > 0 ? Number((value / 100).toFixed(2)) : 0;
	  }

	  function buildPracticeB2BPackageTrackingPayload(packageConfig, calculation) {
	    var quantity = Number(packageConfig && packageConfig.quantity);
	    var packageSize = quantity >= 20 ? '20+' : Number.isFinite(quantity) && quantity > 0 ? String(quantity) : '';
	    var price = practiceB2BNumberFromCents(packageConfig && packageConfig.priceCents);
	    var variantId = packageConfig && packageConfig.variantId != null ? String(packageConfig.variantId) : '';
	    var itemId = variantId || String(packageConfig && packageConfig.productHandle || packageConfig && packageConfig.key || '');
	    var itemName = String(packageConfig && packageConfig.label || packageConfig && packageConfig.key || 'Nordbelt praktijkpakket');
	    var item = {
	      item_id: itemId,
	      item_name: itemName,
	      item_brand: 'Nordbelt',
	      item_category: 'Practice package',
	      item_variant: packageSize,
	      price: price,
	      quantity: 1
	    };
	    if (variantId) item.variant_id = variantId;

	    var payload = {
	      recommended_pack: quantity >= 20 ? '20+' : Number.isFinite(quantity) && quantity > 0 ? String(quantity) : '',
	      vat_toggle: false,
	      estimated_margin: calculation && Number.isFinite(Number(calculation.margin)) ? Number(calculation.margin) : '',
	      business_plan_key: packageConfig && packageConfig.key ? packageConfig.key : '',
	      item_name: itemName,
	      item_id: itemId,
	      variant_id: variantId,
	      package_size: packageSize,
	      price: price,
	      currency: getBusinessPricingCurrency(),
	      value: price,
	      content_type: 'product',
	      items: [item],
	      ecommerce: {
	        currency: getBusinessPricingCurrency(),
	        value: price,
	        items: [item]
	      }
	    };
	    if (itemId) payload.content_ids = [itemId];
	    return payload;
	  }

	  window.NordbeltPracticeB2BTracking = {
	    push: pushPracticeB2BTrackingEvent,
	    pushOnce: pushPracticeB2BTrackingEventOnce
	  };

	  function buildPracticeB2BStaffelContext(config, packageConfig, advice, calculation, useVatCorrection) {
	    if (!advice || advice.adviceKey !== 'group-20plus') return null;

	    var patientStockMargin = calculation && advice.patientStock > 0
	      ? calculation.marginPerUnit * advice.patientStock
	      : null;
	    var estimatedMargin = Number.isFinite(patientStockMargin)
	      ? formatPracticeB2BCents(patientStockMargin)
	      : 'op basis van staffelprijs';

	    var context = {
	      recommended_pack: '20+ Nordbelts',
	      practice_sets: String(advice.practiceSets),
	      reserve_sets: String(advice.reserveSets),
	      patient_sets: String(advice.patientStock),
	      locations: getPracticeB2BLocationLabel(advice.locations),
	      therapists_range: getPracticeB2BTherapistLabel(advice.therapistsValue || advice.therapistSets),
	      rooms: getPracticeB2BRoomLabel(advice.roomsValue || advice.roomSets),
	      monthly_patients_range: getPracticeB2BMonthlyPatientsLabel(advice.monthlyPatients),
	      issue_model: getPracticeB2BIssueModelLabel(advice.distribution),
	      vat_toggle: useVatCorrection ? getPracticeB2BText('vatOn') : getPracticeB2BText('vatOff'),
	      estimated_margin: estimatedMargin,
	      raw_needed: String(advice.rawNeeded),
	      recommended_quantity: String(Math.max(20, advice.rawNeeded || 20)),
	      locations_value: String(advice.locations || ''),
	      rooms_value: String(advice.roomsValue || advice.roomSets || ''),
	      therapists_value: String(advice.therapistsValue || advice.therapistSets || ''),
	      distribution_value: String(advice.distribution || ''),
	      package_key: String(packageConfig && packageConfig.key || advice.adviceKey),
	      updated_at: String(Date.now())
	    };

	    Object.keys(context).forEach(function (key) {
	      context[key] = sanitizePracticeB2BStaffelValue(context[key], key === 'updated_at' ? 32 : 140);
	    });

	    return context;
	  }

	  function storePracticeB2BStaffelContext(context) {
	    if (!context) return;

	    try {
	      window.sessionStorage.setItem(practiceB2BStaffelStorageKey, JSON.stringify(context));
	    } catch (error) {
	      // The form also receives the same event, so storage failure should not block the flow.
	    }

	    if (typeof window.CustomEvent === 'function') {
	      window.dispatchEvent(new CustomEvent('practice-b2b-staffel-context', { detail: context }));
	    }
	  }

	  function formatPracticeB2BPackagePrice(packageConfig, calculation) {
	    if (!calculation) return getPracticeB2BUnavailableMessage();
	    return (packageConfig && packageConfig.isQuoteOnly ? getPracticeB2BFromPrefix() : '') + formatPracticeB2BCents(calculation.packagePrice);
	  }

	  function createPracticeB2BTableCell(text) {
	    var cell = document.createElement('td');
	    cell.textContent = text;
	    return cell;
	  }

	  function setPracticeB2BMarginOutput(root, name, value) {
	    root.querySelectorAll('[data-practice-b2b-margin-output="' + name + '"]').forEach(function (node) {
	      node.textContent = value;
	    });
	  }

	  function renderPracticeB2BMarginExample(root, config, packages, key, prefix, useVatCorrection) {
	    var packageConfig = packages.find(function (item) {
	      return item && item.key === key;
	    });
	    var calculation = calculatePracticeB2BPackage(config, packageConfig, useVatCorrection);
	    var details = root.querySelector('[data-practice-b2b-margin-example-details="' + key + '"]');
	    var fallback = root.querySelector('[data-practice-b2b-margin-output="' + prefix + 'Fallback"]');
	    var showQuoteFallback = !calculation && key === 'group-20plus';

	    if (details) details.hidden = showQuoteFallback;
	    if (fallback) fallback.hidden = !showQuoteFallback;

	    if (!calculation) {
	      if (!showQuoteFallback) {
		        var fallbackMessage = '';
	        setPracticeB2BMarginOutput(root, prefix + 'Package', getPracticeB2BUnavailableMessage());
	        setPracticeB2BMarginOutput(root, prefix + 'Revenue', fallbackMessage);
	        setPracticeB2BMarginOutput(root, prefix + 'Margin', fallbackMessage);
	        setPracticeB2BMarginOutput(root, prefix + 'MarginPerUnit', fallbackMessage);
	      }
	      return;
	    }

	    var quotePrefix = packageConfig && packageConfig.isQuoteOnly ? getPracticeB2BFromPrefix() : '';
	    setPracticeB2BMarginOutput(root, prefix + 'Package', formatPracticeB2BPackagePrice(packageConfig, calculation));
	    setPracticeB2BMarginOutput(root, prefix + 'Revenue', formatPracticeB2BCents(calculation.revenue));
	    setPracticeB2BMarginOutput(root, prefix + 'Margin', quotePrefix + formatPracticeB2BCents(calculation.margin));
	    setPracticeB2BMarginOutput(root, prefix + 'MarginPerUnit', quotePrefix + formatPracticeB2BCents(calculation.marginPerUnit));
	  }

	  function ensurePracticeB2BMarginOverviewFallback() {
	    if (window.location.pathname.indexOf('/pages/fysiopraktijken') === -1) return;
	    if (document.querySelector('[data-practice-b2b-margin-overview]')) return;

	    var planAnchor = document.querySelector('#business-pricing-plans');
	    var target = planAnchor && planAnchor.closest ? planAnchor.closest('.shopify-section') : planAnchor;
	    if (!target || !target.parentNode) return;

	    var wrapper = document.createElement('div');
	    wrapper.className = 'shopify-section practice-b2b-margin-section-fallback';
	    wrapper.innerHTML = [
	      '<section id="practice-b2b-margin" class="nb-section practice-b2b-margin-section" data-practice-b2b-margin-overview>',
	      '  <div class="nb-container">',
	      '    <div class="nb-card practice-b2b-margin-section__shell">',
	      '      <div class="practice-b2b-margin-section__head">',
	      '        <p class="nb-business-plan-panel__eyebrow practice-b2b-margin-section__eyebrow">Doorverkoop rekenvoorbeeld</p>',
	      '        <h2 class="nb-title nb-section-title practice-b2b-margin-section__title"><span>Marge voor je praktijk bij </span><span class="nb-title-accent nb-title-accent--sky">doorverkoop</span></h2>',
	      '        <p class="nb-subtitle practice-b2b-margin-section__subtitle">Koop Nordbelt in via praktijkstaffel en verkoop het thuispakket aan patiënten voor de actuele Nordbelt-prijs. Hoe groter de praktijkvoorraad, hoe lager je inkoop per stuk en hoe hoger je marge.</p>',
	      '        <p class="practice-b2b-margin-section__patient-price">Actuele patiëntprijs: <strong data-practice-b2b-margin-output="patientPrice">actuele Nordbelt-prijs</strong></p>',
	      '        <p class="practice-b2b-margin-section__tax-note">Praktijkpakketten: <span data-practice-b2b-margin-output="taxLabel" title="Nordbelt berekent geen btw vanwege toepassing van de kleineondernemersregeling. Er staat geen btw op de factuur.">btw-vrij geleverd via KOR</span></p>',
	      '      </div>',
	      '      <div class="practice-b2b-margin-section__controls">',
	      '        <label class="practice-b2b-margin-toggle">',
	      '          <input type="checkbox" data-practice-b2b-margin-vat-toggle>',
	      '          <span>Btw afdragen over doorverkoop</span>',
	      '          <span class="practice-b2b-margin-toggle__tooltip" tabindex="0" title="Standaard tonen we de marge zonder btw-afdracht door de praktijk. Zet dit aan als je intern met 21% btw over productverkoop wilt rekenen. Dit is een rekenvoorbeeld, geen fiscaal advies." aria-label="Standaard tonen we de marge zonder btw-afdracht door de praktijk. Zet dit aan als je intern met 21% btw over productverkoop wilt rekenen. Dit is een rekenvoorbeeld, geen fiscaal advies."></span>',
	      '        </label>',
	      '        <p class="practice-b2b-margin-section__microcopy" data-practice-b2b-margin-output="microcopy">Dit zijn rekenvoorbeelden. Controleer je eigen fiscale situatie met je boekhouder.</p>',
	      '      </div>',
	      '      <p class="practice-b2b-margin-section__conversion" data-practice-b2b-margin-copy data-copy-without-vat="Vanaf het 12-pack wordt doorverkoop echt interessant: je marge per Nordbelt ligt daar hoger doordat je inkoopprijs per stuk lager is." data-copy-with-vat="Ook met btw-afdracht blijft vooral 12 of 20+ interessant, omdat de inkoopprijs per Nordbelt daar lager ligt.">Vanaf het 12-pack wordt doorverkoop echt interessant: je marge per Nordbelt ligt daar hoger doordat je inkoopprijs per stuk lager is.</p>',
	      '      <div class="practice-b2b-margin-section__table-wrap" role="region" aria-label="Marge per praktijkpakket">',
	      '        <table class="practice-b2b-margin-table">',
	      '          <caption class="visually-hidden">Marge voor fysiopraktijken bij doorverkoop van Nordbelt praktijkpakketten</caption>',
	      '          <thead><tr><th scope="col">Pakket</th><th scope="col">Aantal</th><th scope="col">Pakketprijs</th><th scope="col">Inkoop per stuk</th><th scope="col">Patiëntprijs</th><th scope="col">Marge per stuk</th><th scope="col">Totale marge</th></tr></thead>',
	      '          <tbody data-practice-b2b-margin-table-body><tr><td colspan="7">Actuele pakketprijs via Shopify-variant.</td></tr></tbody>',
	      '        </table>',
	      '      </div>',
	      '      <div class="practice-b2b-margin-section__cards" data-practice-b2b-margin-card-list aria-label="Marge per pakket"></div>',
	      '      <div class="practice-b2b-margin-section__examples">',
	      '        <article class="practice-b2b-margin-example practice-b2b-margin-example--featured" data-practice-b2b-margin-example="scale-12">',
	      '          <span class="practice-b2b-margin-example__label">12-pack voorbeeld</span>',
	      '          <h3>Meest gekozen voor praktijk + thuisvoorraad</h3>',
	      '          <dl><div><dt>Pakketprijs</dt><dd data-practice-b2b-margin-output="example12Package">Actuele pakketprijs via Shopify-variant.</dd></div><div><dt>Omzet bij volledige doorverkoop</dt><dd data-practice-b2b-margin-output="example12Revenue"></dd></div><div><dt>Potentiële marge</dt><dd data-practice-b2b-margin-output="example12Margin"></dd></div><div><dt>Marge per Nordbelt</dt><dd data-practice-b2b-margin-output="example12MarginPerUnit"></dd></div></dl>',
	      '        </article>',
	      '        <article class="practice-b2b-margin-example" data-practice-b2b-margin-example="group-20plus">',
	      '          <span class="practice-b2b-margin-example__label">20+ voorbeeld</span>',
	      '          <h3>Voor grotere voorraad of meerdere locaties</h3>',
	      '          <p class="practice-b2b-margin-example__fallback" data-practice-b2b-margin-output="example20Fallback" hidden>Vraag staffel aan voor actuele 20+ prijs en marge-inschatting.</p>',
	      '          <dl data-practice-b2b-margin-example-details="group-20plus"><div><dt>Pakketprijs</dt><dd data-practice-b2b-margin-output="example20Package">staffel op aanvraag</dd></div><div><dt>Omzet bij volledige doorverkoop</dt><dd data-practice-b2b-margin-output="example20Revenue"></dd></div><div><dt>Potentiële marge</dt><dd data-practice-b2b-margin-output="example20Margin"></dd></div><div><dt>Marge per Nordbelt</dt><dd data-practice-b2b-margin-output="example20MarginPerUnit"></dd></div></dl>',
	      '        </article>',
	      '      </div>',
	      '      <div class="practice-b2b-margin-section__actions"><a class="nb-button" href="#business-pricing-plans" data-nb-cta="practice_margin_view_plans">Bekijk praktijkpakketten</a><a class="nb-button nb-button--secondary" href="#business-plan-practices-scale-12" data-nb-cta="practice_margin_view_12_pack">Bekijk 12-pack</a></div>',
	      '    </div>',
	      '  </div>',
	      '</section>'
	    ].join('');

	    target.parentNode.insertBefore(wrapper, target);
	  }

	  function bindPracticeB2BMarginOverview() {
	    var sections = document.querySelectorAll('[data-practice-b2b-margin-overview]');
	    if (!sections.length) return;

	    var config = getPracticePricingConfig();
	    var packages = config && Array.isArray(config.packages) ? config.packages : [];

	    sections.forEach(function (section) {
	      if (section.dataset.practiceB2BMarginOverviewBound === 'true') return;
	      section.dataset.practiceB2BMarginOverviewBound = 'true';

	      var vatToggle = section.querySelector('[data-practice-b2b-margin-vat-toggle]');
	      var tableBody = section.querySelector('[data-practice-b2b-margin-table-body]');
	      var cardList = section.querySelector('[data-practice-b2b-margin-card-list]');
	      var conversionCopy = section.querySelector('[data-practice-b2b-margin-copy]');
	      var patientPriceLabel = getPracticeB2BPatientPriceLabel(config);

	      setPracticeB2BMarginOutput(section, 'patientPrice', patientPriceLabel);
	      setPracticeB2BMarginOutput(section, 'taxLabel', config && config.taxLabel ? config.taxLabel : getPracticeB2BText('taxLabel'));
	      setPracticeB2BMarginOutput(
	        section,
	        'microcopy',
	        config && config.microcopy ? config.microcopy : getPracticeB2BText('microcopy')
	      );

	      if (vatToggle) {
	        vatToggle.checked = Boolean(config && config.vatToggleDefault);
	      }

	      function renderOverview() {
	        var useVatCorrection = Boolean(vatToggle && vatToggle.checked);
	        var unavailable = getPracticeB2BUnavailableMessage();

	        if (conversionCopy) {
	          conversionCopy.textContent = useVatCorrection
	            ? conversionCopy.getAttribute('data-copy-with-vat')
	            : conversionCopy.getAttribute('data-copy-without-vat');
	        }

	        if (tableBody) tableBody.innerHTML = '';
	        if (cardList) cardList.innerHTML = '';

	        if (!config || !packages.length) {
	          if (tableBody) {
	            var fallbackRow = document.createElement('tr');
	            var fallbackCell = document.createElement('td');
	            fallbackCell.colSpan = 7;
	            fallbackCell.textContent = unavailable;
	            fallbackRow.appendChild(fallbackCell);
	            tableBody.appendChild(fallbackRow);
	          }
	          return;
	        }

	        packages.forEach(function (packageConfig) {
	          if (!packageConfig || !packageConfig.key) return;

	          var calculation = calculatePracticeB2BPackage(config, packageConfig, useVatCorrection);
	          var packageName = getPracticeB2BPackageName(packageConfig);
	          var quantityLabel = packageConfig.quantity ? packageConfig.quantity + ' Nordbelts' : getPracticeB2BText('unknownPackageSize');
		  var packagePrice = formatPracticeB2BPackagePrice(packageConfig, calculation);
	          var quotePrefix = packageConfig && packageConfig.isQuoteOnly ? getPracticeB2BFromPrefix() : '';
	          var unitCost = calculation ? quotePrefix + formatPracticeB2BCents(calculation.unitCost) : unavailable;
	          var marginPerUnit = calculation ? quotePrefix + formatPracticeB2BCents(calculation.marginPerUnit) : unavailable;
	          var totalMargin = calculation ? quotePrefix + formatPracticeB2BCents(calculation.margin) : unavailable;

	          if (tableBody) {
	            var row = document.createElement('tr');
	            row.setAttribute('data-practice-b2b-margin-row', packageConfig.key);
	            if (packageConfig.variantId) row.setAttribute('data-variant-id', String(packageConfig.variantId));
	            if (Number.isFinite(Number(packageConfig.priceCents))) row.setAttribute('data-price-cents', String(packageConfig.priceCents));
	            if (Number.isFinite(Number(packageConfig.quantity))) row.setAttribute('data-qty', String(packageConfig.quantity));
	            if (config && Number.isFinite(Number(config.patientPriceCents))) row.setAttribute('data-patient-price-cents', String(config.patientPriceCents));
	            if (packageConfig.key === 'scale-12') row.classList.add('is-featured');
	            if (!calculation) row.classList.add('is-unavailable');

	            row.appendChild(createPracticeB2BTableCell(packageName));
	            row.appendChild(createPracticeB2BTableCell(quantityLabel));
	            row.appendChild(createPracticeB2BTableCell(packagePrice));
	            row.appendChild(createPracticeB2BTableCell(unitCost));
	            row.appendChild(createPracticeB2BTableCell(patientPriceLabel));
	            row.appendChild(createPracticeB2BTableCell(marginPerUnit));
	            row.appendChild(createPracticeB2BTableCell(totalMargin));
	            tableBody.appendChild(row);
	          }

	          if (cardList) {
	            var card = document.createElement('article');
	            card.className = 'practice-b2b-margin-card';
	            card.setAttribute('data-practice-b2b-margin-card', packageConfig.key);
	            if (packageConfig.variantId) card.setAttribute('data-variant-id', String(packageConfig.variantId));
	            if (Number.isFinite(Number(packageConfig.priceCents))) card.setAttribute('data-price-cents', String(packageConfig.priceCents));
	            if (Number.isFinite(Number(packageConfig.quantity))) card.setAttribute('data-qty', String(packageConfig.quantity));
	            if (config && Number.isFinite(Number(config.patientPriceCents))) card.setAttribute('data-patient-price-cents', String(config.patientPriceCents));
	            if (packageConfig.key === 'scale-12') card.classList.add('is-featured');
	            if (!calculation) card.classList.add('is-unavailable');

	            var title = document.createElement('h3');
	            title.textContent = packageName;
	            var meta = document.createElement('p');
	            meta.className = 'practice-b2b-margin-card__meta';
	            meta.textContent = quantityLabel + ' · ' + getPracticeB2BText('patientPriceLower') + ' ' + patientPriceLabel;
	            card.appendChild(title);
	            card.appendChild(meta);

	            [
	              [getPracticeB2BText('packagePrice'), packagePrice],
	              [getPracticeB2BText('unitCost'), unitCost],
	              [getPracticeB2BText('marginPerUnit'), marginPerUnit],
	              [getPracticeB2BText('totalMargin'), totalMargin]
	            ].forEach(function (item) {
	              var metric = document.createElement('div');
	              metric.className = 'practice-b2b-margin-card__metric';
	              var label = document.createElement('span');
	              label.textContent = item[0];
	              var value = document.createElement('strong');
	              value.textContent = item[1];
	              metric.appendChild(label);
	              metric.appendChild(value);
	              card.appendChild(metric);
	            });

	            cardList.appendChild(card);
	          }
	        });

	        renderPracticeB2BMarginExample(section, config, packages, 'scale-12', 'example12', useVatCorrection);
	        renderPracticeB2BMarginExample(section, config, packages, 'group-20plus', 'example20', useVatCorrection);
	        cleanPracticeB2BMarginLocaleCopy(section);
	      }

	      if (vatToggle) {
	        vatToggle.addEventListener('change', function () {
	          var useVatCorrection = Boolean(vatToggle.checked);
	          renderOverview();
	          pushPracticeB2BTrackingEvent(useVatCorrection ? 'b2b_margin_toggle_on' : 'b2b_margin_toggle_off', {
	            vat_toggle: useVatCorrection,
	            business_cta_location: 'practice-margin'
	          });
	        });
	      }

	      renderOverview();
	    });
	  }

	  function bindPracticeB2BPlanCards() {
	    var cards = document.querySelectorAll('[data-business-plan-card][data-business-audience="practices"]');
	    if (!cards.length) return;

	    var config = getPracticePricingConfig();
	    var packages = config && Array.isArray(config.packages) ? config.packages : [];
	    var fallbackMessage = '';

	    function setCardOutput(card, name, value) {
	      card.querySelectorAll('[data-practice-b2b-plan-output="' + name + '"]').forEach(function (node) {
	        node.textContent = value;
	      });
	    }

	    function setCardSaving(card, calculation, quotePrefix) {
	      var rows = card.querySelectorAll('[data-practice-b2b-saving-row]');
	      if (!rows.length) return;
	      var saving = calculation && Number(calculation.margin);
	      var hasSaving = Number.isFinite(saving) && saving > 0;
	      rows.forEach(function (row) {
	        row.hidden = !hasSaving;
	        if (hasSaving) {
	          row.setAttribute('aria-label', getPracticeB2BText('savingAriaPrefix') + quotePrefix + formatPracticeB2BCents(saving));
	        }
	      });
	      if (hasSaving) {
	        setCardOutput(card, 'packageSaving', getPracticeB2BText('savingPrefix') + quotePrefix + formatPracticeB2BCents(saving));
	      }
	    }

	    cards.forEach(function (card) {
	      if (card.dataset.practiceB2bPlanCardBound === 'true') return;
	      card.dataset.practiceB2bPlanCardBound = 'true';

	      var planKey = card.getAttribute('data-plan-key') || '';
	      var packageConfig = packages.find(function (item) {
	        return item && item.key === planKey;
	      });
	      var calculation = calculatePracticeB2BPackage(config, packageConfig, false);
	      var quotePrefix = packageConfig && packageConfig.isQuoteOnly ? getPracticeB2BFromPrefix() : '';

	      if (!packageConfig || !calculation) {
	        setCardOutput(card, 'unitCost', packageConfig && packageConfig.isQuoteOnly ? getPracticeB2BTierLabel() : getPracticeB2BUnavailableMessage());
	        setCardOutput(card, 'marginPerUnit', fallbackMessage);
	        setCardOutput(card, 'totalMargin', fallbackMessage);
	        setCardSaving(card, null, '');
	        return;
	      }

	      setCardOutput(card, 'unitCost', quotePrefix + formatPracticeB2BCents(calculation.unitCost));
	      setCardOutput(card, 'marginPerUnit', quotePrefix + formatPracticeB2BCents(calculation.marginPerUnit));
	      setCardOutput(card, 'totalMargin', quotePrefix + formatPracticeB2BCents(calculation.margin));
	      setCardSaving(card, calculation, quotePrefix);
	    });
	  }

	  function pushPracticeCalculatorEvent(eventName, detail) {
	    pushPracticeB2BTrackingEvent(
	      eventName,
	      Object.assign({ business_cta_location: 'practice-calculator' }, detail || {})
	    );
	  }

	  function bindPracticeB2BCalculator() {
	    document.querySelectorAll('[data-practice-b2b-stock-calculator]').forEach(function (panel) {
	      if (panel.dataset.practiceB2bCalculatorBound === 'true') return;

	      var config = getPracticePricingConfig();
	      var packages = config && Array.isArray(config.packages) ? config.packages : [];
	      var vatToggle = panel.querySelector('[data-practice-b2b-calculator-vat-toggle]');
	      var reserveRow = panel.querySelector('[data-practice-b2b-calculator-reserve-row]');
	      var fallback = panel.querySelector('[data-practice-b2b-calculator-fallback]');
	      var primaryCta = panel.querySelector('[data-practice-b2b-calculator-primary]');
	      var secondaryCta = panel.querySelector('[data-practice-b2b-calculator-secondary]');
	      var interactionStarted = false;
	      var completionTracked = false;
	      var lastRecommendationEvent = '';

	      panel.dataset.practiceB2bCalculatorBound = 'true';

	      function setOutput(name, value) {
	        panel.querySelectorAll('[data-practice-b2b-calculator-output="' + name + '"]').forEach(function (node) {
	          node.textContent = value;
	        });
	      }

	      function getSelectedValue(name, fallbackValue) {
	        var input = panel.querySelector('input[name="' + name + '"]:checked');
	        return input ? input.value : fallbackValue;
	      }

	      function getPracticePackageByAdvice(adviceKey) {
	        var targetQuantity = adviceKey === 'group-20plus' ? 20 : Number(adviceKey);
	        return packages.find(function (packageConfig) {
	          if (!packageConfig) return false;
	          if (adviceKey === 'group-20plus') {
	            return String(packageConfig.key || '').indexOf('20plus') !== -1 || Number(packageConfig.quantity) >= 20;
	          }
	          return Number(packageConfig.quantity) === targetQuantity;
	        }) || null;
	      }

	      function getAdviceLabel(adviceKey) {
	        if (adviceKey === 'group-20plus') return '20+';
	        return adviceKey + '-pack';
	      }

	      function calculateStockAdvice() {
	        var roomsValue = getSelectedValue('practice_b2b_rooms', '1');
	        var therapistsValue = getSelectedValue('practice_b2b_therapists', '1');
	        var roomSets = Number(roomsValue) || 1;
	        var therapistSets = Number(therapistsValue) || 1;
	        var patientIntent = getSelectedValue('practice_b2b_patient_intent', 'none');
	        var monthlyPatients = getSelectedValue('practice_b2b_monthly_patients', '0-2');
	        var distribution = getSelectedValue('practice_b2b_distribution', 'practice-only');
	        var locations = getSelectedValue('practice_b2b_locations', '1');
	        var patientStockMap = {
	          none: 0,
	          occasional: 4,
	          structural: 8,
	          homepack: 12
	        };
	        var monthlyMinimumMap = {
	          '0-2': 0,
	          '3-5': 4,
	          '6-10': 8,
	          '10plus': 12
	        };
	        var practiceSets = Math.max(roomSets, therapistSets);
	        var patientStock = patientStockMap[patientIntent] || 0;
	        var monthlyMinimum = monthlyMinimumMap[monthlyPatients] || 0;

	        if (patientIntent !== 'none') {
	          patientStock = Math.max(patientStock, monthlyMinimum);
	        }

	        if (distribution === 'practice-only' || patientIntent === 'none') {
	          patientStock = 0;
	        } else if (distribution === 'lend' && patientStock > 0) {
	          patientStock += 2;
	        }

	        var rawNeeded = practiceSets + patientStock;
	        var force20Plus =
	          locations === '3plus' ||
	          (
	            monthlyPatients === '10plus' &&
	            (patientIntent === 'structural' || patientIntent === 'homepack' || distribution === 'sell')
	          );
	        var recommendedQty = 4;

	        if (force20Plus || rawNeeded >= 13) {
	          recommendedQty = 20;
	        } else if (rawNeeded >= 9) {
	          recommendedQty = 12;
	        } else if (rawNeeded >= 5) {
	          recommendedQty = 8;
	        }

	        if (locations === '2' && recommendedQty < 8) {
	          recommendedQty = 8;
	        }

	        var adviceKey = recommendedQty >= 20 ? 'group-20plus' : String(recommendedQty);
	        var reserveSets = recommendedQty - practiceSets - patientStock;
	        if (reserveSets < 0 || adviceKey === 'group-20plus' && rawNeeded > 20) {
	          reserveSets = 0;
	        }

	        return {
	          roomsValue: roomsValue,
	          therapistsValue: therapistsValue,
	          roomSets: roomSets,
	          therapistSets: therapistSets,
	          practiceSets: practiceSets,
	          patientStock: patientStock,
	          rawNeeded: rawNeeded,
	          recommendedQty: recommendedQty,
	          adviceKey: adviceKey,
	          reserveSets: reserveSets,
	          monthlyPatients: monthlyPatients,
	          patientIntent: patientIntent,
	          distribution: distribution,
	          locations: locations
	        };
	      }

	      function formatPackagePrice(packageConfig, calculation) {
	        if (!calculation) {
	          if (packageConfig && packageConfig.isQuoteOnly) return 'Vraag staffel aan';
	          return getPracticeB2BUnavailableMessage();
	        }
	        return formatPracticeB2BPackagePrice(packageConfig, calculation);
	      }

	      function setPrimaryCta(packageConfig, advice) {
	        if (!primaryCta) return;

	        var isQuoteOnly = advice.adviceKey === 'group-20plus' || Boolean(packageConfig && packageConfig.isQuoteOnly);
	        primaryCta.textContent = isQuoteOnly ? 'Vraag praktijkstaffel aan' : 'Voeg aanbevolen pakket toe';
	        primaryCta.setAttribute('href', isQuoteOnly ? '#practice-b2b-staffel' : packageConfig && packageConfig.addToCartUrl ? packageConfig.addToCartUrl : '#business-pricing-plans');
	        primaryCta.setAttribute('data-business-cta-intent', isQuoteOnly ? 'quote' : 'buy');
	        primaryCta.setAttribute('data-business-plan-key', packageConfig && packageConfig.key ? packageConfig.key : advice.adviceKey);
	        primaryCta.setAttribute('data-practice-b2b-calculator-action', isQuoteOnly ? 'quote' : 'add');

	        if (!isQuoteOnly && !(packageConfig && packageConfig.addToCartUrl)) {
	          primaryCta.setAttribute('aria-disabled', 'true');
	        } else {
	          primaryCta.removeAttribute('aria-disabled');
	        }
	      }

	      function getCurrentTrackingDetail() {
	        var advice = calculateStockAdvice();
	        var packageConfig = getPracticePackageByAdvice(advice.adviceKey);
	        var useVatCorrection = Boolean(vatToggle && vatToggle.checked);
	        var calculation = calculatePracticeB2BPackage(config, packageConfig, useVatCorrection);
	        var patientStockMargin = calculation ? calculation.marginPerUnit * advice.patientStock : '';
	        var detail = buildPracticeB2BAdviceTrackingPayload(advice, calculation, useVatCorrection, patientStockMargin);
	        detail.business_plan_key = packageConfig && packageConfig.key ? packageConfig.key : advice.adviceKey;
	        return detail;
	      }

	      function renderCalculator(userInitiated) {
	        var advice = calculateStockAdvice();
	        var packageConfig = getPracticePackageByAdvice(advice.adviceKey);
	        var useVatCorrection = Boolean(vatToggle && vatToggle.checked);
	        var calculation = calculatePracticeB2BPackage(config, packageConfig, useVatCorrection);
	        var patientPriceLabel = getPracticeB2BPatientPriceLabel(config);
	        var patientPriceCents = Number(config && config.patientPriceCents);
	        var vatRate = Number(config && config.vatRate) || 1.21;
	        var unavailable = getPracticeB2BUnavailableMessage();
	        var adviceLabel = getAdviceLabel(advice.adviceKey);
	        var adviceCountLabel = advice.adviceKey === 'group-20plus' ? '20+' : String(advice.recommendedQty);
	        var packageName = packageConfig ? getPracticeB2BPackageName(packageConfig) : adviceLabel;
	        var patientStockMargin = calculation ? calculation.marginPerUnit * advice.patientStock : null;
	        var allSetsMargin = calculation ? calculation.margin : null;
	        var note = config && config.microcopy ? config.microcopy : 'Dit zijn rekenvoorbeelden. Controleer je eigen fiscale situatie met je boekhouder.';
	        var trackingDetail = buildPracticeB2BAdviceTrackingPayload(advice, calculation, useVatCorrection, patientStockMargin);
	        trackingDetail.business_plan_key = packageConfig && packageConfig.key ? packageConfig.key : advice.adviceKey;

	        if (useVatCorrection && Number.isFinite(patientPriceCents) && patientPriceCents > 0) {
	          patientPriceLabel = formatPracticeB2BCents(patientPriceCents / vatRate) + ' netto bij 21% btw';
	        }

	        if (advice.adviceKey === 'group-20plus') {
	          if (calculation) {
	            note = advice.rawNeeded > 20
	              ? 'Berekende behoefte: ' + advice.rawNeeded + ' sets. Stem de 20+ staffel af op locaties, uitleenflow en patiëntvoorraad.'
	              : '20+ is bedoeld als staffeladvies voor grotere voorraad of meerdere locaties.';
	          } else {
	            note = 'Vraag staffel aan voor actuele 20+ prijs en marge-inschatting.';
	          }
	        }

	        setOutput('adviceTitle', 'Advies voor jouw praktijk: ' + adviceCountLabel + ' Nordbelts');
	        setOutput('summaryPracticeSets', advice.practiceSets + ' sets');
	        setOutput('summaryPatientStock', advice.patientStock + ' sets');
	        setOutput('summaryAdvice', adviceLabel);
	        setOutput('summaryMargin', calculation ? formatPracticeB2BCents(patientStockMargin) : unavailable);
	        setOutput('practiceSets', advice.practiceSets + ' Nordbelts');
	        setOutput('patientSets', advice.patientStock + ' Nordbelts');
	        setOutput('reserveSets', advice.reserveSets + ' Nordbelts');
	        setOutput('recommendedPackage', packageName);
		        var quotePrefix = packageConfig && packageConfig.isQuoteOnly ? getPracticeB2BFromPrefix() : '';
		        setOutput('packagePrice', formatPackagePrice(packageConfig, calculation));
		        setOutput('unitCost', calculation ? quotePrefix + formatPracticeB2BCents(calculation.unitCost) : unavailable);
		        setOutput('patientPrice', patientPriceLabel);
		        setOutput('marginPerUnit', calculation ? quotePrefix + formatPracticeB2BCents(calculation.marginPerUnit) : unavailable);
		        setOutput('patientStockMargin', calculation ? quotePrefix + formatPracticeB2BCents(patientStockMargin) : unavailable);
		        setOutput('allSetsMargin', calculation ? quotePrefix + formatPracticeB2BCents(allSetsMargin) : unavailable);
	        setOutput('note', note);

	        if (reserveRow) {
	          reserveRow.hidden = advice.reserveSets <= 0;
	        }

	        if (fallback) {
	          fallback.hidden = Boolean(calculation);
	          fallback.textContent = packageConfig && packageConfig.isQuoteOnly
	            ? 'Vraag staffel aan voor actuele 20+ prijs en marge-inschatting.'
	            : '';
	        }

	        setPrimaryCta(packageConfig, advice);

	        if (secondaryCta) {
	          secondaryCta.setAttribute('data-business-plan-key', packageConfig && packageConfig.key ? packageConfig.key : advice.adviceKey);
	        }

	        if (userInitiated) {
	          if (!completionTracked) {
	            pushPracticeCalculatorEvent('calculator_completed', trackingDetail);
	            completionTracked = true;
	          }

	          var recommendationEvent = 'recommended_' + (advice.adviceKey === 'group-20plus' ? '20plus' : advice.recommendedQty);
	          if (lastRecommendationEvent !== recommendationEvent) {
	            pushPracticeCalculatorEvent(recommendationEvent, trackingDetail);
	            lastRecommendationEvent = recommendationEvent;
	          }
	        }
	      }

	      panel.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
	        input.addEventListener('change', function () {
	          if (!interactionStarted) {
	            pushPracticeCalculatorEvent('calculator_started', getCurrentTrackingDetail());
	            interactionStarted = true;
	          }
	          renderCalculator(true);
	        });
	      });

	      if (primaryCta) {
	        primaryCta.addEventListener('click', function () {
	          var action = primaryCta.getAttribute('data-practice-b2b-calculator-action') || 'add';
	          var advice = calculateStockAdvice();
	          var packageConfig = getPracticePackageByAdvice(advice.adviceKey);
	          var useVatCorrection = Boolean(vatToggle && vatToggle.checked);
	          var calculation = calculatePracticeB2BPackage(config, packageConfig, useVatCorrection);
	          if (action === 'quote') {
	            storePracticeB2BStaffelContext(buildPracticeB2BStaffelContext(config, packageConfig, advice, calculation, useVatCorrection));
	          }
	          var trackingDetail = getCurrentTrackingDetail();
	          trackingDetail.business_plan_key = primaryCta.getAttribute('data-business-plan-key') || trackingDetail.business_plan_key || '';
	          var packageTrackingDetail = Object.assign(
	            {},
	            trackingDetail,
	            buildPracticeB2BPackageTrackingPayload(packageConfig, calculation),
	            {
	              business_cta_location: 'practice-calculator',
	              practice_event_trigger: action === 'quote' ? 'calculator_quote_click' : 'calculator_add_click'
	            }
	          );
	          if (action === 'quote') {
	            pushPracticeB2BTrackingEvent('click_practice_staffel_20_plus', packageTrackingDetail);
	            pushPracticeB2BTrackingEventOnce('staffel_request_started', packageTrackingDetail, 'staffel_request_started');
	          } else {
	            var quantity = Number(packageConfig && packageConfig.quantity);
	            if (quantity === 4 || quantity === 8 || quantity === 12) {
	              pushPracticeB2BTrackingEvent('click_practice_package_' + quantity, packageTrackingDetail);
	            }
	            pushPracticeB2BTrackingEvent('add_to_cart_practice_package', packageTrackingDetail);
	            pushPracticeCalculatorEvent('add_to_cart_from_calculator', trackingDetail);
	          }
	        });
	      }

	      if (vatToggle) {
	        vatToggle.checked = Boolean(config && config.vatToggleDefault);
	      }

	      renderCalculator(false);
	    });
	  }

	  function isPracticeB2BPage() {
	    return getPageContext() === 'practices' || window.location.pathname.indexOf('/pages/fysiopraktijken') !== -1;
	  }

	  function findPracticeB2BPackageByKey(packages, planKey) {
	    return packages.find(function (packageConfig) {
	      return packageConfig && packageConfig.key === planKey;
	    }) || null;
	  }

	  function findPracticeB2BPackageByQuantity(packages, quantity) {
	    var targetQuantity = Number(quantity);
	    if (!Number.isFinite(targetQuantity) || targetQuantity <= 0) return null;
	    return packages.find(function (packageConfig) {
	      if (!packageConfig) return false;
	      var packageQuantity = Number(packageConfig.quantity);
	      if (targetQuantity >= 20) return packageQuantity >= 20 || String(packageConfig.key || '').indexOf('20plus') !== -1;
	      return packageQuantity === targetQuantity;
	    }) || null;
	  }

	  function getPracticeB2BQuotePlanQuantity(plan) {
	    var normalizedPlan = String(plan || '').toLowerCase();
	    if (normalizedPlan === 'start' || normalizedPlan === 'practice-4') return 4;
	    if (normalizedPlan === 'praktijk' || normalizedPlan === 'flow-8') return 8;
	    if (normalizedPlan === 'partner' || normalizedPlan === 'scale-12') return 12;
	    if (
	      normalizedPlan === '20plus' ||
	      normalizedPlan === 'multi-locatie' ||
	      normalizedPlan === 'netwerk' ||
	      normalizedPlan === 'group-20plus'
	    ) {
	      return 20;
	    }
	    return 0;
	  }

	  function findPracticeB2BPackageByPlanOrQuantity(packages, planKey, quantity) {
	    return findPracticeB2BPackageByKey(packages, planKey) ||
	      findPracticeB2BPackageByQuantity(packages, quantity || getPracticeB2BQuotePlanQuantity(planKey)) ||
	      null;
	  }

	  function getPracticeB2BLinkHash(link) {
	    var href = link && link.getAttribute ? link.getAttribute('href') || '' : '';
	    if (!href) return '';
	    try {
	      return new URL(href, window.location.href).hash || '';
	    } catch (error) {
	      return href.charAt(0) === '#' ? href : '';
	    }
	  }

	  function isPracticeB2BEvidenceSourceLink(link) {
	    if (!link || !link.getAttribute) return false;
	    var href = String(link.getAttribute('href') || '').toLowerCase();
	    var label = String(link.textContent || '').toLowerCase();
	    return (
	      href.indexOf('30808663') !== -1 ||
	      href.indexOf('bjsports-2018-100045') !== -1 ||
	      label.indexOf('30808663') !== -1 ||
	      label.indexOf('van dyk') !== -1 && label.indexOf('br j sports') !== -1
	    );
	  }

	  function isPracticeB2BMeasurementContext() {
	    if (isPracticeB2BPage()) return true;
	    var path = (window.location.pathname || '').toLowerCase();
	    if (path.indexOf('/pages/request-a-quote') === -1) return false;
	    try {
	      var params = new URLSearchParams(window.location.search || '');
	      return normalizeSegment((params.get('segment') || '').toLowerCase()) === 'practice';
	    } catch (error) {
	      return false;
	    }
	  }

	  function collectPracticeCampaignParams() {
	    var allowedNames = {
	      gclid: true,
	      gbraid: true,
	      wbraid: true,
	      gad_source: true,
	      gad_campaignid: true,
	      dclid: true,
	      fbclid: true,
	      msclkid: true
	    };
	    var collected = [];
	    try {
	      var params = new URLSearchParams(window.location.search || '');
	      params.forEach(function (value, name) {
	        var normalizedName = String(name || '').toLowerCase();
	        if (!value) return;
	        if (normalizedName.indexOf('utm_') !== 0 && !allowedNames[normalizedName]) return;
	        collected.push({ name: normalizedName, value: String(value) });
	      });
	    } catch (error) {
	      return collected;
	    }
	    return collected;
	  }

	  function isPracticeCampaignTargetUrl(url) {
	    if (!url || url.origin !== window.location.origin) return false;
	    var path = (url.pathname || '').toLowerCase();
	    return (
	      path.indexOf('/cart') === 0 ||
	      path.indexOf('/checkout') === 0 ||
	      path.indexOf('/pages/request-a-quote') === 0 ||
	      path.indexOf('/products/proef-nordbelt-voor-fysiopraktijken') === 0
	    );
	  }

	  function appendPracticeCampaignParamsToUrl(url, params) {
	    params.forEach(function (entry) {
	      if (!url.searchParams.has(entry.name)) {
	        url.searchParams.set(entry.name, entry.value);
	      }
	    });

	    if (url.pathname.indexOf('/cart/add') === 0 && url.searchParams.has('return_to')) {
	      try {
	        var returnTo = new URL(url.searchParams.get('return_to'), window.location.origin);
	        if (returnTo.origin === window.location.origin) {
	          params.forEach(function (entry) {
	            if (!returnTo.searchParams.has(entry.name)) {
	              returnTo.searchParams.set(entry.name, entry.value);
	            }
	          });
	          url.searchParams.set('return_to', returnTo.pathname + returnTo.search + returnTo.hash);
	        }
	      } catch (error) {
	        // Keep the original return_to when it is not parseable.
	      }
	    }
	  }

	  function applyPracticeCampaignParamsToLink(link, params) {
	    if (!link || !link.getAttribute || !params.length) return;
	    var href = link.getAttribute('href') || '';
	    if (!href || href.charAt(0) === '#' || /^mailto:|^tel:/i.test(href)) return;

	    try {
	      var url = new URL(href, window.location.href);
	      if (!isPracticeCampaignTargetUrl(url)) return;
	      appendPracticeCampaignParamsToUrl(url, params);
	      link.setAttribute('href', url.pathname + url.search + url.hash);
	    } catch (error) {
	      // no-op
	    }
	  }

	  function bindPracticeCampaignParamPropagation() {
	    if (!isPracticeB2BMeasurementContext()) return;
	    if (document.documentElement.dataset.practiceCampaignParamsBound === 'true') return;
	    var params = collectPracticeCampaignParams();
	    if (!params.length) return;

	    document.documentElement.dataset.practiceCampaignParamsBound = 'true';
	    document.querySelectorAll('a[href]').forEach(function (link) {
	      applyPracticeCampaignParamsToLink(link, params);
	    });
	    document.addEventListener('click', function (event) {
	      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
	      applyPracticeCampaignParamsToLink(link, params);
	    }, true);
	  }

	  function trackPracticeB2BPageView() {
	    if (!isPracticeB2BPage()) return;
	    pushPracticeB2BTrackingEventOnce(
	      'view_practice_page',
	      { practice_event_trigger: 'page_view' },
	      'view_practice_page'
	    );
	  }

	  function getPracticeQuoteFieldValue(form, names) {
	    if (!form) return '';
	    for (var index = 0; index < names.length; index += 1) {
	      var field = form.querySelector('[name="' + names[index] + '"]');
	      if (field && field.value) return field.value;
	    }
	    return '';
	  }

	  function bindPracticeQuoteSubmitTracking() {
	    if (document.documentElement.dataset.practiceQuoteSubmitTrackingBound === 'true') return;
	    document.documentElement.dataset.practiceQuoteSubmitTrackingBound = 'true';

	    document.addEventListener('submit', function (event) {
	      var form = event.target;
	      if (!form || !form.matches) return;
	      if (!form.matches('form.nb-page-form--practice-quote, form.practice-b2b-staffel__form')) return;

	      var segment = normalizeSegment(getPracticeQuoteFieldValue(form, ['contact[segment]', 'contact[Segment]', 'contact[segment_key]']).toLowerCase());
	      if (segment && segment !== 'practice') return;

	      var config = getPracticePricingConfig();
	      var packages = config && Array.isArray(config.packages) ? config.packages : [];
	      var plan = getPracticeQuoteFieldValue(form, ['contact[plan]', 'contact[Plan]', 'contact[pakket]']);
	      if (!plan) {
	        try {
	          plan = new URLSearchParams(window.location.search || '').get('plan') || '';
	        } catch (error) {
	          plan = '';
	        }
	      }
	      var packageConfig = findPracticeB2BPackageByPlanOrQuantity(packages, plan || '20plus', 20);
	      var calculation = calculatePracticeB2BPackage(config, packageConfig, false);
	      var payload = Object.assign(
	        {
	          business_cta_location: form.classList.contains('practice-b2b-staffel__form') ? 'practice-staffel-form' : 'practice-quote-page',
	          practice_event_trigger: 'form_submit',
	          quote_flow: 'practice_quote'
	        },
	        buildPracticeB2BPackageTrackingPayload(packageConfig, calculation)
	      );
	      pushPracticeB2BTrackingEvent('submit_practice_quote', payload);
	    }, true);
	  }

	  function bindPracticeB2BFlowTracking() {
	    if (!isPracticeB2BPage()) return;
	    if (document.documentElement.dataset.practiceB2BFlowTrackingBound === 'true') return;
	    document.documentElement.dataset.practiceB2BFlowTrackingBound = 'true';

	    var config = getPracticePricingConfig();
	    var packages = config && Array.isArray(config.packages) ? config.packages : [];

	    document.addEventListener('click', function (event) {
	      var target = event.target;
	      var link = target && target.closest ? target.closest('a,button') : null;
	      if (!link) return;
	      if (link.getAttribute('aria-disabled') === 'true') return;
	      if (link.getAttribute('data-business-link-disabled') === 'true') return;

	      var ctaId = link.getAttribute('data-nb-cta') || '';
	      var location = link.getAttribute('data-business-cta-location') || '';
	      var intent = link.getAttribute('data-business-cta-intent') || '';
	      var planKey = link.getAttribute('data-business-plan-key') || '';
	      var card = link.closest ? link.closest('[data-business-plan-card][data-business-audience="practices"]') : null;
	      if (!planKey && card) planKey = card.getAttribute('data-plan-key') || '';

	      if (isPracticeB2BEvidenceSourceLink(link)) {
	        pushPracticeB2BTrackingEvent('evidence_51_source_click', {
	          business_cta_location: 'evidence-source'
	        });
	      }

	      if (ctaId === 'business_page_hero_primary') {
	        pushPracticeB2BTrackingEvent('b2b_hero_cta_packages_click', {
	          business_cta_location: 'hero'
	        });
	      }

	      if (ctaId === 'business_page_hero_secondary') {
	        pushPracticeB2BTrackingEvent('b2b_hero_cta_trial_click', {
	          business_cta_location: 'hero'
	        });
	      }

	      if (getPracticeB2BLinkHash(link) === '#practice-b2b-staffel') {
	        var quotePackage = findPracticeB2BPackageByPlanOrQuantity(packages, planKey || '20plus', 20);
	        var quoteCalculation = calculatePracticeB2BPackage(config, quotePackage, false);
	        var quotePayload = Object.assign(
	          {
	            business_cta_location: location || 'staffel-link',
	            practice_event_trigger: 'staffel_click'
	          },
	          buildPracticeB2BPackageTrackingPayload(quotePackage, quoteCalculation)
	        );
	        pushPracticeB2BTrackingEvent('click_practice_staffel_20_plus', quotePayload);
	        pushPracticeB2BTrackingEventOnce(
	          'staffel_request_started',
	          quotePayload,
	          'staffel_request_started'
	        );
	      }

	      if (location !== 'pricing-card' || intent !== 'buy') return;

	      var packageConfig = findPracticeB2BPackageByKey(packages, planKey);
	      var calculation = calculatePracticeB2BPackage(config, packageConfig, false);
	      var quantity = Number(packageConfig && packageConfig.quantity);
	      var packageEvent = '';
	      if (quantity === 4) packageEvent = 'add_to_cart_4_pack';
	      if (quantity === 8) packageEvent = 'add_to_cart_8_pack';
	      if (quantity === 12) packageEvent = 'add_to_cart_12_pack';
	      if (!packageEvent) return;
	      var packagePayload = Object.assign(
	        {
	          business_cta_location: 'pricing-card',
	          practice_event_trigger: 'pricing_card_click'
	        },
	        buildPracticeB2BPackageTrackingPayload(packageConfig, calculation)
	      );

	      pushPracticeB2BTrackingEvent('click_practice_package_' + quantity, packagePayload);
	      pushPracticeB2BTrackingEvent('add_to_cart_practice_package', packagePayload);
	      pushPracticeB2BTrackingEvent(
	        packageEvent,
	        packagePayload
	      );
	    });
	  }

  document.addEventListener('DOMContentLoaded', function () {
    cleanPracticeB2BPlatformCopy(document);
    cleanPracticeB2BStaleLocaleCopy(document);
    cleanPracticeB2BMarginLocaleCopy(document);
    readBusinessPricingConfig();
    trackPracticeB2BPageView();
    bindPracticeCampaignParamPropagation();
    syncPlanGrids();
    syncPlanStage();
    syncReferralDiagram();
    syncCompareBadgeReveal();
    bindTabs();
    setAudience(getDefaultAudience(), { force: true });
    bindFaqTracking();
    bindDisabledLinks();
    bindBusinessAnchorScroll();
    bindBusinessCtaTracking();
    bindPracticeB2BFlowTracking();
    normalizePracticeB2BSplitHeadings(document);
    normalizePracticeB2BHomekitVideoLabels(document);
    runBusinessIdleTask(function () {
      ensurePracticeB2BMarginOverviewFallback();
      bindPracticeB2BMarginOverview();
      bindPracticeB2BPlanCards();
      bindPracticeB2BCalculator();
      normalizePracticeB2BSplitHeadings(document);
      normalizePracticeB2BHomekitVideoLabels(document);
      cleanPracticeB2BStaleLocaleCopy(document);
      cleanPracticeB2BMarginLocaleCopy(document);
    });
    initQuotePrefill();
    bindPracticeQuoteSubmitTracking();
    bindPracticeCampaignParamPropagation();
    bindPlanStage();
    bindReferralDiagram();
    bindCompareBadgeReveal();
    bindCompareWheelIntent();
    window.setTimeout(function () {
      normalizePracticeB2BSplitHeadings(document);
      normalizePracticeB2BHomekitVideoLabels(document);
      cleanPracticeB2BPlatformCopy(document);
      cleanPracticeB2BStaleLocaleCopy(document);
      cleanPracticeB2BMarginLocaleCopy(document);
    }, 500);
    [1500, 3000].forEach(function (delay) {
      window.setTimeout(function () {
        normalizePracticeB2BSplitHeadings(document);
        normalizePracticeB2BHomekitVideoLabels(document);
        cleanPracticeB2BStaleLocaleCopy(document);
        cleanPracticeB2BMarginLocaleCopy(document);
      }, delay);
    });
  });
})();
